function K(U) {
  return U && U.__esModule && Object.prototype.hasOwnProperty.call(U, "default") ? U.default : U;
}
var j = {};
(function(U) {
  var f = /* @__PURE__ */ function() {
    var t = /* @__PURE__ */ new Date(), e = 4, r = 3, s = 2, o = 1, a = e, h = {
      setLogLevel: function(d) {
        d == this.debug ? a = o : d == this.info ? a = s : d == this.warn ? a = r : (d == this.error, a = e);
      },
      debug: function(d, p) {
        console.debug === void 0 && (console.debug = console.log), o >= a && console.debug("[" + f.getDurationString(/* @__PURE__ */ new Date() - t, 1e3) + "]", "[" + d + "]", p);
      },
      log: function(d, p) {
        this.debug(d.msg);
      },
      info: function(d, p) {
        s >= a && console.info("[" + f.getDurationString(/* @__PURE__ */ new Date() - t, 1e3) + "]", "[" + d + "]", p);
      },
      warn: function(d, p) {
        r >= a && console.warn("[" + f.getDurationString(/* @__PURE__ */ new Date() - t, 1e3) + "]", "[" + d + "]", p);
      },
      error: function(d, p) {
        e >= a && console.error("[" + f.getDurationString(/* @__PURE__ */ new Date() - t, 1e3) + "]", "[" + d + "]", p);
      }
    };
    return h;
  }();
  f.getDurationString = function(t, e) {
    var r;
    function s(u, c) {
      for (var y = "" + u, x = y.split("."); x[0].length < c; )
        x[0] = "0" + x[0];
      return x.join(".");
    }
    t < 0 ? (r = !0, t = -t) : r = !1;
    var o = e || 1, a = t / o, h = Math.floor(a / 3600);
    a -= h * 3600;
    var d = Math.floor(a / 60);
    a -= d * 60;
    var p = a * 1e3;
    return a = Math.floor(a), p -= a * 1e3, p = Math.floor(p), (r ? "-" : "") + h + ":" + s(d, 2) + ":" + s(a, 2) + "." + s(p, 3);
  }, f.printRanges = function(t) {
    var e = t.length;
    if (e > 0) {
      for (var r = "", s = 0; s < e; s++)
        s > 0 && (r += ","), r += "[" + f.getDurationString(t.start(s)) + "," + f.getDurationString(t.end(s)) + "]";
      return r;
    } else
      return "(empty)";
  }, U.Log = f;
  var g = function(t) {
    if (t instanceof ArrayBuffer)
      this.buffer = t, this.dataview = new DataView(t);
    else
      throw "Needs an array buffer";
    this.position = 0;
  };
  g.prototype.getPosition = function() {
    return this.position;
  }, g.prototype.getEndPosition = function() {
    return this.buffer.byteLength;
  }, g.prototype.getLength = function() {
    return this.buffer.byteLength;
  }, g.prototype.seek = function(t) {
    var e = Math.max(0, Math.min(this.buffer.byteLength, t));
    return this.position = isNaN(e) || !isFinite(e) ? 0 : e, !0;
  }, g.prototype.isEos = function() {
    return this.getPosition() >= this.getEndPosition();
  }, g.prototype.readAnyInt = function(t, e) {
    var r = 0;
    if (this.position + t <= this.buffer.byteLength) {
      switch (t) {
        case 1:
          e ? r = this.dataview.getInt8(this.position) : r = this.dataview.getUint8(this.position);
          break;
        case 2:
          e ? r = this.dataview.getInt16(this.position) : r = this.dataview.getUint16(this.position);
          break;
        case 3:
          if (e)
            throw "No method for reading signed 24 bits values";
          r = this.dataview.getUint8(this.position) << 16, r |= this.dataview.getUint8(this.position + 1) << 8, r |= this.dataview.getUint8(this.position + 2);
          break;
        case 4:
          e ? r = this.dataview.getInt32(this.position) : r = this.dataview.getUint32(this.position);
          break;
        case 8:
          if (e)
            throw "No method for reading signed 64 bits values";
          r = this.dataview.getUint32(this.position) << 32, r |= this.dataview.getUint32(this.position + 4);
          break;
        default:
          throw "readInt method not implemented for size: " + t;
      }
      return this.position += t, r;
    } else
      throw "Not enough bytes in buffer";
  }, g.prototype.readUint8 = function() {
    return this.readAnyInt(1, !1);
  }, g.prototype.readUint16 = function() {
    return this.readAnyInt(2, !1);
  }, g.prototype.readUint24 = function() {
    return this.readAnyInt(3, !1);
  }, g.prototype.readUint32 = function() {
    return this.readAnyInt(4, !1);
  }, g.prototype.readUint64 = function() {
    return this.readAnyInt(8, !1);
  }, g.prototype.readString = function(t) {
    if (this.position + t <= this.buffer.byteLength) {
      for (var e = "", r = 0; r < t; r++)
        e += String.fromCharCode(this.readUint8());
      return e;
    } else
      throw "Not enough bytes in buffer";
  }, g.prototype.readCString = function() {
    for (var t = []; ; ) {
      var e = this.readUint8();
      if (e !== 0)
        t.push(e);
      else
        break;
    }
    return String.fromCharCode.apply(null, t);
  }, g.prototype.readInt8 = function() {
    return this.readAnyInt(1, !0);
  }, g.prototype.readInt16 = function() {
    return this.readAnyInt(2, !0);
  }, g.prototype.readInt32 = function() {
    return this.readAnyInt(4, !0);
  }, g.prototype.readInt64 = function() {
    return this.readAnyInt(8, !1);
  }, g.prototype.readUint8Array = function(t) {
    for (var e = new Uint8Array(t), r = 0; r < t; r++)
      e[r] = this.readUint8();
    return e;
  }, g.prototype.readInt16Array = function(t) {
    for (var e = new Int16Array(t), r = 0; r < t; r++)
      e[r] = this.readInt16();
    return e;
  }, g.prototype.readUint16Array = function(t) {
    for (var e = new Int16Array(t), r = 0; r < t; r++)
      e[r] = this.readUint16();
    return e;
  }, g.prototype.readUint32Array = function(t) {
    for (var e = new Uint32Array(t), r = 0; r < t; r++)
      e[r] = this.readUint32();
    return e;
  }, g.prototype.readInt32Array = function(t) {
    for (var e = new Int32Array(t), r = 0; r < t; r++)
      e[r] = this.readInt32();
    return e;
  }, U.MP4BoxStream = g;
  var l = function(t, e, r) {
    this._byteOffset = e || 0, t instanceof ArrayBuffer ? this.buffer = t : typeof t == "object" ? (this.dataView = t, e && (this._byteOffset += e)) : this.buffer = new ArrayBuffer(t || 0), this.position = 0, this.endianness = r ?? l.LITTLE_ENDIAN;
  };
  l.prototype = {}, l.prototype.getPosition = function() {
    return this.position;
  }, l.prototype._realloc = function(t) {
    if (this._dynamicSize) {
      var e = this._byteOffset + this.position + t, r = this._buffer.byteLength;
      if (e <= r) {
        e > this._byteLength && (this._byteLength = e);
        return;
      }
      for (r < 1 && (r = 1); e > r; )
        r *= 2;
      var s = new ArrayBuffer(r), o = new Uint8Array(this._buffer), a = new Uint8Array(s, 0, o.length);
      a.set(o), this.buffer = s, this._byteLength = e;
    }
  }, l.prototype._trimAlloc = function() {
    if (this._byteLength != this._buffer.byteLength) {
      var t = new ArrayBuffer(this._byteLength), e = new Uint8Array(t), r = new Uint8Array(this._buffer, 0, e.length);
      e.set(r), this.buffer = t;
    }
  }, l.BIG_ENDIAN = !1, l.LITTLE_ENDIAN = !0, l.prototype._byteLength = 0, Object.defineProperty(
    l.prototype,
    "byteLength",
    { get: function() {
      return this._byteLength - this._byteOffset;
    } }
  ), Object.defineProperty(
    l.prototype,
    "buffer",
    {
      get: function() {
        return this._trimAlloc(), this._buffer;
      },
      set: function(t) {
        this._buffer = t, this._dataView = new DataView(this._buffer, this._byteOffset), this._byteLength = this._buffer.byteLength;
      }
    }
  ), Object.defineProperty(
    l.prototype,
    "byteOffset",
    {
      get: function() {
        return this._byteOffset;
      },
      set: function(t) {
        this._byteOffset = t, this._dataView = new DataView(this._buffer, this._byteOffset), this._byteLength = this._buffer.byteLength;
      }
    }
  ), Object.defineProperty(
    l.prototype,
    "dataView",
    {
      get: function() {
        return this._dataView;
      },
      set: function(t) {
        this._byteOffset = t.byteOffset, this._buffer = t.buffer, this._dataView = new DataView(this._buffer, this._byteOffset), this._byteLength = this._byteOffset + t.byteLength;
      }
    }
  ), l.prototype.seek = function(t) {
    var e = Math.max(0, Math.min(this.byteLength, t));
    this.position = isNaN(e) || !isFinite(e) ? 0 : e;
  }, l.prototype.isEof = function() {
    return this.position >= this._byteLength;
  }, l.prototype.mapUint8Array = function(t) {
    this._realloc(t * 1);
    var e = new Uint8Array(this._buffer, this.byteOffset + this.position, t);
    return this.position += t * 1, e;
  }, l.prototype.readInt32Array = function(t, e) {
    t = t ?? this.byteLength - this.position / 4;
    var r = new Int32Array(t);
    return l.memcpy(
      r.buffer,
      0,
      this.buffer,
      this.byteOffset + this.position,
      t * r.BYTES_PER_ELEMENT
    ), l.arrayToNative(r, e ?? this.endianness), this.position += r.byteLength, r;
  }, l.prototype.readInt16Array = function(t, e) {
    t = t ?? this.byteLength - this.position / 2;
    var r = new Int16Array(t);
    return l.memcpy(
      r.buffer,
      0,
      this.buffer,
      this.byteOffset + this.position,
      t * r.BYTES_PER_ELEMENT
    ), l.arrayToNative(r, e ?? this.endianness), this.position += r.byteLength, r;
  }, l.prototype.readInt8Array = function(t) {
    t = t ?? this.byteLength - this.position;
    var e = new Int8Array(t);
    return l.memcpy(
      e.buffer,
      0,
      this.buffer,
      this.byteOffset + this.position,
      t * e.BYTES_PER_ELEMENT
    ), this.position += e.byteLength, e;
  }, l.prototype.readUint32Array = function(t, e) {
    t = t ?? this.byteLength - this.position / 4;
    var r = new Uint32Array(t);
    return l.memcpy(
      r.buffer,
      0,
      this.buffer,
      this.byteOffset + this.position,
      t * r.BYTES_PER_ELEMENT
    ), l.arrayToNative(r, e ?? this.endianness), this.position += r.byteLength, r;
  }, l.prototype.readUint16Array = function(t, e) {
    t = t ?? this.byteLength - this.position / 2;
    var r = new Uint16Array(t);
    return l.memcpy(
      r.buffer,
      0,
      this.buffer,
      this.byteOffset + this.position,
      t * r.BYTES_PER_ELEMENT
    ), l.arrayToNative(r, e ?? this.endianness), this.position += r.byteLength, r;
  }, l.prototype.readUint8Array = function(t) {
    t = t ?? this.byteLength - this.position;
    var e = new Uint8Array(t);
    return l.memcpy(
      e.buffer,
      0,
      this.buffer,
      this.byteOffset + this.position,
      t * e.BYTES_PER_ELEMENT
    ), this.position += e.byteLength, e;
  }, l.prototype.readFloat64Array = function(t, e) {
    t = t ?? this.byteLength - this.position / 8;
    var r = new Float64Array(t);
    return l.memcpy(
      r.buffer,
      0,
      this.buffer,
      this.byteOffset + this.position,
      t * r.BYTES_PER_ELEMENT
    ), l.arrayToNative(r, e ?? this.endianness), this.position += r.byteLength, r;
  }, l.prototype.readFloat32Array = function(t, e) {
    t = t ?? this.byteLength - this.position / 4;
    var r = new Float32Array(t);
    return l.memcpy(
      r.buffer,
      0,
      this.buffer,
      this.byteOffset + this.position,
      t * r.BYTES_PER_ELEMENT
    ), l.arrayToNative(r, e ?? this.endianness), this.position += r.byteLength, r;
  }, l.prototype.readInt32 = function(t) {
    var e = this._dataView.getInt32(this.position, t ?? this.endianness);
    return this.position += 4, e;
  }, l.prototype.readInt16 = function(t) {
    var e = this._dataView.getInt16(this.position, t ?? this.endianness);
    return this.position += 2, e;
  }, l.prototype.readInt8 = function() {
    var t = this._dataView.getInt8(this.position);
    return this.position += 1, t;
  }, l.prototype.readUint32 = function(t) {
    var e = this._dataView.getUint32(this.position, t ?? this.endianness);
    return this.position += 4, e;
  }, l.prototype.readUint16 = function(t) {
    var e = this._dataView.getUint16(this.position, t ?? this.endianness);
    return this.position += 2, e;
  }, l.prototype.readUint8 = function() {
    var t = this._dataView.getUint8(this.position);
    return this.position += 1, t;
  }, l.prototype.readFloat32 = function(t) {
    var e = this._dataView.getFloat32(this.position, t ?? this.endianness);
    return this.position += 4, e;
  }, l.prototype.readFloat64 = function(t) {
    var e = this._dataView.getFloat64(this.position, t ?? this.endianness);
    return this.position += 8, e;
  }, l.endianness = new Int8Array(new Int16Array([1]).buffer)[0] > 0, l.memcpy = function(t, e, r, s, o) {
    var a = new Uint8Array(t, e, o), h = new Uint8Array(r, s, o);
    a.set(h);
  }, l.arrayToNative = function(t, e) {
    return e == this.endianness ? t : this.flipArrayEndianness(t);
  }, l.nativeToEndian = function(t, e) {
    return this.endianness == e ? t : this.flipArrayEndianness(t);
  }, l.flipArrayEndianness = function(t) {
    for (var e = new Uint8Array(t.buffer, t.byteOffset, t.byteLength), r = 0; r < t.byteLength; r += t.BYTES_PER_ELEMENT)
      for (var s = r + t.BYTES_PER_ELEMENT - 1, o = r; s > o; s--, o++) {
        var a = e[o];
        e[o] = e[s], e[s] = a;
      }
    return t;
  }, l.prototype.failurePosition = 0, String.fromCharCodeUint8 = function(t) {
    for (var e = [], r = 0; r < t.length; r++)
      e[r] = t[r];
    return String.fromCharCode.apply(null, e);
  }, l.prototype.readString = function(t, e) {
    return e == null || e == "ASCII" ? String.fromCharCodeUint8.apply(null, [this.mapUint8Array(t ?? this.byteLength - this.position)]) : new TextDecoder(e).decode(this.mapUint8Array(t));
  }, l.prototype.readCString = function(t) {
    var e = this.byteLength - this.position, r = new Uint8Array(this._buffer, this._byteOffset + this.position), s = e;
    t != null && (s = Math.min(t, e));
    for (var o = 0; o < s && r[o] !== 0; o++) ;
    var a = String.fromCharCodeUint8.apply(null, [this.mapUint8Array(o)]);
    return t != null ? this.position += s - o : o != e && (this.position += 1), a;
  };
  var B = Math.pow(2, 32);
  l.prototype.readInt64 = function() {
    return this.readInt32() * B + this.readUint32();
  }, l.prototype.readUint64 = function() {
    return this.readUint32() * B + this.readUint32();
  }, l.prototype.readInt64 = function() {
    return this.readUint32() * B + this.readUint32();
  }, l.prototype.readUint24 = function() {
    return (this.readUint8() << 16) + (this.readUint8() << 8) + this.readUint8();
  }, U.DataStream = l, l.prototype.save = function(t) {
    var e = new Blob([this.buffer]);
    if (window.URL && URL.createObjectURL) {
      var r = window.URL.createObjectURL(e), s = document.createElement("a");
      document.body.appendChild(s), s.setAttribute("href", r), s.setAttribute("download", t), s.setAttribute("target", "_self"), s.click(), window.URL.revokeObjectURL(r);
    } else
      throw "DataStream.save: Can't create object URL.";
  }, l.prototype._dynamicSize = !0, Object.defineProperty(
    l.prototype,
    "dynamicSize",
    {
      get: function() {
        return this._dynamicSize;
      },
      set: function(t) {
        t || this._trimAlloc(), this._dynamicSize = t;
      }
    }
  ), l.prototype.shift = function(t) {
    var e = new ArrayBuffer(this._byteLength - t), r = new Uint8Array(e), s = new Uint8Array(this._buffer, t, r.length);
    r.set(s), this.buffer = e, this.position -= t;
  }, l.prototype.writeInt32Array = function(t, e) {
    if (this._realloc(t.length * 4), t instanceof Int32Array && this.byteOffset + this.position % t.BYTES_PER_ELEMENT === 0)
      l.memcpy(
        this._buffer,
        this.byteOffset + this.position,
        t.buffer,
        0,
        t.byteLength
      ), this.mapInt32Array(t.length, e);
    else
      for (var r = 0; r < t.length; r++)
        this.writeInt32(t[r], e);
  }, l.prototype.writeInt16Array = function(t, e) {
    if (this._realloc(t.length * 2), t instanceof Int16Array && this.byteOffset + this.position % t.BYTES_PER_ELEMENT === 0)
      l.memcpy(
        this._buffer,
        this.byteOffset + this.position,
        t.buffer,
        0,
        t.byteLength
      ), this.mapInt16Array(t.length, e);
    else
      for (var r = 0; r < t.length; r++)
        this.writeInt16(t[r], e);
  }, l.prototype.writeInt8Array = function(t) {
    if (this._realloc(t.length * 1), t instanceof Int8Array && this.byteOffset + this.position % t.BYTES_PER_ELEMENT === 0)
      l.memcpy(
        this._buffer,
        this.byteOffset + this.position,
        t.buffer,
        0,
        t.byteLength
      ), this.mapInt8Array(t.length);
    else
      for (var e = 0; e < t.length; e++)
        this.writeInt8(t[e]);
  }, l.prototype.writeUint32Array = function(t, e) {
    if (this._realloc(t.length * 4), t instanceof Uint32Array && this.byteOffset + this.position % t.BYTES_PER_ELEMENT === 0)
      l.memcpy(
        this._buffer,
        this.byteOffset + this.position,
        t.buffer,
        0,
        t.byteLength
      ), this.mapUint32Array(t.length, e);
    else
      for (var r = 0; r < t.length; r++)
        this.writeUint32(t[r], e);
  }, l.prototype.writeUint16Array = function(t, e) {
    if (this._realloc(t.length * 2), t instanceof Uint16Array && this.byteOffset + this.position % t.BYTES_PER_ELEMENT === 0)
      l.memcpy(
        this._buffer,
        this.byteOffset + this.position,
        t.buffer,
        0,
        t.byteLength
      ), this.mapUint16Array(t.length, e);
    else
      for (var r = 0; r < t.length; r++)
        this.writeUint16(t[r], e);
  }, l.prototype.writeUint8Array = function(t) {
    if (this._realloc(t.length * 1), t instanceof Uint8Array && this.byteOffset + this.position % t.BYTES_PER_ELEMENT === 0)
      l.memcpy(
        this._buffer,
        this.byteOffset + this.position,
        t.buffer,
        0,
        t.byteLength
      ), this.mapUint8Array(t.length);
    else
      for (var e = 0; e < t.length; e++)
        this.writeUint8(t[e]);
  }, l.prototype.writeFloat64Array = function(t, e) {
    if (this._realloc(t.length * 8), t instanceof Float64Array && this.byteOffset + this.position % t.BYTES_PER_ELEMENT === 0)
      l.memcpy(
        this._buffer,
        this.byteOffset + this.position,
        t.buffer,
        0,
        t.byteLength
      ), this.mapFloat64Array(t.length, e);
    else
      for (var r = 0; r < t.length; r++)
        this.writeFloat64(t[r], e);
  }, l.prototype.writeFloat32Array = function(t, e) {
    if (this._realloc(t.length * 4), t instanceof Float32Array && this.byteOffset + this.position % t.BYTES_PER_ELEMENT === 0)
      l.memcpy(
        this._buffer,
        this.byteOffset + this.position,
        t.buffer,
        0,
        t.byteLength
      ), this.mapFloat32Array(t.length, e);
    else
      for (var r = 0; r < t.length; r++)
        this.writeFloat32(t[r], e);
  }, l.prototype.writeInt32 = function(t, e) {
    this._realloc(4), this._dataView.setInt32(this.position, t, e ?? this.endianness), this.position += 4;
  }, l.prototype.writeInt16 = function(t, e) {
    this._realloc(2), this._dataView.setInt16(this.position, t, e ?? this.endianness), this.position += 2;
  }, l.prototype.writeInt8 = function(t) {
    this._realloc(1), this._dataView.setInt8(this.position, t), this.position += 1;
  }, l.prototype.writeUint32 = function(t, e) {
    this._realloc(4), this._dataView.setUint32(this.position, t, e ?? this.endianness), this.position += 4;
  }, l.prototype.writeUint16 = function(t, e) {
    this._realloc(2), this._dataView.setUint16(this.position, t, e ?? this.endianness), this.position += 2;
  }, l.prototype.writeUint8 = function(t) {
    this._realloc(1), this._dataView.setUint8(this.position, t), this.position += 1;
  }, l.prototype.writeFloat32 = function(t, e) {
    this._realloc(4), this._dataView.setFloat32(this.position, t, e ?? this.endianness), this.position += 4;
  }, l.prototype.writeFloat64 = function(t, e) {
    this._realloc(8), this._dataView.setFloat64(this.position, t, e ?? this.endianness), this.position += 8;
  }, l.prototype.writeUCS2String = function(t, e, r) {
    r == null && (r = t.length);
    for (var s = 0; s < t.length && s < r; s++)
      this.writeUint16(t.charCodeAt(s), e);
    for (; s < r; s++)
      this.writeUint16(0);
  }, l.prototype.writeString = function(t, e, r) {
    var s = 0;
    if (e == null || e == "ASCII")
      if (r != null) {
        var o = Math.min(t.length, r);
        for (s = 0; s < o; s++)
          this.writeUint8(t.charCodeAt(s));
        for (; s < r; s++)
          this.writeUint8(0);
      } else
        for (s = 0; s < t.length; s++)
          this.writeUint8(t.charCodeAt(s));
    else
      this.writeUint8Array(new TextEncoder(e).encode(t.substring(0, r)));
  }, l.prototype.writeCString = function(t, e) {
    var r = 0;
    if (e != null) {
      var s = Math.min(t.length, e);
      for (r = 0; r < s; r++)
        this.writeUint8(t.charCodeAt(r));
      for (; r < e; r++)
        this.writeUint8(0);
    } else {
      for (r = 0; r < t.length; r++)
        this.writeUint8(t.charCodeAt(r));
      this.writeUint8(0);
    }
  }, l.prototype.writeStruct = function(t, e) {
    for (var r = 0; r < t.length; r += 2) {
      var s = t[r + 1];
      this.writeType(s, e[t[r]], e);
    }
  }, l.prototype.writeType = function(t, e, r) {
    var s;
    if (typeof t == "function")
      return t(this, e);
    if (typeof t == "object" && !(t instanceof Array))
      return t.set(this, e, r);
    var o = null, a = "ASCII", h = this.position;
    switch (typeof t == "string" && /:/.test(t) && (s = t.split(":"), t = s[0], o = parseInt(s[1])), typeof t == "string" && /,/.test(t) && (s = t.split(","), t = s[0], a = parseInt(s[1])), t) {
      case "uint8":
        this.writeUint8(e);
        break;
      case "int8":
        this.writeInt8(e);
        break;
      case "uint16":
        this.writeUint16(e, this.endianness);
        break;
      case "int16":
        this.writeInt16(e, this.endianness);
        break;
      case "uint32":
        this.writeUint32(e, this.endianness);
        break;
      case "int32":
        this.writeInt32(e, this.endianness);
        break;
      case "float32":
        this.writeFloat32(e, this.endianness);
        break;
      case "float64":
        this.writeFloat64(e, this.endianness);
        break;
      case "uint16be":
        this.writeUint16(e, l.BIG_ENDIAN);
        break;
      case "int16be":
        this.writeInt16(e, l.BIG_ENDIAN);
        break;
      case "uint32be":
        this.writeUint32(e, l.BIG_ENDIAN);
        break;
      case "int32be":
        this.writeInt32(e, l.BIG_ENDIAN);
        break;
      case "float32be":
        this.writeFloat32(e, l.BIG_ENDIAN);
        break;
      case "float64be":
        this.writeFloat64(e, l.BIG_ENDIAN);
        break;
      case "uint16le":
        this.writeUint16(e, l.LITTLE_ENDIAN);
        break;
      case "int16le":
        this.writeInt16(e, l.LITTLE_ENDIAN);
        break;
      case "uint32le":
        this.writeUint32(e, l.LITTLE_ENDIAN);
        break;
      case "int32le":
        this.writeInt32(e, l.LITTLE_ENDIAN);
        break;
      case "float32le":
        this.writeFloat32(e, l.LITTLE_ENDIAN);
        break;
      case "float64le":
        this.writeFloat64(e, l.LITTLE_ENDIAN);
        break;
      case "cstring":
        this.writeCString(e, o);
        break;
      case "string":
        this.writeString(e, a, o);
        break;
      case "u16string":
        this.writeUCS2String(e, this.endianness, o);
        break;
      case "u16stringle":
        this.writeUCS2String(e, l.LITTLE_ENDIAN, o);
        break;
      case "u16stringbe":
        this.writeUCS2String(e, l.BIG_ENDIAN, o);
        break;
      default:
        if (t.length == 3) {
          for (var d = t[1], p = 0; p < e.length; p++)
            this.writeType(d, e[p]);
          break;
        } else {
          this.writeStruct(t, e);
          break;
        }
    }
    o != null && (this.position = h, this._realloc(o), this.position = h + o);
  }, l.prototype.writeUint64 = function(t) {
    var e = Math.floor(t / B);
    this.writeUint32(e), this.writeUint32(t & 4294967295);
  }, l.prototype.writeUint24 = function(t) {
    this.writeUint8((t & 16711680) >> 16), this.writeUint8((t & 65280) >> 8), this.writeUint8(t & 255);
  }, l.prototype.adjustUint32 = function(t, e) {
    var r = this.position;
    this.seek(t), this.writeUint32(e), this.seek(r);
  }, l.prototype.mapInt32Array = function(t, e) {
    this._realloc(t * 4);
    var r = new Int32Array(this._buffer, this.byteOffset + this.position, t);
    return l.arrayToNative(r, e ?? this.endianness), this.position += t * 4, r;
  }, l.prototype.mapInt16Array = function(t, e) {
    this._realloc(t * 2);
    var r = new Int16Array(this._buffer, this.byteOffset + this.position, t);
    return l.arrayToNative(r, e ?? this.endianness), this.position += t * 2, r;
  }, l.prototype.mapInt8Array = function(t) {
    this._realloc(t * 1);
    var e = new Int8Array(this._buffer, this.byteOffset + this.position, t);
    return this.position += t * 1, e;
  }, l.prototype.mapUint32Array = function(t, e) {
    this._realloc(t * 4);
    var r = new Uint32Array(this._buffer, this.byteOffset + this.position, t);
    return l.arrayToNative(r, e ?? this.endianness), this.position += t * 4, r;
  }, l.prototype.mapUint16Array = function(t, e) {
    this._realloc(t * 2);
    var r = new Uint16Array(this._buffer, this.byteOffset + this.position, t);
    return l.arrayToNative(r, e ?? this.endianness), this.position += t * 2, r;
  }, l.prototype.mapFloat64Array = function(t, e) {
    this._realloc(t * 8);
    var r = new Float64Array(this._buffer, this.byteOffset + this.position, t);
    return l.arrayToNative(r, e ?? this.endianness), this.position += t * 8, r;
  }, l.prototype.mapFloat32Array = function(t, e) {
    this._realloc(t * 4);
    var r = new Float32Array(this._buffer, this.byteOffset + this.position, t);
    return l.arrayToNative(r, e ?? this.endianness), this.position += t * 4, r;
  };
  var S = function(t) {
    this.buffers = [], this.bufferIndex = -1, t && (this.insertBuffer(t), this.bufferIndex = 0);
  };
  S.prototype = new l(new ArrayBuffer(), 0, l.BIG_ENDIAN), S.prototype.initialized = function() {
    var t;
    return this.bufferIndex > -1 ? !0 : this.buffers.length > 0 ? (t = this.buffers[0], t.fileStart === 0 ? (this.buffer = t, this.bufferIndex = 0, f.debug("MultiBufferStream", "Stream ready for parsing"), !0) : (f.warn("MultiBufferStream", "The first buffer should have a fileStart of 0"), this.logBufferLevel(), !1)) : (f.warn("MultiBufferStream", "No buffer to start parsing from"), this.logBufferLevel(), !1);
  }, ArrayBuffer.concat = function(t, e) {
    f.debug("ArrayBuffer", "Trying to create a new buffer of size: " + (t.byteLength + e.byteLength));
    var r = new Uint8Array(t.byteLength + e.byteLength);
    return r.set(new Uint8Array(t), 0), r.set(new Uint8Array(e), t.byteLength), r.buffer;
  }, S.prototype.reduceBuffer = function(t, e, r) {
    var s;
    return s = new Uint8Array(r), s.set(new Uint8Array(t, e, r)), s.buffer.fileStart = t.fileStart + e, s.buffer.usedBytes = 0, s.buffer;
  }, S.prototype.insertBuffer = function(t) {
    for (var e = !0, r = 0; r < this.buffers.length; r++) {
      var s = this.buffers[r];
      if (t.fileStart <= s.fileStart) {
        if (t.fileStart === s.fileStart)
          if (t.byteLength > s.byteLength) {
            this.buffers.splice(r, 1), r--;
            continue;
          } else
            f.warn("MultiBufferStream", "Buffer (fileStart: " + t.fileStart + " - Length: " + t.byteLength + ") already appended, ignoring");
        else
          t.fileStart + t.byteLength <= s.fileStart || (t = this.reduceBuffer(t, 0, s.fileStart - t.fileStart)), f.debug("MultiBufferStream", "Appending new buffer (fileStart: " + t.fileStart + " - Length: " + t.byteLength + ")"), this.buffers.splice(r, 0, t), r === 0 && (this.buffer = t);
        e = !1;
        break;
      } else if (t.fileStart < s.fileStart + s.byteLength) {
        var o = s.fileStart + s.byteLength - t.fileStart, a = t.byteLength - o;
        if (a > 0)
          t = this.reduceBuffer(t, o, a);
        else {
          e = !1;
          break;
        }
      }
    }
    e && (f.debug("MultiBufferStream", "Appending new buffer (fileStart: " + t.fileStart + " - Length: " + t.byteLength + ")"), this.buffers.push(t), r === 0 && (this.buffer = t));
  }, S.prototype.logBufferLevel = function(t) {
    var e, r, s, o, a = [], h, d = "";
    for (s = 0, o = 0, e = 0; e < this.buffers.length; e++)
      r = this.buffers[e], e === 0 ? (h = {}, a.push(h), h.start = r.fileStart, h.end = r.fileStart + r.byteLength, d += "[" + h.start + "-") : h.end === r.fileStart ? h.end = r.fileStart + r.byteLength : (h = {}, h.start = r.fileStart, d += a[a.length - 1].end - 1 + "], [" + h.start + "-", h.end = r.fileStart + r.byteLength, a.push(h)), s += r.usedBytes, o += r.byteLength;
    a.length > 0 && (d += h.end - 1 + "]");
    var p = t ? f.info : f.debug;
    this.buffers.length === 0 ? p("MultiBufferStream", "No more buffer in memory") : p("MultiBufferStream", "" + this.buffers.length + " stored buffer(s) (" + s + "/" + o + " bytes), continuous ranges: " + d);
  }, S.prototype.cleanBuffers = function() {
    var t, e;
    for (t = 0; t < this.buffers.length; t++)
      e = this.buffers[t], e.usedBytes === e.byteLength && (f.debug("MultiBufferStream", "Removing buffer #" + t), this.buffers.splice(t, 1), t--);
  }, S.prototype.mergeNextBuffer = function() {
    var t;
    if (this.bufferIndex + 1 < this.buffers.length)
      if (t = this.buffers[this.bufferIndex + 1], t.fileStart === this.buffer.fileStart + this.buffer.byteLength) {
        var e = this.buffer.byteLength, r = this.buffer.usedBytes, s = this.buffer.fileStart;
        return this.buffers[this.bufferIndex] = ArrayBuffer.concat(this.buffer, t), this.buffer = this.buffers[this.bufferIndex], this.buffers.splice(this.bufferIndex + 1, 1), this.buffer.usedBytes = r, this.buffer.fileStart = s, f.debug("ISOFile", "Concatenating buffer for box parsing (length: " + e + "->" + this.buffer.byteLength + ")"), !0;
      } else
        return !1;
    else
      return !1;
  }, S.prototype.findPosition = function(t, e, r) {
    var s, o = null, a = -1;
    for (t === !0 ? s = 0 : s = this.bufferIndex; s < this.buffers.length && (o = this.buffers[s], o.fileStart <= e); ) {
      a = s, r && (o.fileStart + o.byteLength <= e ? o.usedBytes = o.byteLength : o.usedBytes = e - o.fileStart, this.logBufferLevel());
      s++;
    }
    return a !== -1 ? (o = this.buffers[a], o.fileStart + o.byteLength >= e ? (f.debug("MultiBufferStream", "Found position in existing buffer #" + a), a) : -1) : -1;
  }, S.prototype.findEndContiguousBuf = function(t) {
    var e, r, s, o = t !== void 0 ? t : this.bufferIndex;
    if (r = this.buffers[o], this.buffers.length > o + 1)
      for (e = o + 1; e < this.buffers.length && (s = this.buffers[e], s.fileStart === r.fileStart + r.byteLength); e++)
        r = s;
    return r.fileStart + r.byteLength;
  }, S.prototype.getEndFilePositionAfter = function(t) {
    var e = this.findPosition(!0, t, !1);
    return e !== -1 ? this.findEndContiguousBuf(e) : t;
  }, S.prototype.addUsedBytes = function(t) {
    this.buffer.usedBytes += t, this.logBufferLevel();
  }, S.prototype.setAllUsedBytes = function() {
    this.buffer.usedBytes = this.buffer.byteLength, this.logBufferLevel();
  }, S.prototype.seek = function(t, e, r) {
    var s;
    return s = this.findPosition(e, t, r), s !== -1 ? (this.buffer = this.buffers[s], this.bufferIndex = s, this.position = t - this.buffer.fileStart, f.debug("MultiBufferStream", "Repositioning parser at buffer position: " + this.position), !0) : (f.debug("MultiBufferStream", "Position " + t + " not found in buffered data"), !1);
  }, S.prototype.getPosition = function() {
    if (this.bufferIndex === -1 || this.buffers[this.bufferIndex] === null)
      throw "Error accessing position in the MultiBufferStream";
    return this.buffers[this.bufferIndex].fileStart + this.position;
  }, S.prototype.getLength = function() {
    return this.byteLength;
  }, S.prototype.getEndPosition = function() {
    if (this.bufferIndex === -1 || this.buffers[this.bufferIndex] === null)
      throw "Error accessing position in the MultiBufferStream";
    return this.buffers[this.bufferIndex].fileStart + this.byteLength;
  }, U.MultiBufferStream = S;
  var E = function() {
    var t = 3, e = 4, r = 5, s = 6, o = [];
    o[t] = "ES_Descriptor", o[e] = "DecoderConfigDescriptor", o[r] = "DecoderSpecificInfo", o[s] = "SLConfigDescriptor", this.getDescriptorName = function(d) {
      return o[d];
    };
    var a = this, h = {};
    return this.parseOneDescriptor = function(d) {
      var p = 0, u, c, y;
      for (u = d.readUint8(), y = d.readUint8(); y & 128; )
        p = (p << 7) + (y & 127), y = d.readUint8();
      return p = (p << 7) + (y & 127), f.debug("MPEG4DescriptorParser", "Found " + (o[u] || "Descriptor " + u) + ", size " + p + " at position " + d.getPosition()), o[u] ? c = new h[o[u]](p) : c = new h.Descriptor(p), c.parse(d), c;
    }, h.Descriptor = function(d, p) {
      this.tag = d, this.size = p, this.descs = [];
    }, h.Descriptor.prototype.parse = function(d) {
      this.data = d.readUint8Array(this.size);
    }, h.Descriptor.prototype.findDescriptor = function(d) {
      for (var p = 0; p < this.descs.length; p++)
        if (this.descs[p].tag == d)
          return this.descs[p];
      return null;
    }, h.Descriptor.prototype.parseRemainingDescriptors = function(d) {
      for (var p = d.position; d.position < p + this.size; ) {
        var u = a.parseOneDescriptor(d);
        this.descs.push(u);
      }
    }, h.ES_Descriptor = function(d) {
      h.Descriptor.call(this, t, d);
    }, h.ES_Descriptor.prototype = new h.Descriptor(), h.ES_Descriptor.prototype.parse = function(d) {
      if (this.ES_ID = d.readUint16(), this.flags = d.readUint8(), this.size -= 3, this.flags & 128 ? (this.dependsOn_ES_ID = d.readUint16(), this.size -= 2) : this.dependsOn_ES_ID = 0, this.flags & 64) {
        var p = d.readUint8();
        this.URL = d.readString(p), this.size -= p + 1;
      } else
        this.URL = "";
      this.flags & 32 ? (this.OCR_ES_ID = d.readUint16(), this.size -= 2) : this.OCR_ES_ID = 0, this.parseRemainingDescriptors(d);
    }, h.ES_Descriptor.prototype.getOTI = function(d) {
      var p = this.findDescriptor(e);
      return p ? p.oti : 0;
    }, h.ES_Descriptor.prototype.getAudioConfig = function(d) {
      var p = this.findDescriptor(e);
      if (!p) return null;
      var u = p.findDescriptor(r);
      if (u && u.data) {
        var c = (u.data[0] & 248) >> 3;
        return c === 31 && u.data.length >= 2 && (c = 32 + ((u.data[0] & 7) << 3) + ((u.data[1] & 224) >> 5)), c;
      } else
        return null;
    }, h.DecoderConfigDescriptor = function(d) {
      h.Descriptor.call(this, e, d);
    }, h.DecoderConfigDescriptor.prototype = new h.Descriptor(), h.DecoderConfigDescriptor.prototype.parse = function(d) {
      this.oti = d.readUint8(), this.streamType = d.readUint8(), this.upStream = (this.streamType >> 1 & 1) !== 0, this.streamType = this.streamType >>> 2, this.bufferSize = d.readUint24(), this.maxBitrate = d.readUint32(), this.avgBitrate = d.readUint32(), this.size -= 13, this.parseRemainingDescriptors(d);
    }, h.DecoderSpecificInfo = function(d) {
      h.Descriptor.call(this, r, d);
    }, h.DecoderSpecificInfo.prototype = new h.Descriptor(), h.SLConfigDescriptor = function(d) {
      h.Descriptor.call(this, s, d);
    }, h.SLConfigDescriptor.prototype = new h.Descriptor(), this;
  };
  U.MPEG4DescriptorParser = E;
  var n = {
    ERR_INVALID_DATA: -1,
    ERR_NOT_ENOUGH_DATA: 0,
    OK: 1,
    // Boxes to be created with default parsing
    BASIC_BOXES: [
      { type: "mdat", name: "MediaDataBox" },
      { type: "idat", name: "ItemDataBox" },
      { type: "free", name: "FreeSpaceBox" },
      { type: "skip", name: "FreeSpaceBox" },
      { type: "meco", name: "AdditionalMetadataContainerBox" },
      { type: "strk", name: "SubTrackBox" }
    ],
    FULL_BOXES: [
      { type: "hmhd", name: "HintMediaHeaderBox" },
      { type: "nmhd", name: "NullMediaHeaderBox" },
      { type: "iods", name: "ObjectDescriptorBox" },
      { type: "xml ", name: "XMLBox" },
      { type: "bxml", name: "BinaryXMLBox" },
      { type: "ipro", name: "ItemProtectionBox" },
      { type: "mere", name: "MetaboxRelationBox" }
    ],
    CONTAINER_BOXES: [
      [{ type: "moov", name: "CompressedMovieBox" }, ["trak", "pssh"]],
      [{ type: "trak", name: "TrackBox" }],
      [{ type: "edts", name: "EditBox" }],
      [{ type: "mdia", name: "MediaBox" }],
      [{ type: "minf", name: "MediaInformationBox" }],
      [{ type: "dinf", name: "DataInformationBox" }],
      [{ type: "stbl", name: "SampleTableBox" }, ["sgpd", "sbgp"]],
      [{ type: "mvex", name: "MovieExtendsBox" }, ["trex"]],
      [{ type: "moof", name: "CompressedMovieFragmentBox" }, ["traf"]],
      [{ type: "traf", name: "TrackFragmentBox" }, ["trun", "sgpd", "sbgp"]],
      [{ type: "vttc", name: "VTTCueBox" }],
      [{ type: "tref", name: "TrackReferenceBox" }],
      [{ type: "iref", name: "ItemReferenceBox" }],
      [{ type: "mfra", name: "MovieFragmentRandomAccessBox" }, ["tfra"]],
      [{ type: "meco", name: "AdditionalMetadataContainerBox" }],
      [{ type: "hnti", name: "trackhintinformation" }],
      [{ type: "hinf", name: "hintstatisticsbox" }],
      [{ type: "strk", name: "SubTrackBox" }],
      [{ type: "strd", name: "SubTrackDefinitionBox" }],
      [{ type: "sinf", name: "ProtectionSchemeInfoBox" }],
      [{ type: "rinf", name: "RestrictedSchemeInfoBox" }],
      [{ type: "schi", name: "SchemeInformationBox" }],
      [{ type: "trgr", name: "TrackGroupBox" }],
      [{ type: "udta", name: "UserDataBox" }, ["kind"]],
      [{ type: "iprp", name: "ItemPropertiesBox" }, ["ipma"]],
      [{ type: "ipco", name: "ItemPropertyContainerBox" }],
      [{ type: "grpl", name: "GroupsListBox" }],
      [{ type: "j2kH", name: "J2KHeaderInfoBox" }],
      [{ type: "etyp", name: "ExtendedTypeBox" }, ["tyco"]]
    ],
    // Boxes effectively created
    boxCodes: [],
    fullBoxCodes: [],
    containerBoxCodes: [],
    sampleEntryCodes: {},
    sampleGroupEntryCodes: [],
    trackGroupTypes: [],
    UUIDBoxes: {},
    UUIDs: [],
    initialize: function() {
      n.FullBox.prototype = new n.Box(), n.ContainerBox.prototype = new n.Box(), n.SampleEntry.prototype = new n.Box(), n.TrackGroupTypeBox.prototype = new n.FullBox(), n.BASIC_BOXES.forEach(function(t) {
        n.createBoxCtor(t.type, t.name);
      }), n.FULL_BOXES.forEach(function(t) {
        n.createFullBoxCtor(t.type, t.name);
      }), n.CONTAINER_BOXES.forEach(function(t) {
        n.createContainerBoxCtor(t[0].type, t[0].name, null, t[1]);
      });
    },
    Box: function(t, e, r, s) {
      this.type = t, this.box_name = r, this.size = e, this.uuid = s;
    },
    FullBox: function(t, e, r, s) {
      n.Box.call(this, t, e, r, s), this.flags = 0, this.version = 0;
    },
    ContainerBox: function(t, e, r, s) {
      n.Box.call(this, t, e, r, s), this.boxes = [];
    },
    SampleEntry: function(t, e, r, s) {
      n.ContainerBox.call(this, t, e), this.hdr_size = r, this.start = s;
    },
    SampleGroupEntry: function(t) {
      this.grouping_type = t;
    },
    TrackGroupTypeBox: function(t, e) {
      n.FullBox.call(this, t, e);
    },
    createBoxCtor: function(t, e, r) {
      n.boxCodes.push(t), n[t + "Box"] = function(s) {
        n.Box.call(this, t, s, e);
      }, n[t + "Box"].prototype = new n.Box(), r && (n[t + "Box"].prototype.parse = r);
    },
    createFullBoxCtor: function(t, e, r) {
      n[t + "Box"] = function(s) {
        n.FullBox.call(this, t, s, e);
      }, n[t + "Box"].prototype = new n.FullBox(), n[t + "Box"].prototype.parse = function(s) {
        this.parseFullHeader(s), r && r.call(this, s);
      };
    },
    addSubBoxArrays: function(t) {
      if (t) {
        this.subBoxNames = t;
        for (var e = t.length, r = 0; r < e; r++)
          this[t[r] + "s"] = [];
      }
    },
    createContainerBoxCtor: function(t, e, r, s) {
      n[t + "Box"] = function(o) {
        n.ContainerBox.call(this, t, o, e), n.addSubBoxArrays.call(this, s);
      }, n[t + "Box"].prototype = new n.ContainerBox(), r && (n[t + "Box"].prototype.parse = r);
    },
    createMediaSampleEntryCtor: function(t, e, r) {
      n.sampleEntryCodes[t] = [], n[t + "SampleEntry"] = function(s, o) {
        n.SampleEntry.call(this, s, o), n.addSubBoxArrays.call(this, r);
      }, n[t + "SampleEntry"].prototype = new n.SampleEntry(), e && (n[t + "SampleEntry"].prototype.parse = e);
    },
    createSampleEntryCtor: function(t, e, r, s) {
      n.sampleEntryCodes[t].push(e), n[e + "SampleEntry"] = function(o) {
        n[t + "SampleEntry"].call(this, e, o), n.addSubBoxArrays.call(this, s);
      }, n[e + "SampleEntry"].prototype = new n[t + "SampleEntry"](), r && (n[e + "SampleEntry"].prototype.parse = r);
    },
    createEncryptedSampleEntryCtor: function(t, e, r) {
      n.createSampleEntryCtor.call(this, t, e, r, ["sinf"]);
    },
    createSampleGroupCtor: function(t, e) {
      n[t + "SampleGroupEntry"] = function(r) {
        n.SampleGroupEntry.call(this, t, r);
      }, n[t + "SampleGroupEntry"].prototype = new n.SampleGroupEntry(), e && (n[t + "SampleGroupEntry"].prototype.parse = e);
    },
    createTrackGroupCtor: function(t, e) {
      n[t + "TrackGroupTypeBox"] = function(r) {
        n.TrackGroupTypeBox.call(this, t, r);
      }, n[t + "TrackGroupTypeBox"].prototype = new n.TrackGroupTypeBox(), e && (n[t + "TrackGroupTypeBox"].prototype.parse = e);
    },
    createUUIDBox: function(t, e, r, s, o) {
      n.UUIDs.push(t), n.UUIDBoxes[t] = function(a) {
        r ? n.FullBox.call(this, "uuid", a, e, t) : s ? n.ContainerBox.call(this, "uuid", a, e, t) : n.Box.call(this, "uuid", a, e, t);
      }, n.UUIDBoxes[t].prototype = r ? new n.FullBox() : s ? new n.ContainerBox() : new n.Box(), o && (r ? n.UUIDBoxes[t].prototype.parse = function(a) {
        this.parseFullHeader(a), o && o.call(this, a);
      } : n.UUIDBoxes[t].prototype.parse = o);
    }
  };
  n.initialize(), n.TKHD_FLAG_ENABLED = 1, n.TKHD_FLAG_IN_MOVIE = 2, n.TKHD_FLAG_IN_PREVIEW = 4, n.TFHD_FLAG_BASE_DATA_OFFSET = 1, n.TFHD_FLAG_SAMPLE_DESC = 2, n.TFHD_FLAG_SAMPLE_DUR = 8, n.TFHD_FLAG_SAMPLE_SIZE = 16, n.TFHD_FLAG_SAMPLE_FLAGS = 32, n.TFHD_FLAG_DUR_EMPTY = 65536, n.TFHD_FLAG_DEFAULT_BASE_IS_MOOF = 131072, n.TRUN_FLAGS_DATA_OFFSET = 1, n.TRUN_FLAGS_FIRST_FLAG = 4, n.TRUN_FLAGS_DURATION = 256, n.TRUN_FLAGS_SIZE = 512, n.TRUN_FLAGS_FLAGS = 1024, n.TRUN_FLAGS_CTS_OFFSET = 2048, n.Box.prototype.add = function(t) {
    return this.addBox(new n[t + "Box"]());
  }, n.Box.prototype.addBox = function(t) {
    return this.boxes.push(t), this[t.type + "s"] ? this[t.type + "s"].push(t) : this[t.type] = t, t;
  }, n.Box.prototype.set = function(t, e) {
    return this[t] = e, this;
  }, n.Box.prototype.addEntry = function(t, e) {
    var r = e || "entries";
    return this[r] || (this[r] = []), this[r].push(t), this;
  }, U.BoxParser = n, n.parseUUID = function(t) {
    return n.parseHex16(t);
  }, n.parseHex16 = function(t) {
    for (var e = "", r = 0; r < 16; r++) {
      var s = t.readUint8().toString(16);
      e += s.length === 1 ? "0" + s : s;
    }
    return e;
  }, n.parseOneBox = function(t, e, r) {
    var s, o = t.getPosition(), a = 0, h, d;
    if (t.getEndPosition() - o < 8)
      return f.debug("BoxParser", "Not enough data in stream to parse the type and size of the box"), { code: n.ERR_NOT_ENOUGH_DATA };
    if (r && r < 8)
      return f.debug("BoxParser", "Not enough bytes left in the parent box to parse a new box"), { code: n.ERR_NOT_ENOUGH_DATA };
    var p = t.readUint32(), u = t.readString(4), c = u;
    if (f.debug("BoxParser", "Found box of type '" + u + "' and size " + p + " at position " + o), a = 8, u == "uuid") {
      if (t.getEndPosition() - t.getPosition() < 16 || r - a < 16)
        return t.seek(o), f.debug("BoxParser", "Not enough bytes left in the parent box to parse a UUID box"), { code: n.ERR_NOT_ENOUGH_DATA };
      d = n.parseUUID(t), a += 16, c = d;
    }
    if (p == 1) {
      if (t.getEndPosition() - t.getPosition() < 8 || r && r - a < 8)
        return t.seek(o), f.warn("BoxParser", 'Not enough data in stream to parse the extended size of the "' + u + '" box'), { code: n.ERR_NOT_ENOUGH_DATA };
      p = t.readUint64(), a += 8;
    } else if (p === 0) {
      if (r)
        p = r;
      else if (u !== "mdat")
        return f.error("BoxParser", "Unlimited box size not supported for type: '" + u + "'"), s = new n.Box(u, p), { code: n.OK, box: s, size: s.size };
    }
    return p !== 0 && p < a ? (f.error("BoxParser", "Box of type " + u + " has an invalid size " + p + " (too small to be a box)"), { code: n.ERR_NOT_ENOUGH_DATA, type: u, size: p, hdr_size: a, start: o }) : p !== 0 && r && p > r ? (f.error("BoxParser", "Box of type '" + u + "' has a size " + p + " greater than its container size " + r), { code: n.ERR_NOT_ENOUGH_DATA, type: u, size: p, hdr_size: a, start: o }) : p !== 0 && o + p > t.getEndPosition() ? (t.seek(o), f.info("BoxParser", "Not enough data in stream to parse the entire '" + u + "' box"), { code: n.ERR_NOT_ENOUGH_DATA, type: u, size: p, hdr_size: a, start: o }) : e ? { code: n.OK, type: u, size: p, hdr_size: a, start: o } : (n[u + "Box"] ? s = new n[u + "Box"](p) : u !== "uuid" ? (f.warn("BoxParser", "Unknown box type: '" + u + "'"), s = new n.Box(u, p), s.has_unparsed_data = !0) : n.UUIDBoxes[d] ? s = new n.UUIDBoxes[d](p) : (f.warn("BoxParser", "Unknown uuid type: '" + d + "'"), s = new n.Box(u, p), s.uuid = d, s.has_unparsed_data = !0), s.hdr_size = a, s.start = o, s.write === n.Box.prototype.write && s.type !== "mdat" && (f.info("BoxParser", "'" + c + "' box writing not yet implemented, keeping unparsed data in memory for later write"), s.parseDataAndRewind(t)), s.parse(t), h = t.getPosition() - (s.start + s.size), h < 0 ? (f.warn("BoxParser", "Parsing of box '" + c + "' did not read the entire indicated box data size (missing " + -h + " bytes), seeking forward"), t.seek(s.start + s.size)) : h > 0 && (f.error("BoxParser", "Parsing of box '" + c + "' read " + h + " more bytes than the indicated box data size, seeking backwards"), s.size !== 0 && t.seek(s.start + s.size)), { code: n.OK, box: s, size: s.size });
  }, n.Box.prototype.parse = function(t) {
    this.type != "mdat" ? this.data = t.readUint8Array(this.size - this.hdr_size) : this.size === 0 ? t.seek(t.getEndPosition()) : t.seek(this.start + this.size);
  }, n.Box.prototype.parseDataAndRewind = function(t) {
    this.data = t.readUint8Array(this.size - this.hdr_size), t.position -= this.size - this.hdr_size;
  }, n.FullBox.prototype.parseDataAndRewind = function(t) {
    this.parseFullHeader(t), this.data = t.readUint8Array(this.size - this.hdr_size), this.hdr_size -= 4, t.position -= this.size - this.hdr_size;
  }, n.FullBox.prototype.parseFullHeader = function(t) {
    this.version = t.readUint8(), this.flags = t.readUint24(), this.hdr_size += 4;
  }, n.FullBox.prototype.parse = function(t) {
    this.parseFullHeader(t), this.data = t.readUint8Array(this.size - this.hdr_size);
  }, n.ContainerBox.prototype.parse = function(t) {
    for (var e, r; t.getPosition() < this.start + this.size; )
      if (e = n.parseOneBox(t, !1, this.size - (t.getPosition() - this.start)), e.code === n.OK)
        if (r = e.box, this.boxes.push(r), this.subBoxNames && this.subBoxNames.indexOf(r.type) != -1)
          this[this.subBoxNames[this.subBoxNames.indexOf(r.type)] + "s"].push(r);
        else {
          var s = r.type !== "uuid" ? r.type : r.uuid;
          this[s] ? f.warn("Box of type " + s + " already stored in field of this type") : this[s] = r;
        }
      else
        return;
  }, n.Box.prototype.parseLanguage = function(t) {
    this.language = t.readUint16();
    var e = [];
    e[0] = this.language >> 10 & 31, e[1] = this.language >> 5 & 31, e[2] = this.language & 31, this.languageString = String.fromCharCode(e[0] + 96, e[1] + 96, e[2] + 96);
  }, n.SAMPLE_ENTRY_TYPE_VISUAL = "Visual", n.SAMPLE_ENTRY_TYPE_AUDIO = "Audio", n.SAMPLE_ENTRY_TYPE_HINT = "Hint", n.SAMPLE_ENTRY_TYPE_METADATA = "Metadata", n.SAMPLE_ENTRY_TYPE_SUBTITLE = "Subtitle", n.SAMPLE_ENTRY_TYPE_SYSTEM = "System", n.SAMPLE_ENTRY_TYPE_TEXT = "Text", n.SampleEntry.prototype.parseHeader = function(t) {
    t.readUint8Array(6), this.data_reference_index = t.readUint16(), this.hdr_size += 8;
  }, n.SampleEntry.prototype.parse = function(t) {
    this.parseHeader(t), this.data = t.readUint8Array(this.size - this.hdr_size);
  }, n.SampleEntry.prototype.parseDataAndRewind = function(t) {
    this.parseHeader(t), this.data = t.readUint8Array(this.size - this.hdr_size), this.hdr_size -= 8, t.position -= this.size - this.hdr_size;
  }, n.SampleEntry.prototype.parseFooter = function(t) {
    n.ContainerBox.prototype.parse.call(this, t);
  }, n.createMediaSampleEntryCtor(n.SAMPLE_ENTRY_TYPE_HINT), n.createMediaSampleEntryCtor(n.SAMPLE_ENTRY_TYPE_METADATA), n.createMediaSampleEntryCtor(n.SAMPLE_ENTRY_TYPE_SUBTITLE), n.createMediaSampleEntryCtor(n.SAMPLE_ENTRY_TYPE_SYSTEM), n.createMediaSampleEntryCtor(n.SAMPLE_ENTRY_TYPE_TEXT), n.createMediaSampleEntryCtor(n.SAMPLE_ENTRY_TYPE_VISUAL, function(t) {
    var e;
    this.parseHeader(t), t.readUint16(), t.readUint16(), t.readUint32Array(3), this.width = t.readUint16(), this.height = t.readUint16(), this.horizresolution = t.readUint32(), this.vertresolution = t.readUint32(), t.readUint32(), this.frame_count = t.readUint16(), e = Math.min(31, t.readUint8()), this.compressorname = t.readString(e), e < 31 && t.readString(31 - e), this.depth = t.readUint16(), t.readUint16(), this.parseFooter(t);
  }), n.createMediaSampleEntryCtor(n.SAMPLE_ENTRY_TYPE_AUDIO, function(t) {
    this.parseHeader(t), t.readUint32Array(2), this.channel_count = t.readUint16(), this.samplesize = t.readUint16(), t.readUint16(), t.readUint16(), this.samplerate = t.readUint32() / 65536, this.parseFooter(t);
  }), n.createSampleEntryCtor(n.SAMPLE_ENTRY_TYPE_VISUAL, "avc1"), n.createSampleEntryCtor(n.SAMPLE_ENTRY_TYPE_VISUAL, "avc2"), n.createSampleEntryCtor(n.SAMPLE_ENTRY_TYPE_VISUAL, "avc3"), n.createSampleEntryCtor(n.SAMPLE_ENTRY_TYPE_VISUAL, "avc4"), n.createSampleEntryCtor(n.SAMPLE_ENTRY_TYPE_VISUAL, "av01"), n.createSampleEntryCtor(n.SAMPLE_ENTRY_TYPE_VISUAL, "dav1"), n.createSampleEntryCtor(n.SAMPLE_ENTRY_TYPE_VISUAL, "hvc1"), n.createSampleEntryCtor(n.SAMPLE_ENTRY_TYPE_VISUAL, "hev1"), n.createSampleEntryCtor(n.SAMPLE_ENTRY_TYPE_VISUAL, "hvt1"), n.createSampleEntryCtor(n.SAMPLE_ENTRY_TYPE_VISUAL, "lhe1"), n.createSampleEntryCtor(n.SAMPLE_ENTRY_TYPE_VISUAL, "dvh1"), n.createSampleEntryCtor(n.SAMPLE_ENTRY_TYPE_VISUAL, "dvhe"), n.createSampleEntryCtor(n.SAMPLE_ENTRY_TYPE_VISUAL, "vvc1"), n.createSampleEntryCtor(n.SAMPLE_ENTRY_TYPE_VISUAL, "vvi1"), n.createSampleEntryCtor(n.SAMPLE_ENTRY_TYPE_VISUAL, "vvs1"), n.createSampleEntryCtor(n.SAMPLE_ENTRY_TYPE_VISUAL, "vvcN"), n.createSampleEntryCtor(n.SAMPLE_ENTRY_TYPE_VISUAL, "vp08"), n.createSampleEntryCtor(n.SAMPLE_ENTRY_TYPE_VISUAL, "vp09"), n.createSampleEntryCtor(n.SAMPLE_ENTRY_TYPE_VISUAL, "avs3"), n.createSampleEntryCtor(n.SAMPLE_ENTRY_TYPE_VISUAL, "j2ki"), n.createSampleEntryCtor(n.SAMPLE_ENTRY_TYPE_VISUAL, "mjp2"), n.createSampleEntryCtor(n.SAMPLE_ENTRY_TYPE_VISUAL, "mjpg"), n.createSampleEntryCtor(n.SAMPLE_ENTRY_TYPE_VISUAL, "uncv"), n.createSampleEntryCtor(n.SAMPLE_ENTRY_TYPE_AUDIO, "mp4a"), n.createSampleEntryCtor(n.SAMPLE_ENTRY_TYPE_AUDIO, "ac-3"), n.createSampleEntryCtor(n.SAMPLE_ENTRY_TYPE_AUDIO, "ac-4"), n.createSampleEntryCtor(n.SAMPLE_ENTRY_TYPE_AUDIO, "ec-3"), n.createSampleEntryCtor(n.SAMPLE_ENTRY_TYPE_AUDIO, "Opus"), n.createSampleEntryCtor(n.SAMPLE_ENTRY_TYPE_AUDIO, "mha1"), n.createSampleEntryCtor(n.SAMPLE_ENTRY_TYPE_AUDIO, "mha2"), n.createSampleEntryCtor(n.SAMPLE_ENTRY_TYPE_AUDIO, "mhm1"), n.createSampleEntryCtor(n.SAMPLE_ENTRY_TYPE_AUDIO, "mhm2"), n.createSampleEntryCtor(n.SAMPLE_ENTRY_TYPE_AUDIO, "fLaC"), n.createEncryptedSampleEntryCtor(n.SAMPLE_ENTRY_TYPE_VISUAL, "encv"), n.createEncryptedSampleEntryCtor(n.SAMPLE_ENTRY_TYPE_AUDIO, "enca"), n.createEncryptedSampleEntryCtor(n.SAMPLE_ENTRY_TYPE_SUBTITLE, "encu"), n.createEncryptedSampleEntryCtor(n.SAMPLE_ENTRY_TYPE_SYSTEM, "encs"), n.createEncryptedSampleEntryCtor(n.SAMPLE_ENTRY_TYPE_TEXT, "enct"), n.createEncryptedSampleEntryCtor(n.SAMPLE_ENTRY_TYPE_METADATA, "encm"), n.createBoxCtor("a1lx", "AV1LayeredImageIndexingProperty", function(t) {
    var e = t.readUint8() & 1, r = ((e & 1) + 1) * 16;
    this.layer_size = [];
    for (var s = 0; s < 3; s++)
      r == 16 ? this.layer_size[s] = t.readUint16() : this.layer_size[s] = t.readUint32();
  }), n.createBoxCtor("a1op", "OperatingPointSelectorProperty", function(t) {
    this.op_index = t.readUint8();
  }), n.createFullBoxCtor("auxC", "AuxiliaryTypeProperty", function(t) {
    this.aux_type = t.readCString();
    var e = this.size - this.hdr_size - (this.aux_type.length + 1);
    this.aux_subtype = t.readUint8Array(e);
  }), n.createBoxCtor("av1C", "AV1CodecConfigurationBox", function(t) {
    var e = t.readUint8();
    if ((e >> 7 & 1) !== 1) {
      f.error("av1C marker problem");
      return;
    }
    if (this.version = e & 127, this.version !== 1) {
      f.error("av1C version " + this.version + " not supported");
      return;
    }
    if (e = t.readUint8(), this.seq_profile = e >> 5 & 7, this.seq_level_idx_0 = e & 31, e = t.readUint8(), this.seq_tier_0 = e >> 7 & 1, this.high_bitdepth = e >> 6 & 1, this.twelve_bit = e >> 5 & 1, this.monochrome = e >> 4 & 1, this.chroma_subsampling_x = e >> 3 & 1, this.chroma_subsampling_y = e >> 2 & 1, this.chroma_sample_position = e & 3, e = t.readUint8(), this.reserved_1 = e >> 5 & 7, this.reserved_1 !== 0) {
      f.error("av1C reserved_1 parsing problem");
      return;
    }
    if (this.initial_presentation_delay_present = e >> 4 & 1, this.initial_presentation_delay_present === 1)
      this.initial_presentation_delay_minus_one = e & 15;
    else if (this.reserved_2 = e & 15, this.reserved_2 !== 0) {
      f.error("av1C reserved_2 parsing problem");
      return;
    }
    var r = this.size - this.hdr_size - 4;
    this.configOBUs = t.readUint8Array(r);
  });
  function A(t) {
    var e = "<table class='inner-table'>";
    e += "<thead><tr><th>length</th><th>nalu_data</th></tr></thead>", e += "<tbody>";
    for (var r = 0; r < t.length; r++) {
      var s = t[r];
      e += "<tr>", e += "<td>" + s.length + "</td>", e += "<td>", e += s.nalu.reduce(function(o, a) {
        return o + a.toString(16).padStart(2, "0");
      }, "0x"), e += "</td></tr>";
    }
    return e += "</tbody></table>", e;
  }
  n.createBoxCtor("avcC", "AVCConfigurationBox", function(t) {
    var e, r;
    for (this.configurationVersion = t.readUint8(), this.AVCProfileIndication = t.readUint8(), this.profile_compatibility = t.readUint8(), this.AVCLevelIndication = t.readUint8(), this.lengthSizeMinusOne = t.readUint8() & 3, this.nb_SPS_nalus = t.readUint8() & 31, r = this.size - this.hdr_size - 6, this.SPS = [], this.SPS.toString = function() {
      return A(this);
    }, e = 0; e < this.nb_SPS_nalus; e++)
      this.SPS[e] = {}, this.SPS[e].length = t.readUint16(), this.SPS[e].nalu = t.readUint8Array(this.SPS[e].length), r -= 2 + this.SPS[e].length;
    for (this.nb_PPS_nalus = t.readUint8(), r--, this.PPS = [], this.PPS.toString = function() {
      return A(this);
    }, e = 0; e < this.nb_PPS_nalus; e++)
      this.PPS[e] = {}, this.PPS[e].length = t.readUint16(), this.PPS[e].nalu = t.readUint8Array(this.PPS[e].length), r -= 2 + this.PPS[e].length;
    r > 0 && (this.ext = t.readUint8Array(r));
  }), n.createBoxCtor("btrt", "BitRateBox", function(t) {
    this.bufferSizeDB = t.readUint32(), this.maxBitrate = t.readUint32(), this.avgBitrate = t.readUint32();
  }), n.createFullBoxCtor("ccst", "CodingConstraintsBox", function(t) {
    var e = t.readUint8();
    this.all_ref_pics_intra = (e & 128) == 128, this.intra_pred_used = (e & 64) == 64, this.max_ref_per_pic = (e & 63) >> 2, t.readUint24();
  }), n.createBoxCtor("cdef", "ComponentDefinitionBox", function(t) {
    var e;
    for (this.channel_count = t.readUint16(), this.channel_indexes = [], this.channel_types = [], this.channel_associations = [], e = 0; e < this.channel_count; e++)
      this.channel_indexes.push(t.readUint16()), this.channel_types.push(t.readUint16()), this.channel_associations.push(t.readUint16());
  }), n.createBoxCtor("clap", "CleanApertureBox", function(t) {
    this.cleanApertureWidthN = t.readUint32(), this.cleanApertureWidthD = t.readUint32(), this.cleanApertureHeightN = t.readUint32(), this.cleanApertureHeightD = t.readUint32(), this.horizOffN = t.readUint32(), this.horizOffD = t.readUint32(), this.vertOffN = t.readUint32(), this.vertOffD = t.readUint32();
  }), n.createBoxCtor("clli", "ContentLightLevelBox", function(t) {
    this.max_content_light_level = t.readUint16(), this.max_pic_average_light_level = t.readUint16();
  }), n.createFullBoxCtor("cmex", "CameraExtrinsicMatrixProperty", function(t) {
    this.flags & 1 && (this.pos_x = t.readInt32()), this.flags & 2 && (this.pos_y = t.readInt32()), this.flags & 4 && (this.pos_z = t.readInt32()), this.flags & 8 && (this.version == 0 ? this.flags & 16 ? (this.quat_x = t.readInt32(), this.quat_y = t.readInt32(), this.quat_z = t.readInt32()) : (this.quat_x = t.readInt16(), this.quat_y = t.readInt16(), this.quat_z = t.readInt16()) : this.version == 1), this.flags & 32 && (this.id = t.readUint32());
  }), n.createFullBoxCtor("cmin", "CameraIntrinsicMatrixProperty", function(t) {
    this.focal_length_x = t.readInt32(), this.principal_point_x = t.readInt32(), this.principal_point_y = t.readInt32(), this.flags & 1 && (this.focal_length_y = t.readInt32(), this.skew_factor = t.readInt32());
  }), n.createBoxCtor("cmpd", "ComponentDefinitionBox", function(t) {
    for (this.component_count = t.readUint32(), this.component_types = [], this.component_type_urls = [], i = 0; i < this.component_count; i++) {
      var e = t.readUint16();
      this.component_types.push(e), e >= 32768 && this.component_type_urls.push(t.readCString());
    }
  }), n.createFullBoxCtor("co64", "ChunkLargeOffsetBox", function(t) {
    var e, r;
    if (e = t.readUint32(), this.chunk_offsets = [], this.version === 0)
      for (r = 0; r < e; r++)
        this.chunk_offsets.push(t.readUint64());
  }), n.createFullBoxCtor("CoLL", "ContentLightLevelBox", function(t) {
    this.maxCLL = t.readUint16(), this.maxFALL = t.readUint16();
  }), n.createBoxCtor("colr", "ColourInformationBox", function(t) {
    if (this.colour_type = t.readString(4), this.colour_type === "nclx") {
      this.colour_primaries = t.readUint16(), this.transfer_characteristics = t.readUint16(), this.matrix_coefficients = t.readUint16();
      var e = t.readUint8();
      this.full_range_flag = e >> 7;
    } else this.colour_type === "rICC" ? this.ICC_profile = t.readUint8Array(this.size - 4) : this.colour_type === "prof" && (this.ICC_profile = t.readUint8Array(this.size - 4));
  }), n.createFullBoxCtor("cprt", "CopyrightBox", function(t) {
    this.parseLanguage(t), this.notice = t.readCString();
  }), n.createFullBoxCtor("cslg", "CompositionToDecodeBox", function(t) {
    this.version === 0 && (this.compositionToDTSShift = t.readInt32(), this.leastDecodeToDisplayDelta = t.readInt32(), this.greatestDecodeToDisplayDelta = t.readInt32(), this.compositionStartTime = t.readInt32(), this.compositionEndTime = t.readInt32());
  }), n.createFullBoxCtor("ctts", "CompositionOffsetBox", function(t) {
    var e, r;
    if (e = t.readUint32(), this.sample_counts = [], this.sample_offsets = [], this.version === 0)
      for (r = 0; r < e; r++) {
        this.sample_counts.push(t.readUint32());
        var s = t.readInt32();
        s < 0 && f.warn("BoxParser", "ctts box uses negative values without using version 1"), this.sample_offsets.push(s);
      }
    else if (this.version == 1)
      for (r = 0; r < e; r++)
        this.sample_counts.push(t.readUint32()), this.sample_offsets.push(t.readInt32());
  }), n.createBoxCtor("dac3", "AC3SpecificBox", function(t) {
    var e = t.readUint8(), r = t.readUint8(), s = t.readUint8();
    this.fscod = e >> 6, this.bsid = e >> 1 & 31, this.bsmod = (e & 1) << 2 | r >> 6 & 3, this.acmod = r >> 3 & 7, this.lfeon = r >> 2 & 1, this.bit_rate_code = r & 3 | s >> 5 & 7;
  }), n.createBoxCtor("dec3", "EC3SpecificBox", function(t) {
    var e = t.readUint16();
    this.data_rate = e >> 3, this.num_ind_sub = e & 7, this.ind_subs = [];
    for (var r = 0; r < this.num_ind_sub + 1; r++) {
      var s = {};
      this.ind_subs.push(s);
      var o = t.readUint8(), a = t.readUint8(), h = t.readUint8();
      s.fscod = o >> 6, s.bsid = o >> 1 & 31, s.bsmod = (o & 1) << 4 | a >> 4 & 15, s.acmod = a >> 1 & 7, s.lfeon = a & 1, s.num_dep_sub = h >> 1 & 15, s.num_dep_sub > 0 && (s.chan_loc = (h & 1) << 8 | t.readUint8());
    }
  }), n.createFullBoxCtor("dfLa", "FLACSpecificBox", function(t) {
    var e = 127, r = 128, s = [], o = [
      "STREAMINFO",
      "PADDING",
      "APPLICATION",
      "SEEKTABLE",
      "VORBIS_COMMENT",
      "CUESHEET",
      "PICTURE",
      "RESERVED"
    ];
    do {
      var a = t.readUint8(), h = Math.min(
        a & e,
        o.length - 1
      );
      if (h ? t.readUint8Array(t.readUint24()) : (t.readUint8Array(13), this.samplerate = t.readUint32() >> 12, t.readUint8Array(20)), s.push(o[h]), a & r)
        break;
    } while (!0);
    this.numMetadataBlocks = s.length + " (" + s.join(", ") + ")";
  }), n.createBoxCtor("dimm", "hintimmediateBytesSent", function(t) {
    this.bytessent = t.readUint64();
  }), n.createBoxCtor("dmax", "hintlongestpacket", function(t) {
    this.time = t.readUint32();
  }), n.createBoxCtor("dmed", "hintmediaBytesSent", function(t) {
    this.bytessent = t.readUint64();
  }), n.createBoxCtor("dOps", "OpusSpecificBox", function(t) {
    if (this.Version = t.readUint8(), this.OutputChannelCount = t.readUint8(), this.PreSkip = t.readUint16(), this.InputSampleRate = t.readUint32(), this.OutputGain = t.readInt16(), this.ChannelMappingFamily = t.readUint8(), this.ChannelMappingFamily !== 0) {
      this.StreamCount = t.readUint8(), this.CoupledCount = t.readUint8(), this.ChannelMapping = [];
      for (var e = 0; e < this.OutputChannelCount; e++)
        this.ChannelMapping[e] = t.readUint8();
    }
  }), n.createFullBoxCtor("dref", "DataReferenceBox", function(t) {
    var e, r;
    this.entries = [];
    for (var s = t.readUint32(), o = 0; o < s; o++)
      if (e = n.parseOneBox(t, !1, this.size - (t.getPosition() - this.start)), e.code === n.OK)
        r = e.box, this.entries.push(r);
      else
        return;
  }), n.createBoxCtor("drep", "hintrepeatedBytesSent", function(t) {
    this.bytessent = t.readUint64();
  }), n.createFullBoxCtor("elng", "ExtendedLanguageBox", function(t) {
    this.extended_language = t.readString(this.size - this.hdr_size);
  }), n.createFullBoxCtor("elst", "EditListBox", function(t) {
    this.entries = [];
    for (var e = t.readUint32(), r = 0; r < e; r++) {
      var s = {};
      this.entries.push(s), this.version === 1 ? (s.segment_duration = t.readUint64(), s.media_time = t.readInt64()) : (s.segment_duration = t.readUint32(), s.media_time = t.readInt32()), s.media_rate_integer = t.readInt16(), s.media_rate_fraction = t.readInt16();
    }
  }), n.createFullBoxCtor("emsg", "EventMessageBox", function(t) {
    this.version == 1 ? (this.timescale = t.readUint32(), this.presentation_time = t.readUint64(), this.event_duration = t.readUint32(), this.id = t.readUint32(), this.scheme_id_uri = t.readCString(), this.value = t.readCString()) : (this.scheme_id_uri = t.readCString(), this.value = t.readCString(), this.timescale = t.readUint32(), this.presentation_time_delta = t.readUint32(), this.event_duration = t.readUint32(), this.id = t.readUint32());
    var e = this.size - this.hdr_size - (4 * 4 + (this.scheme_id_uri.length + 1) + (this.value.length + 1));
    this.version == 1 && (e -= 4), this.message_data = t.readUint8Array(e);
  }), n.createEntityToGroupCtor = function(t, e) {
    n[t + "Box"] = function(r) {
      n.FullBox.call(this, t, r);
    }, n[t + "Box"].prototype = new n.FullBox(), n[t + "Box"].prototype.parse = function(r) {
      if (this.parseFullHeader(r), e)
        e.call(this, r);
      else
        for (this.group_id = r.readUint32(), this.num_entities_in_group = r.readUint32(), this.entity_ids = [], i = 0; i < this.num_entities_in_group; i++) {
          var s = r.readUint32();
          this.entity_ids.push(s);
        }
    };
  }, n.createEntityToGroupCtor("aebr"), n.createEntityToGroupCtor("afbr"), n.createEntityToGroupCtor("albc"), n.createEntityToGroupCtor("altr"), n.createEntityToGroupCtor("brst"), n.createEntityToGroupCtor("dobr"), n.createEntityToGroupCtor("eqiv"), n.createEntityToGroupCtor("favc"), n.createEntityToGroupCtor("fobr"), n.createEntityToGroupCtor("iaug"), n.createEntityToGroupCtor("pano"), n.createEntityToGroupCtor("slid"), n.createEntityToGroupCtor("ster"), n.createEntityToGroupCtor("tsyn"), n.createEntityToGroupCtor("wbbr"), n.createEntityToGroupCtor("prgr"), n.createEntityToGroupCtor("pymd", function(t) {
    this.group_id = t.readUint32(), this.num_entities_in_group = t.readUint32(), this.entity_ids = [];
    for (var e = 0; e < this.num_entities_in_group; e++) {
      var r = t.readUint32();
      this.entity_ids.push(r);
    }
    for (this.tile_size_x = t.readUint16(), this.tile_size_y = t.readUint16(), this.layer_binning = [], this.tiles_in_layer_column_minus1 = [], this.tiles_in_layer_row_minus1 = [], e = 0; e < this.num_entities_in_group; e++)
      this.layer_binning[e] = t.readUint16(), this.tiles_in_layer_row_minus1[e] = t.readUint16(), this.tiles_in_layer_column_minus1[e] = t.readUint16();
  }), n.createFullBoxCtor("esds", "ElementaryStreamDescriptorBox", function(t) {
    var e = t.readUint8Array(this.size - this.hdr_size);
    if (typeof E < "u") {
      var r = new E();
      this.esd = r.parseOneDescriptor(new l(e.buffer, 0, l.BIG_ENDIAN));
    }
  }), n.createBoxCtor("fiel", "FieldHandlingBox", function(t) {
    this.fieldCount = t.readUint8(), this.fieldOrdering = t.readUint8();
  }), n.createBoxCtor("frma", "OriginalFormatBox", function(t) {
    this.data_format = t.readString(4);
  }), n.createBoxCtor("ftyp", "FileTypeBox", function(t) {
    var e = this.size - this.hdr_size;
    this.major_brand = t.readString(4), this.minor_version = t.readUint32(), e -= 8, this.compatible_brands = [];
    for (var r = 0; e >= 4; )
      this.compatible_brands[r] = t.readString(4), e -= 4, r++;
  }), n.createFullBoxCtor("hdlr", "HandlerBox", function(t) {
    this.version === 0 && (t.readUint32(), this.handler = t.readString(4), t.readUint32Array(3), this.name = t.readString(this.size - this.hdr_size - 20), this.name[this.name.length - 1] === "\0" && (this.name = this.name.slice(0, -1)));
  }), n.createBoxCtor("hvcC", "HEVCConfigurationBox", function(t) {
    var e, r, s, o;
    this.configurationVersion = t.readUint8(), o = t.readUint8(), this.general_profile_space = o >> 6, this.general_tier_flag = (o & 32) >> 5, this.general_profile_idc = o & 31, this.general_profile_compatibility = t.readUint32(), this.general_constraint_indicator = t.readUint8Array(6), this.general_level_idc = t.readUint8(), this.min_spatial_segmentation_idc = t.readUint16() & 4095, this.parallelismType = t.readUint8() & 3, this.chroma_format_idc = t.readUint8() & 3, this.bit_depth_luma_minus8 = t.readUint8() & 7, this.bit_depth_chroma_minus8 = t.readUint8() & 7, this.avgFrameRate = t.readUint16(), o = t.readUint8(), this.constantFrameRate = o >> 6, this.numTemporalLayers = (o & 13) >> 3, this.temporalIdNested = (o & 4) >> 2, this.lengthSizeMinusOne = o & 3, this.nalu_arrays = [], this.nalu_arrays.toString = function() {
      var u = "<table class='inner-table'>";
      u += "<thead><tr><th>completeness</th><th>nalu_type</th><th>nalu_data</th></tr></thead>", u += "<tbody>";
      for (var c = 0; c < this.length; c++) {
        var y = this[c];
        u += "<tr>", u += "<td rowspan='" + y.length + "'>" + y.completeness + "</td>", u += "<td rowspan='" + y.length + "'>" + y.nalu_type + "</td>";
        for (var x = 0; x < y.length; x++) {
          var m = y[x];
          x !== 0 && (u += "<tr>"), u += "<td>", u += m.data.reduce(function(w, b) {
            return w + b.toString(16).padStart(2, "0");
          }, "0x"), u += "</td></tr>";
        }
      }
      return u += "</tbody></table>", u;
    };
    var a = t.readUint8();
    for (e = 0; e < a; e++) {
      var h = [];
      this.nalu_arrays.push(h), o = t.readUint8(), h.completeness = (o & 128) >> 7, h.nalu_type = o & 63;
      var d = t.readUint16();
      for (r = 0; r < d; r++) {
        var p = {};
        h.push(p), s = t.readUint16(), p.data = t.readUint8Array(s);
      }
    }
  }), n.createFullBoxCtor("iinf", "ItemInfoBox", function(t) {
    var e;
    this.version === 0 ? this.entry_count = t.readUint16() : this.entry_count = t.readUint32(), this.item_infos = [];
    for (var r = 0; r < this.entry_count; r++)
      if (e = n.parseOneBox(t, !1, this.size - (t.getPosition() - this.start)), e.code === n.OK)
        e.box.type !== "infe" && f.error("BoxParser", "Expected 'infe' box, got " + e.box.type), this.item_infos[r] = e.box;
      else
        return;
  }), n.createFullBoxCtor("iloc", "ItemLocationBox", function(t) {
    var e;
    e = t.readUint8(), this.offset_size = e >> 4 & 15, this.length_size = e & 15, e = t.readUint8(), this.base_offset_size = e >> 4 & 15, this.version === 1 || this.version === 2 ? this.index_size = e & 15 : this.index_size = 0, this.items = [];
    var r = 0;
    if (this.version < 2)
      r = t.readUint16();
    else if (this.version === 2)
      r = t.readUint32();
    else
      throw "version of iloc box not supported";
    for (var s = 0; s < r; s++) {
      var o = {};
      if (this.items.push(o), this.version < 2)
        o.item_ID = t.readUint16();
      else if (this.version === 2)
        o.item_ID = t.readUint32();
      else
        throw "version of iloc box not supported";
      switch (this.version === 1 || this.version === 2 ? o.construction_method = t.readUint16() & 15 : o.construction_method = 0, o.data_reference_index = t.readUint16(), this.base_offset_size) {
        case 0:
          o.base_offset = 0;
          break;
        case 4:
          o.base_offset = t.readUint32();
          break;
        case 8:
          o.base_offset = t.readUint64();
          break;
        default:
          throw "Error reading base offset size";
      }
      var a = t.readUint16();
      o.extents = [];
      for (var h = 0; h < a; h++) {
        var d = {};
        if (o.extents.push(d), this.version === 1 || this.version === 2)
          switch (this.index_size) {
            case 0:
              d.extent_index = 0;
              break;
            case 4:
              d.extent_index = t.readUint32();
              break;
            case 8:
              d.extent_index = t.readUint64();
              break;
            default:
              throw "Error reading extent index";
          }
        switch (this.offset_size) {
          case 0:
            d.extent_offset = 0;
            break;
          case 4:
            d.extent_offset = t.readUint32();
            break;
          case 8:
            d.extent_offset = t.readUint64();
            break;
          default:
            throw "Error reading extent index";
        }
        switch (this.length_size) {
          case 0:
            d.extent_length = 0;
            break;
          case 4:
            d.extent_length = t.readUint32();
            break;
          case 8:
            d.extent_length = t.readUint64();
            break;
          default:
            throw "Error reading extent index";
        }
      }
    }
  }), n.createBoxCtor("imir", "ImageMirror", function(t) {
    var e = t.readUint8();
    this.reserved = e >> 7, this.axis = e & 1;
  }), n.createFullBoxCtor("infe", "ItemInfoEntry", function(t) {
    if ((this.version === 0 || this.version === 1) && (this.item_ID = t.readUint16(), this.item_protection_index = t.readUint16(), this.item_name = t.readCString(), this.content_type = t.readCString(), this.content_encoding = t.readCString()), this.version === 1) {
      this.extension_type = t.readString(4), f.warn("BoxParser", "Cannot parse extension type"), t.seek(this.start + this.size);
      return;
    }
    this.version >= 2 && (this.version === 2 ? this.item_ID = t.readUint16() : this.version === 3 && (this.item_ID = t.readUint32()), this.item_protection_index = t.readUint16(), this.item_type = t.readString(4), this.item_name = t.readCString(), this.item_type === "mime" ? (this.content_type = t.readCString(), this.content_encoding = t.readCString()) : this.item_type === "uri " && (this.item_uri_type = t.readCString()));
  }), n.createFullBoxCtor("ipma", "ItemPropertyAssociationBox", function(t) {
    var e, r;
    for (entry_count = t.readUint32(), this.associations = [], e = 0; e < entry_count; e++) {
      var s = {};
      this.associations.push(s), this.version < 1 ? s.id = t.readUint16() : s.id = t.readUint32();
      var o = t.readUint8();
      for (s.props = [], r = 0; r < o; r++) {
        var a = t.readUint8(), h = {};
        s.props.push(h), h.essential = (a & 128) >> 7 === 1, this.flags & 1 ? h.property_index = (a & 127) << 8 | t.readUint8() : h.property_index = a & 127;
      }
    }
  }), n.createFullBoxCtor("iref", "ItemReferenceBox", function(t) {
    var e, r;
    for (this.references = []; t.getPosition() < this.start + this.size; )
      if (e = n.parseOneBox(t, !0, this.size - (t.getPosition() - this.start)), e.code === n.OK)
        this.version === 0 ? r = new n.SingleItemTypeReferenceBox(e.type, e.size, e.hdr_size, e.start) : r = new n.SingleItemTypeReferenceBoxLarge(e.type, e.size, e.hdr_size, e.start), r.write === n.Box.prototype.write && r.type !== "mdat" && (f.warn("BoxParser", r.type + " box writing not yet implemented, keeping unparsed data in memory for later write"), r.parseDataAndRewind(t)), r.parse(t), this.references.push(r);
      else
        return;
  }), n.createBoxCtor("irot", "ImageRotation", function(t) {
    this.angle = t.readUint8() & 3;
  }), n.createFullBoxCtor("ispe", "ImageSpatialExtentsProperty", function(t) {
    this.image_width = t.readUint32(), this.image_height = t.readUint32();
  }), n.createFullBoxCtor("kind", "KindBox", function(t) {
    this.schemeURI = t.readCString(), this.value = t.readCString();
  }), n.createFullBoxCtor("leva", "LevelAssignmentBox", function(t) {
    var e = t.readUint8();
    this.levels = [];
    for (var r = 0; r < e; r++) {
      var s = {};
      this.levels[r] = s, s.track_ID = t.readUint32();
      var o = t.readUint8();
      switch (s.padding_flag = o >> 7, s.assignment_type = o & 127, s.assignment_type) {
        case 0:
          s.grouping_type = t.readString(4);
          break;
        case 1:
          s.grouping_type = t.readString(4), s.grouping_type_parameter = t.readUint32();
          break;
        case 2:
          break;
        case 3:
          break;
        case 4:
          s.sub_track_id = t.readUint32();
          break;
        default:
          f.warn("BoxParser", "Unknown leva assignement type");
      }
    }
  }), n.createBoxCtor("lhvC", "LHEVCConfigurationBox", function(t) {
    var e, r, s;
    this.configurationVersion = t.readUint8(), this.min_spatial_segmentation_idc = t.readUint16() & 4095, this.parallelismType = t.readUint8() & 3, s = t.readUint8(), this.numTemporalLayers = (s & 13) >> 3, this.temporalIdNested = (s & 4) >> 2, this.lengthSizeMinusOne = s & 3, this.nalu_arrays = [], this.nalu_arrays.toString = function() {
      var u = "<table class='inner-table'>";
      u += "<thead><tr><th>completeness</th><th>nalu_type</th><th>nalu_data</th></tr></thead>", u += "<tbody>";
      for (var c = 0; c < this.length; c++) {
        var y = this[c];
        u += "<tr>", u += "<td rowspan='" + y.length + "'>" + y.completeness + "</td>", u += "<td rowspan='" + y.length + "'>" + y.nalu_type + "</td>";
        for (var x = 0; x < y.length; x++) {
          var m = y[x];
          x !== 0 && (u += "<tr>"), u += "<td>", u += m.data.reduce(function(w, b) {
            return w + b.toString(16).padStart(2, "0");
          }, "0x"), u += "</td></tr>";
        }
      }
      return u += "</tbody></table>", u;
    };
    var o = t.readUint8();
    for (e = 0; e < o; e++) {
      var a = [];
      this.nalu_arrays.push(a), s = t.readUint8(), a.completeness = (s & 128) >> 7, a.nalu_type = s & 63;
      var h = t.readUint16();
      for (r = 0; r < h; r++) {
        var d = {};
        a.push(d);
        var p = t.readUint16();
        d.data = t.readUint8Array(p);
      }
    }
  }), n.createBoxCtor("lsel", "LayerSelectorProperty", function(t) {
    this.layer_id = t.readUint16();
  }), n.createBoxCtor("maxr", "hintmaxrate", function(t) {
    this.period = t.readUint32(), this.bytes = t.readUint32();
  });
  function T(t, e) {
    this.x = t, this.y = e;
  }
  T.prototype.toString = function() {
    return "(" + this.x + "," + this.y + ")";
  }, n.createBoxCtor("mdcv", "MasteringDisplayColourVolumeBox", function(t) {
    this.display_primaries = [], this.display_primaries[0] = new T(t.readUint16(), t.readUint16()), this.display_primaries[1] = new T(t.readUint16(), t.readUint16()), this.display_primaries[2] = new T(t.readUint16(), t.readUint16()), this.white_point = new T(t.readUint16(), t.readUint16()), this.max_display_mastering_luminance = t.readUint32(), this.min_display_mastering_luminance = t.readUint32();
  }), n.createFullBoxCtor("mdhd", "MediaHeaderBox", function(t) {
    this.version == 1 ? (this.creation_time = t.readUint64(), this.modification_time = t.readUint64(), this.timescale = t.readUint32(), this.duration = t.readUint64()) : (this.creation_time = t.readUint32(), this.modification_time = t.readUint32(), this.timescale = t.readUint32(), this.duration = t.readUint32()), this.parseLanguage(t), t.readUint16();
  }), n.createFullBoxCtor("mehd", "MovieExtendsHeaderBox", function(t) {
    this.flags & 1 && (f.warn("BoxParser", "mehd box incorrectly uses flags set to 1, converting version to 1"), this.version = 1), this.version == 1 ? this.fragment_duration = t.readUint64() : this.fragment_duration = t.readUint32();
  }), n.createFullBoxCtor("meta", "MetaBox", function(t) {
    this.boxes = [], n.ContainerBox.prototype.parse.call(this, t);
  }), n.createFullBoxCtor("mfhd", "MovieFragmentHeaderBox", function(t) {
    this.sequence_number = t.readUint32();
  }), n.createFullBoxCtor("mfro", "MovieFragmentRandomAccessOffsetBox", function(t) {
    this._size = t.readUint32();
  }), n.createFullBoxCtor("mskC", "MaskConfigurationProperty", function(t) {
    this.bits_per_pixel = t.readUint8();
  }), n.createFullBoxCtor("mvhd", "MovieHeaderBox", function(t) {
    this.version == 1 ? (this.creation_time = t.readUint64(), this.modification_time = t.readUint64(), this.timescale = t.readUint32(), this.duration = t.readUint64()) : (this.creation_time = t.readUint32(), this.modification_time = t.readUint32(), this.timescale = t.readUint32(), this.duration = t.readUint32()), this.rate = t.readUint32(), this.volume = t.readUint16() >> 8, t.readUint16(), t.readUint32Array(2), this.matrix = t.readUint32Array(9), t.readUint32Array(6), this.next_track_id = t.readUint32();
  }), n.createBoxCtor("npck", "hintPacketsSent", function(t) {
    this.packetssent = t.readUint32();
  }), n.createBoxCtor("nump", "hintPacketsSent", function(t) {
    this.packetssent = t.readUint64();
  }), n.createFullBoxCtor("padb", "PaddingBitsBox", function(t) {
    var e = t.readUint32();
    this.padbits = [];
    for (var r = 0; r < Math.floor((e + 1) / 2); r++)
      this.padbits = t.readUint8();
  }), n.createBoxCtor("pasp", "PixelAspectRatioBox", function(t) {
    this.hSpacing = t.readUint32(), this.vSpacing = t.readUint32();
  }), n.createBoxCtor("payl", "CuePayloadBox", function(t) {
    this.text = t.readString(this.size - this.hdr_size);
  }), n.createBoxCtor("payt", "hintpayloadID", function(t) {
    this.payloadID = t.readUint32();
    var e = t.readUint8();
    this.rtpmap_string = t.readString(e);
  }), n.createFullBoxCtor("pdin", "ProgressiveDownloadInfoBox", function(t) {
    var e = (this.size - this.hdr_size) / 8;
    this.rate = [], this.initial_delay = [];
    for (var r = 0; r < e; r++)
      this.rate[r] = t.readUint32(), this.initial_delay[r] = t.readUint32();
  }), n.createFullBoxCtor("pitm", "PrimaryItemBox", function(t) {
    this.version === 0 ? this.item_id = t.readUint16() : this.item_id = t.readUint32();
  }), n.createFullBoxCtor("pixi", "PixelInformationProperty", function(t) {
    var e;
    for (this.num_channels = t.readUint8(), this.bits_per_channels = [], e = 0; e < this.num_channels; e++)
      this.bits_per_channels[e] = t.readUint8();
  }), n.createBoxCtor("pmax", "hintlargestpacket", function(t) {
    this.bytes = t.readUint32();
  }), n.createFullBoxCtor("prdi", "ProgressiveDerivedImageItemInformationProperty", function(t) {
    if (this.step_count = t.readUint16(), this.item_count = [], this.flags & 2)
      for (var e = 0; e < this.step_count; e++)
        this.item_count[e] = t.readUint16();
  }), n.createFullBoxCtor("prft", "ProducerReferenceTimeBox", function(t) {
    this.ref_track_id = t.readUint32(), this.ntp_timestamp = t.readUint64(), this.version === 0 ? this.media_time = t.readUint32() : this.media_time = t.readUint64();
  }), n.createFullBoxCtor("pssh", "ProtectionSystemSpecificHeaderBox", function(t) {
    if (this.system_id = n.parseHex16(t), this.version > 0) {
      var e = t.readUint32();
      this.kid = [];
      for (var r = 0; r < e; r++)
        this.kid[r] = n.parseHex16(t);
    }
    var s = t.readUint32();
    s > 0 && (this.data = t.readUint8Array(s));
  }), n.createFullBoxCtor("clef", "TrackCleanApertureDimensionsBox", function(t) {
    this.width = t.readUint32(), this.height = t.readUint32();
  }), n.createFullBoxCtor("enof", "TrackEncodedPixelsDimensionsBox", function(t) {
    this.width = t.readUint32(), this.height = t.readUint32();
  }), n.createFullBoxCtor("prof", "TrackProductionApertureDimensionsBox", function(t) {
    this.width = t.readUint32(), this.height = t.readUint32();
  }), n.createContainerBoxCtor("tapt", "TrackApertureModeDimensionsBox", null, ["clef", "prof", "enof"]), n.createBoxCtor("rtp ", "rtpmoviehintinformation", function(t) {
    this.descriptionformat = t.readString(4), this.sdptext = t.readString(this.size - this.hdr_size - 4);
  }), n.createFullBoxCtor("saio", "SampleAuxiliaryInformationOffsetsBox", function(t) {
    this.flags & 1 && (this.aux_info_type = t.readString(4), this.aux_info_type_parameter = t.readUint32());
    var e = t.readUint32();
    this.offset = [];
    for (var r = 0; r < e; r++)
      this.version === 0 ? this.offset[r] = t.readUint32() : this.offset[r] = t.readUint64();
  }), n.createFullBoxCtor("saiz", "SampleAuxiliaryInformationSizesBox", function(t) {
    if (this.flags & 1 && (this.aux_info_type = t.readString(4), this.aux_info_type_parameter = t.readUint32()), this.default_sample_info_size = t.readUint8(), this.sample_count = t.readUint32(), this.sample_info_size = [], this.default_sample_info_size === 0)
      for (var e = 0; e < this.sample_count; e++)
        this.sample_info_size[e] = t.readUint8();
  }), n.createSampleEntryCtor(n.SAMPLE_ENTRY_TYPE_METADATA, "mett", function(t) {
    this.parseHeader(t), this.content_encoding = t.readCString(), this.mime_format = t.readCString(), this.parseFooter(t);
  }), n.createSampleEntryCtor(n.SAMPLE_ENTRY_TYPE_METADATA, "metx", function(t) {
    this.parseHeader(t), this.content_encoding = t.readCString(), this.namespace = t.readCString(), this.schema_location = t.readCString(), this.parseFooter(t);
  }), n.createSampleEntryCtor(n.SAMPLE_ENTRY_TYPE_SUBTITLE, "sbtt", function(t) {
    this.parseHeader(t), this.content_encoding = t.readCString(), this.mime_format = t.readCString(), this.parseFooter(t);
  }), n.createSampleEntryCtor(n.SAMPLE_ENTRY_TYPE_SUBTITLE, "stpp", function(t) {
    this.parseHeader(t), this.namespace = t.readCString(), this.schema_location = t.readCString(), this.auxiliary_mime_types = t.readCString(), this.parseFooter(t);
  }), n.createSampleEntryCtor(n.SAMPLE_ENTRY_TYPE_SUBTITLE, "stxt", function(t) {
    this.parseHeader(t), this.content_encoding = t.readCString(), this.mime_format = t.readCString(), this.parseFooter(t);
  }), n.createSampleEntryCtor(n.SAMPLE_ENTRY_TYPE_SUBTITLE, "tx3g", function(t) {
    this.parseHeader(t), this.displayFlags = t.readUint32(), this.horizontal_justification = t.readInt8(), this.vertical_justification = t.readInt8(), this.bg_color_rgba = t.readUint8Array(4), this.box_record = t.readInt16Array(4), this.style_record = t.readUint8Array(12), this.parseFooter(t);
  }), n.createSampleEntryCtor(n.SAMPLE_ENTRY_TYPE_METADATA, "wvtt", function(t) {
    this.parseHeader(t), this.parseFooter(t);
  }), n.createSampleGroupCtor("alst", function(t) {
    var e, r = t.readUint16();
    for (this.first_output_sample = t.readUint16(), this.sample_offset = [], e = 0; e < r; e++)
      this.sample_offset[e] = t.readUint32();
    var s = this.description_length - 4 - 4 * r;
    for (this.num_output_samples = [], this.num_total_samples = [], e = 0; e < s / 4; e++)
      this.num_output_samples[e] = t.readUint16(), this.num_total_samples[e] = t.readUint16();
  }), n.createSampleGroupCtor("avll", function(t) {
    this.layerNumber = t.readUint8(), this.accurateStatisticsFlag = t.readUint8(), this.avgBitRate = t.readUint16(), this.avgFrameRate = t.readUint16();
  }), n.createSampleGroupCtor("avss", function(t) {
    this.subSequenceIdentifier = t.readUint16(), this.layerNumber = t.readUint8();
    var e = t.readUint8();
    this.durationFlag = e >> 7, this.avgRateFlag = e >> 6 & 1, this.durationFlag && (this.duration = t.readUint32()), this.avgRateFlag && (this.accurateStatisticsFlag = t.readUint8(), this.avgBitRate = t.readUint16(), this.avgFrameRate = t.readUint16()), this.dependency = [];
    for (var r = t.readUint8(), s = 0; s < r; s++) {
      var o = {};
      this.dependency.push(o), o.subSeqDirectionFlag = t.readUint8(), o.layerNumber = t.readUint8(), o.subSequenceIdentifier = t.readUint16();
    }
  }), n.createSampleGroupCtor("dtrt", function(t) {
    f.warn("BoxParser", "Sample Group type: " + this.grouping_type + " not fully parsed");
  }), n.createSampleGroupCtor("mvif", function(t) {
    f.warn("BoxParser", "Sample Group type: " + this.grouping_type + " not fully parsed");
  }), n.createSampleGroupCtor("prol", function(t) {
    this.roll_distance = t.readInt16();
  }), n.createSampleGroupCtor("rap ", function(t) {
    var e = t.readUint8();
    this.num_leading_samples_known = e >> 7, this.num_leading_samples = e & 127;
  }), n.createSampleGroupCtor("rash", function(t) {
    if (this.operation_point_count = t.readUint16(), this.description_length !== 2 + (this.operation_point_count === 1 ? 2 : this.operation_point_count * 6) + 9)
      f.warn("BoxParser", "Mismatch in " + this.grouping_type + " sample group length"), this.data = t.readUint8Array(this.description_length - 2);
    else {
      if (this.operation_point_count === 1)
        this.target_rate_share = t.readUint16();
      else {
        this.target_rate_share = [], this.available_bitrate = [];
        for (var e = 0; e < this.operation_point_count; e++)
          this.available_bitrate[e] = t.readUint32(), this.target_rate_share[e] = t.readUint16();
      }
      this.maximum_bitrate = t.readUint32(), this.minimum_bitrate = t.readUint32(), this.discard_priority = t.readUint8();
    }
  }), n.createSampleGroupCtor("roll", function(t) {
    this.roll_distance = t.readInt16();
  }), n.SampleGroupEntry.prototype.parse = function(t) {
    f.warn("BoxParser", "Unknown Sample Group type: " + this.grouping_type), this.data = t.readUint8Array(this.description_length);
  }, n.createSampleGroupCtor("scif", function(t) {
    f.warn("BoxParser", "Sample Group type: " + this.grouping_type + " not fully parsed");
  }), n.createSampleGroupCtor("scnm", function(t) {
    f.warn("BoxParser", "Sample Group type: " + this.grouping_type + " not fully parsed");
  }), n.createSampleGroupCtor("seig", function(t) {
    this.reserved = t.readUint8();
    var e = t.readUint8();
    this.crypt_byte_block = e >> 4, this.skip_byte_block = e & 15, this.isProtected = t.readUint8(), this.Per_Sample_IV_Size = t.readUint8(), this.KID = n.parseHex16(t), this.constant_IV_size = 0, this.constant_IV = 0, this.isProtected === 1 && this.Per_Sample_IV_Size === 0 && (this.constant_IV_size = t.readUint8(), this.constant_IV = t.readUint8Array(this.constant_IV_size));
  }), n.createSampleGroupCtor("stsa", function(t) {
    f.warn("BoxParser", "Sample Group type: " + this.grouping_type + " not fully parsed");
  }), n.createSampleGroupCtor("sync", function(t) {
    var e = t.readUint8();
    this.NAL_unit_type = e & 63;
  }), n.createSampleGroupCtor("tele", function(t) {
    var e = t.readUint8();
    this.level_independently_decodable = e >> 7;
  }), n.createSampleGroupCtor("tsas", function(t) {
    f.warn("BoxParser", "Sample Group type: " + this.grouping_type + " not fully parsed");
  }), n.createSampleGroupCtor("tscl", function(t) {
    f.warn("BoxParser", "Sample Group type: " + this.grouping_type + " not fully parsed");
  }), n.createSampleGroupCtor("vipr", function(t) {
    f.warn("BoxParser", "Sample Group type: " + this.grouping_type + " not fully parsed");
  }), n.createFullBoxCtor("sbgp", "SampleToGroupBox", function(t) {
    this.grouping_type = t.readString(4), this.version === 1 ? this.grouping_type_parameter = t.readUint32() : this.grouping_type_parameter = 0, this.entries = [];
    for (var e = t.readUint32(), r = 0; r < e; r++) {
      var s = {};
      this.entries.push(s), s.sample_count = t.readInt32(), s.group_description_index = t.readInt32();
    }
  });
  function G(t, e) {
    this.bad_pixel_row = t, this.bad_pixel_column = e;
  }
  G.prototype.toString = function() {
    return "[row: " + this.bad_pixel_row + ", column: " + this.bad_pixel_column + "]";
  }, n.createFullBoxCtor("sbpm", "SensorBadPixelsMapBox", function(t) {
    var e;
    for (this.component_count = t.readUint16(), this.component_index = [], e = 0; e < this.component_count; e++)
      this.component_index.push(t.readUint16());
    var r = t.readUint8();
    for (this.correction_applied = (r & 128) == 128, this.num_bad_rows = t.readUint32(), this.num_bad_cols = t.readUint32(), this.num_bad_pixels = t.readUint32(), this.bad_rows = [], this.bad_columns = [], this.bad_pixels = [], e = 0; e < this.num_bad_rows; e++)
      this.bad_rows.push(t.readUint32());
    for (e = 0; e < this.num_bad_cols; e++)
      this.bad_columns.push(t.readUint32());
    for (e = 0; e < this.num_bad_pixels; e++) {
      var s = t.readUint32(), o = t.readUint32();
      this.bad_pixels.push(new G(s, o));
    }
  }), n.createFullBoxCtor("schm", "SchemeTypeBox", function(t) {
    this.scheme_type = t.readString(4), this.scheme_version = t.readUint32(), this.flags & 1 && (this.scheme_uri = t.readString(this.size - this.hdr_size - 8));
  }), n.createBoxCtor("sdp ", "rtptracksdphintinformation", function(t) {
    this.sdptext = t.readString(this.size - this.hdr_size);
  }), n.createFullBoxCtor("sdtp", "SampleDependencyTypeBox", function(t) {
    var e, r = this.size - this.hdr_size;
    this.is_leading = [], this.sample_depends_on = [], this.sample_is_depended_on = [], this.sample_has_redundancy = [];
    for (var s = 0; s < r; s++)
      e = t.readUint8(), this.is_leading[s] = e >> 6, this.sample_depends_on[s] = e >> 4 & 3, this.sample_is_depended_on[s] = e >> 2 & 3, this.sample_has_redundancy[s] = e & 3;
  }), n.createFullBoxCtor(
    "senc",
    "SampleEncryptionBox"
    /*, function(stream) {
    	this.parseFullHeader(stream);
    	var sample_count = stream.readUint32();
    	this.samples = [];
    	for (var i = 0; i < sample_count; i++) {
    		var sample = {};
    		// tenc.default_Per_Sample_IV_Size or seig.Per_Sample_IV_Size
    		sample.InitializationVector = this.readUint8Array(Per_Sample_IV_Size*8);
    		if (this.flags & 0x2) {
    			sample.subsamples = [];
    			subsample_count = stream.readUint16();
    			for (var j = 0; j < subsample_count; j++) {
    				var subsample = {};
    				subsample.BytesOfClearData = stream.readUint16();
    				subsample.BytesOfProtectedData = stream.readUint32();
    				sample.subsamples.push(subsample);
    			}
    		}
    		// TODO
    		this.samples.push(sample);
    	}
    }*/
  ), n.createFullBoxCtor("sgpd", "SampleGroupDescriptionBox", function(t) {
    this.grouping_type = t.readString(4), f.debug("BoxParser", "Found Sample Groups of type " + this.grouping_type), this.version === 1 ? this.default_length = t.readUint32() : this.default_length = 0, this.version >= 2 && (this.default_group_description_index = t.readUint32()), this.entries = [];
    for (var e = t.readUint32(), r = 0; r < e; r++) {
      var s;
      n[this.grouping_type + "SampleGroupEntry"] ? s = new n[this.grouping_type + "SampleGroupEntry"](this.grouping_type) : s = new n.SampleGroupEntry(this.grouping_type), this.entries.push(s), this.version === 1 ? this.default_length === 0 ? s.description_length = t.readUint32() : s.description_length = this.default_length : s.description_length = this.default_length, s.write === n.SampleGroupEntry.prototype.write && (f.info("BoxParser", "SampleGroup for type " + this.grouping_type + " writing not yet implemented, keeping unparsed data in memory for later write"), s.data = t.readUint8Array(s.description_length), t.position -= s.description_length), s.parse(t);
    }
  }), n.createFullBoxCtor("sidx", "CompressedSegmentIndexBox", function(t) {
    this.reference_ID = t.readUint32(), this.timescale = t.readUint32(), this.version === 0 ? (this.earliest_presentation_time = t.readUint32(), this.first_offset = t.readUint32()) : (this.earliest_presentation_time = t.readUint64(), this.first_offset = t.readUint64()), t.readUint16(), this.references = [];
    for (var e = t.readUint16(), r = 0; r < e; r++) {
      var s = {};
      this.references.push(s);
      var o = t.readUint32();
      s.reference_type = o >> 31 & 1, s.referenced_size = o & 2147483647, s.subsegment_duration = t.readUint32(), o = t.readUint32(), s.starts_with_SAP = o >> 31 & 1, s.SAP_type = o >> 28 & 7, s.SAP_delta_time = o & 268435455;
    }
  }), n.SingleItemTypeReferenceBox = function(t, e, r, s) {
    n.Box.call(this, t, e), this.hdr_size = r, this.start = s;
  }, n.SingleItemTypeReferenceBox.prototype = new n.Box(), n.SingleItemTypeReferenceBox.prototype.parse = function(t) {
    this.from_item_ID = t.readUint16();
    var e = t.readUint16();
    this.references = [];
    for (var r = 0; r < e; r++)
      this.references[r] = {}, this.references[r].to_item_ID = t.readUint16();
  }, n.SingleItemTypeReferenceBoxLarge = function(t, e, r, s) {
    n.Box.call(this, t, e), this.hdr_size = r, this.start = s;
  }, n.SingleItemTypeReferenceBoxLarge.prototype = new n.Box(), n.SingleItemTypeReferenceBoxLarge.prototype.parse = function(t) {
    this.from_item_ID = t.readUint32();
    var e = t.readUint16();
    this.references = [];
    for (var r = 0; r < e; r++)
      this.references[r] = {}, this.references[r].to_item_ID = t.readUint32();
  }, n.createFullBoxCtor("SmDm", "SMPTE2086MasteringDisplayMetadataBox", function(t) {
    this.primaryRChromaticity_x = t.readUint16(), this.primaryRChromaticity_y = t.readUint16(), this.primaryGChromaticity_x = t.readUint16(), this.primaryGChromaticity_y = t.readUint16(), this.primaryBChromaticity_x = t.readUint16(), this.primaryBChromaticity_y = t.readUint16(), this.whitePointChromaticity_x = t.readUint16(), this.whitePointChromaticity_y = t.readUint16(), this.luminanceMax = t.readUint32(), this.luminanceMin = t.readUint32();
  }), n.createFullBoxCtor("smhd", "SoundMediaHeaderBox", function(t) {
    this.balance = t.readUint16(), t.readUint16();
  }), n.createFullBoxCtor("ssix", "CompressedSubsegmentIndexBox", function(t) {
    this.subsegments = [];
    for (var e = t.readUint32(), r = 0; r < e; r++) {
      var s = {};
      this.subsegments.push(s), s.ranges = [];
      for (var o = t.readUint32(), a = 0; a < o; a++) {
        var h = {};
        s.ranges.push(h), h.level = t.readUint8(), h.range_size = t.readUint24();
      }
    }
  }), n.createFullBoxCtor("stco", "ChunkOffsetBox", function(t) {
    var e;
    if (e = t.readUint32(), this.chunk_offsets = [], this.version === 0)
      for (var r = 0; r < e; r++)
        this.chunk_offsets.push(t.readUint32());
  }), n.createFullBoxCtor("stdp", "DegradationPriorityBox", function(t) {
    var e = (this.size - this.hdr_size) / 2;
    this.priority = [];
    for (var r = 0; r < e; r++)
      this.priority[r] = t.readUint16();
  }), n.createFullBoxCtor("sthd", "SubtitleMediaHeaderBox"), n.createFullBoxCtor("stri", "SubTrackInformationBox", function(t) {
    this.switch_group = t.readUint16(), this.alternate_group = t.readUint16(), this.sub_track_id = t.readUint32();
    var e = (this.size - this.hdr_size - 8) / 4;
    this.attribute_list = [];
    for (var r = 0; r < e; r++)
      this.attribute_list[r] = t.readUint32();
  }), n.createFullBoxCtor("stsc", "SampleToChunkBox", function(t) {
    var e, r;
    if (e = t.readUint32(), this.first_chunk = [], this.samples_per_chunk = [], this.sample_description_index = [], this.version === 0)
      for (r = 0; r < e; r++)
        this.first_chunk.push(t.readUint32()), this.samples_per_chunk.push(t.readUint32()), this.sample_description_index.push(t.readUint32());
  }), n.createFullBoxCtor("stsd", "SampleDescriptionBox", function(t) {
    var e, r, s, o;
    for (this.entries = [], s = t.readUint32(), e = 1; e <= s; e++)
      if (r = n.parseOneBox(t, !0, this.size - (t.getPosition() - this.start)), r.code === n.OK)
        n[r.type + "SampleEntry"] ? (o = new n[r.type + "SampleEntry"](r.size), o.hdr_size = r.hdr_size, o.start = r.start) : (f.warn("BoxParser", "Unknown sample entry type: " + r.type), o = new n.SampleEntry(r.type, r.size, r.hdr_size, r.start)), o.write === n.SampleEntry.prototype.write && (f.info("BoxParser", "SampleEntry " + o.type + " box writing not yet implemented, keeping unparsed data in memory for later write"), o.parseDataAndRewind(t)), o.parse(t), this.entries.push(o);
      else
        return;
  }), n.createFullBoxCtor("stsg", "SubTrackSampleGroupBox", function(t) {
    this.grouping_type = t.readUint32();
    var e = t.readUint16();
    this.group_description_index = [];
    for (var r = 0; r < e; r++)
      this.group_description_index[r] = t.readUint32();
  }), n.createFullBoxCtor("stsh", "ShadowSyncSampleBox", function(t) {
    var e, r;
    if (e = t.readUint32(), this.shadowed_sample_numbers = [], this.sync_sample_numbers = [], this.version === 0)
      for (r = 0; r < e; r++)
        this.shadowed_sample_numbers.push(t.readUint32()), this.sync_sample_numbers.push(t.readUint32());
  }), n.createFullBoxCtor("stss", "SyncSampleBox", function(t) {
    var e, r;
    if (r = t.readUint32(), this.version === 0)
      for (this.sample_numbers = [], e = 0; e < r; e++)
        this.sample_numbers.push(t.readUint32());
  }), n.createFullBoxCtor("stsz", "SampleSizeBox", function(t) {
    var e;
    if (this.sample_sizes = [], this.version === 0)
      for (this.sample_size = t.readUint32(), this.sample_count = t.readUint32(), e = 0; e < this.sample_count; e++)
        this.sample_size === 0 ? this.sample_sizes.push(t.readUint32()) : this.sample_sizes[e] = this.sample_size;
  }), n.createFullBoxCtor("stts", "TimeToSampleBox", function(t) {
    var e, r, s;
    if (e = t.readUint32(), this.sample_counts = [], this.sample_deltas = [], this.version === 0)
      for (r = 0; r < e; r++)
        this.sample_counts.push(t.readUint32()), s = t.readInt32(), s < 0 && (f.warn("BoxParser", "File uses negative stts sample delta, using value 1 instead, sync may be lost!"), s = 1), this.sample_deltas.push(s);
  }), n.createFullBoxCtor("stvi", "StereoVideoBox", function(t) {
    var e = t.readUint32();
    this.single_view_allowed = e & 3, this.stereo_scheme = t.readUint32();
    var r = t.readUint32();
    this.stereo_indication_type = t.readString(r);
    var s, o;
    for (this.boxes = []; t.getPosition() < this.start + this.size; )
      if (s = n.parseOneBox(t, !1, this.size - (t.getPosition() - this.start)), s.code === n.OK)
        o = s.box, this.boxes.push(o), this[o.type] = o;
      else
        return;
  }), n.createBoxCtor("styp", "SegmentTypeBox", function(t) {
    n.ftypBox.prototype.parse.call(this, t);
  }), n.createFullBoxCtor("stz2", "CompactSampleSizeBox", function(t) {
    var e, r;
    if (this.sample_sizes = [], this.version === 0)
      if (this.reserved = t.readUint24(), this.field_size = t.readUint8(), r = t.readUint32(), this.field_size === 4)
        for (e = 0; e < r; e += 2) {
          var s = t.readUint8();
          this.sample_sizes[e] = s >> 4 & 15, this.sample_sizes[e + 1] = s & 15;
        }
      else if (this.field_size === 8)
        for (e = 0; e < r; e++)
          this.sample_sizes[e] = t.readUint8();
      else if (this.field_size === 16)
        for (e = 0; e < r; e++)
          this.sample_sizes[e] = t.readUint16();
      else
        f.error("BoxParser", "Error in length field in stz2 box");
  }), n.createFullBoxCtor("subs", "SubSampleInformationBox", function(t) {
    var e, r, s, o;
    for (s = t.readUint32(), this.entries = [], e = 0; e < s; e++) {
      var a = {};
      if (this.entries[e] = a, a.sample_delta = t.readUint32(), a.subsamples = [], o = t.readUint16(), o > 0)
        for (r = 0; r < o; r++) {
          var h = {};
          a.subsamples.push(h), this.version == 1 ? h.size = t.readUint32() : h.size = t.readUint16(), h.priority = t.readUint8(), h.discardable = t.readUint8(), h.codec_specific_parameters = t.readUint32();
        }
    }
  }), n.createFullBoxCtor("tenc", "TrackEncryptionBox", function(t) {
    if (t.readUint8(), this.version === 0)
      t.readUint8();
    else {
      var e = t.readUint8();
      this.default_crypt_byte_block = e >> 4 & 15, this.default_skip_byte_block = e & 15;
    }
    this.default_isProtected = t.readUint8(), this.default_Per_Sample_IV_Size = t.readUint8(), this.default_KID = n.parseHex16(t), this.default_isProtected === 1 && this.default_Per_Sample_IV_Size === 0 && (this.default_constant_IV_size = t.readUint8(), this.default_constant_IV = t.readUint8Array(this.default_constant_IV_size));
  }), n.createFullBoxCtor("tfdt", "TrackFragmentBaseMediaDecodeTimeBox", function(t) {
    this.version == 1 ? this.baseMediaDecodeTime = t.readUint64() : this.baseMediaDecodeTime = t.readUint32();
  }), n.createFullBoxCtor("tfhd", "TrackFragmentHeaderBox", function(t) {
    var e = 0;
    this.track_id = t.readUint32(), this.size - this.hdr_size > e && this.flags & n.TFHD_FLAG_BASE_DATA_OFFSET ? (this.base_data_offset = t.readUint64(), e += 8) : this.base_data_offset = 0, this.size - this.hdr_size > e && this.flags & n.TFHD_FLAG_SAMPLE_DESC ? (this.default_sample_description_index = t.readUint32(), e += 4) : this.default_sample_description_index = 0, this.size - this.hdr_size > e && this.flags & n.TFHD_FLAG_SAMPLE_DUR ? (this.default_sample_duration = t.readUint32(), e += 4) : this.default_sample_duration = 0, this.size - this.hdr_size > e && this.flags & n.TFHD_FLAG_SAMPLE_SIZE ? (this.default_sample_size = t.readUint32(), e += 4) : this.default_sample_size = 0, this.size - this.hdr_size > e && this.flags & n.TFHD_FLAG_SAMPLE_FLAGS ? (this.default_sample_flags = t.readUint32(), e += 4) : this.default_sample_flags = 0;
  }), n.createFullBoxCtor("tfra", "TrackFragmentRandomAccessBox", function(t) {
    this.track_ID = t.readUint32(), t.readUint24();
    var e = t.readUint8();
    this.length_size_of_traf_num = e >> 4 & 3, this.length_size_of_trun_num = e >> 2 & 3, this.length_size_of_sample_num = e & 3, this.entries = [];
    for (var r = t.readUint32(), s = 0; s < r; s++)
      this.version === 1 ? (this.time = t.readUint64(), this.moof_offset = t.readUint64()) : (this.time = t.readUint32(), this.moof_offset = t.readUint32()), this.traf_number = t["readUint" + 8 * (this.length_size_of_traf_num + 1)](), this.trun_number = t["readUint" + 8 * (this.length_size_of_trun_num + 1)](), this.sample_number = t["readUint" + 8 * (this.length_size_of_sample_num + 1)]();
  }), n.createFullBoxCtor("tkhd", "TrackHeaderBox", function(t) {
    this.version == 1 ? (this.creation_time = t.readUint64(), this.modification_time = t.readUint64(), this.track_id = t.readUint32(), t.readUint32(), this.duration = t.readUint64()) : (this.creation_time = t.readUint32(), this.modification_time = t.readUint32(), this.track_id = t.readUint32(), t.readUint32(), this.duration = t.readUint32()), t.readUint32Array(2), this.layer = t.readInt16(), this.alternate_group = t.readInt16(), this.volume = t.readInt16() >> 8, t.readUint16(), this.matrix = t.readInt32Array(9), this.width = t.readUint32(), this.height = t.readUint32();
  }), n.createBoxCtor("tmax", "hintmaxrelativetime", function(t) {
    this.time = t.readUint32();
  }), n.createBoxCtor("tmin", "hintminrelativetime", function(t) {
    this.time = t.readUint32();
  }), n.createBoxCtor("totl", "hintBytesSent", function(t) {
    this.bytessent = t.readUint32();
  }), n.createBoxCtor("tpay", "hintBytesSent", function(t) {
    this.bytessent = t.readUint32();
  }), n.createBoxCtor("tpyl", "hintBytesSent", function(t) {
    this.bytessent = t.readUint64();
  }), n.TrackGroupTypeBox.prototype.parse = function(t) {
    this.parseFullHeader(t), this.track_group_id = t.readUint32();
  }, n.createTrackGroupCtor("msrc"), n.TrackReferenceTypeBox = function(t, e, r, s) {
    n.Box.call(this, t, e), this.hdr_size = r, this.start = s;
  }, n.TrackReferenceTypeBox.prototype = new n.Box(), n.TrackReferenceTypeBox.prototype.parse = function(t) {
    this.track_ids = t.readUint32Array((this.size - this.hdr_size) / 4);
  }, n.trefBox.prototype.parse = function(t) {
    for (var e, r; t.getPosition() < this.start + this.size; )
      if (e = n.parseOneBox(t, !0, this.size - (t.getPosition() - this.start)), e.code === n.OK)
        r = new n.TrackReferenceTypeBox(e.type, e.size, e.hdr_size, e.start), r.write === n.Box.prototype.write && r.type !== "mdat" && (f.info("BoxParser", "TrackReference " + r.type + " box writing not yet implemented, keeping unparsed data in memory for later write"), r.parseDataAndRewind(t)), r.parse(t), this.boxes.push(r);
      else
        return;
  }, n.createFullBoxCtor("trep", "TrackExtensionPropertiesBox", function(t) {
    for (this.track_ID = t.readUint32(), this.boxes = []; t.getPosition() < this.start + this.size; )
      if (ret = n.parseOneBox(t, !1, this.size - (t.getPosition() - this.start)), ret.code === n.OK)
        box = ret.box, this.boxes.push(box);
      else
        return;
  }), n.createFullBoxCtor("trex", "TrackExtendsBox", function(t) {
    this.track_id = t.readUint32(), this.default_sample_description_index = t.readUint32(), this.default_sample_duration = t.readUint32(), this.default_sample_size = t.readUint32(), this.default_sample_flags = t.readUint32();
  }), n.createBoxCtor("trpy", "hintBytesSent", function(t) {
    this.bytessent = t.readUint64();
  }), n.createFullBoxCtor("trun", "TrackRunBox", function(t) {
    var e = 0;
    if (this.sample_count = t.readUint32(), e += 4, this.size - this.hdr_size > e && this.flags & n.TRUN_FLAGS_DATA_OFFSET ? (this.data_offset = t.readInt32(), e += 4) : this.data_offset = 0, this.size - this.hdr_size > e && this.flags & n.TRUN_FLAGS_FIRST_FLAG ? (this.first_sample_flags = t.readUint32(), e += 4) : this.first_sample_flags = 0, this.sample_duration = [], this.sample_size = [], this.sample_flags = [], this.sample_composition_time_offset = [], this.size - this.hdr_size > e)
      for (var r = 0; r < this.sample_count; r++)
        this.flags & n.TRUN_FLAGS_DURATION && (this.sample_duration[r] = t.readUint32()), this.flags & n.TRUN_FLAGS_SIZE && (this.sample_size[r] = t.readUint32()), this.flags & n.TRUN_FLAGS_FLAGS && (this.sample_flags[r] = t.readUint32()), this.flags & n.TRUN_FLAGS_CTS_OFFSET && (this.version === 0 ? this.sample_composition_time_offset[r] = t.readUint32() : this.sample_composition_time_offset[r] = t.readInt32());
  }), n.createFullBoxCtor("tsel", "TrackSelectionBox", function(t) {
    this.switch_group = t.readUint32();
    var e = (this.size - this.hdr_size - 4) / 4;
    this.attribute_list = [];
    for (var r = 0; r < e; r++)
      this.attribute_list[r] = t.readUint32();
  }), n.createFullBoxCtor("txtC", "TextConfigBox", function(t) {
    this.config = t.readCString();
  }), n.createBoxCtor("tyco", "TypeCombinationBox", function(t) {
    var e = (this.size - this.hdr_size) / 4;
    this.compatible_brands = [];
    for (var r = 0; r < e; r++)
      this.compatible_brands[r] = t.readString(4);
  }), n.createFullBoxCtor("udes", "UserDescriptionProperty", function(t) {
    this.lang = t.readCString(), this.name = t.readCString(), this.description = t.readCString(), this.tags = t.readCString();
  }), n.createFullBoxCtor("uncC", "UncompressedFrameConfigBox", function(t) {
    var e;
    if (this.profile = t.readString(4), this.version != 1) {
      if (this.version == 0) {
        for (this.component_count = t.readUint32(), this.component_index = [], this.component_bit_depth_minus_one = [], this.component_format = [], this.component_align_size = [], e = 0; e < this.component_count; e++)
          this.component_index.push(t.readUint16()), this.component_bit_depth_minus_one.push(t.readUint8()), this.component_format.push(t.readUint8()), this.component_align_size.push(t.readUint8());
        this.sampling_type = t.readUint8(), this.interleave_type = t.readUint8(), this.block_size = t.readUint8();
        var r = t.readUint8();
        this.component_little_endian = r >> 7 & 1, this.block_pad_lsb = r >> 6 & 1, this.block_little_endian = r >> 5 & 1, this.block_reversed = r >> 4 & 1, this.pad_unknown = r >> 3 & 1, this.pixel_size = t.readUint32(), this.row_align_size = t.readUint32(), this.tile_align_size = t.readUint32(), this.num_tile_cols_minus_one = t.readUint32(), this.num_tile_rows_minus_one = t.readUint32();
      }
    }
  }), n.createFullBoxCtor("url ", "DataEntryUrlBox", function(t) {
    this.flags !== 1 && (this.location = t.readCString());
  }), n.createFullBoxCtor("urn ", "DataEntryUrnBox", function(t) {
    this.name = t.readCString(), this.size - this.hdr_size - this.name.length - 1 > 0 && (this.location = t.readCString());
  }), n.createUUIDBox("a5d40b30e81411ddba2f0800200c9a66", "LiveServerManifestBox", !0, !1, function(t) {
    this.LiveServerManifest = t.readString(this.size - this.hdr_size).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#039;");
  }), n.createUUIDBox("d08a4f1810f34a82b6c832d8aba183d3", "PiffProtectionSystemSpecificHeaderBox", !0, !1, function(t) {
    this.system_id = n.parseHex16(t);
    var e = t.readUint32();
    e > 0 && (this.data = t.readUint8Array(e));
  }), n.createUUIDBox(
    "a2394f525a9b4f14a2446c427c648df4",
    "PiffSampleEncryptionBox",
    !0,
    !1
    /*, function(stream) {
    	if (this.flags & 0x1) {
    		this.AlgorithmID = stream.readUint24();
    		this.IV_size = stream.readUint8();
    		this.KID = BoxParser.parseHex16(stream);
    	}
    	var sample_count = stream.readUint32();
    	this.samples = [];
    	for (var i = 0; i < sample_count; i++) {
    		var sample = {};
    		sample.InitializationVector = this.readUint8Array(this.IV_size*8);
    		if (this.flags & 0x2) {
    			sample.subsamples = [];
    			sample.NumberOfEntries = stream.readUint16();
    			for (var j = 0; j < sample.NumberOfEntries; j++) {
    				var subsample = {};
    				subsample.BytesOfClearData = stream.readUint16();
    				subsample.BytesOfProtectedData = stream.readUint32();
    				sample.subsamples.push(subsample);
    			}
    		}
    		this.samples.push(sample);
    	}
    }*/
  ), n.createUUIDBox("8974dbce7be74c5184f97148f9882554", "PiffTrackEncryptionBox", !0, !1, function(t) {
    this.default_AlgorithmID = t.readUint24(), this.default_IV_size = t.readUint8(), this.default_KID = n.parseHex16(t);
  }), n.createUUIDBox("d4807ef2ca3946958e5426cb9e46a79f", "TfrfBox", !0, !1, function(t) {
    this.fragment_count = t.readUint8(), this.entries = [];
    for (var e = 0; e < this.fragment_count; e++) {
      var r = {}, s = 0, o = 0;
      this.version === 1 ? (s = t.readUint64(), o = t.readUint64()) : (s = t.readUint32(), o = t.readUint32()), r.absolute_time = s, r.absolute_duration = o, this.entries.push(r);
    }
  }), n.createUUIDBox("6d1d9b0542d544e680e2141daff757b2", "TfxdBox", !0, !1, function(t) {
    this.version === 1 ? (this.absolute_time = t.readUint64(), this.duration = t.readUint64()) : (this.absolute_time = t.readUint32(), this.duration = t.readUint32());
  }), n.createFullBoxCtor("vmhd", "VideoMediaHeaderBox", function(t) {
    this.graphicsmode = t.readUint16(), this.opcolor = t.readUint16Array(3);
  }), n.createFullBoxCtor("vpcC", "VPCodecConfigurationRecord", function(t) {
    var e;
    this.version === 1 ? (this.profile = t.readUint8(), this.level = t.readUint8(), e = t.readUint8(), this.bitDepth = e >> 4, this.chromaSubsampling = e >> 1 & 7, this.videoFullRangeFlag = e & 1, this.colourPrimaries = t.readUint8(), this.transferCharacteristics = t.readUint8(), this.matrixCoefficients = t.readUint8(), this.codecIntializationDataSize = t.readUint16(), this.codecIntializationData = t.readUint8Array(this.codecIntializationDataSize)) : (this.profile = t.readUint8(), this.level = t.readUint8(), e = t.readUint8(), this.bitDepth = e >> 4 & 15, this.colorSpace = e & 15, e = t.readUint8(), this.chromaSubsampling = e >> 4 & 15, this.transferFunction = e >> 1 & 7, this.videoFullRangeFlag = e & 1, this.codecIntializationDataSize = t.readUint16(), this.codecIntializationData = t.readUint8Array(this.codecIntializationDataSize));
  }), n.createBoxCtor("vttC", "WebVTTConfigurationBox", function(t) {
    this.text = t.readString(this.size - this.hdr_size);
  }), n.createFullBoxCtor("vvcC", "VvcConfigurationBox", function(t) {
    var e, r, s = {
      held_bits: void 0,
      num_held_bits: 0,
      stream_read_1_bytes: function(m) {
        this.held_bits = m.readUint8(), this.num_held_bits = 8;
      },
      stream_read_2_bytes: function(m) {
        this.held_bits = m.readUint16(), this.num_held_bits = 16;
      },
      extract_bits: function(m) {
        var w = this.held_bits >> this.num_held_bits - m & (1 << m) - 1;
        return this.num_held_bits -= m, w;
      }
    };
    if (s.stream_read_1_bytes(t), s.extract_bits(5), this.lengthSizeMinusOne = s.extract_bits(2), this.ptl_present_flag = s.extract_bits(1), this.ptl_present_flag) {
      s.stream_read_2_bytes(t), this.ols_idx = s.extract_bits(9), this.num_sublayers = s.extract_bits(3), this.constant_frame_rate = s.extract_bits(2), this.chroma_format_idc = s.extract_bits(2), s.stream_read_1_bytes(t), this.bit_depth_minus8 = s.extract_bits(3), s.extract_bits(5);
      {
        if (s.stream_read_2_bytes(t), s.extract_bits(2), this.num_bytes_constraint_info = s.extract_bits(6), this.general_profile_idc = s.extract_bits(7), this.general_tier_flag = s.extract_bits(1), this.general_level_idc = t.readUint8(), s.stream_read_1_bytes(t), this.ptl_frame_only_constraint_flag = s.extract_bits(1), this.ptl_multilayer_enabled_flag = s.extract_bits(1), this.general_constraint_info = new Uint8Array(this.num_bytes_constraint_info), this.num_bytes_constraint_info) {
          for (e = 0; e < this.num_bytes_constraint_info - 1; e++) {
            var o = s.extract_bits(6);
            s.stream_read_1_bytes(t);
            var a = s.extract_bits(2);
            this.general_constraint_info[e] = o << 2 | a;
          }
          this.general_constraint_info[this.num_bytes_constraint_info - 1] = s.extract_bits(6);
        } else
          s.extract_bits(6);
        if (this.num_sublayers > 1) {
          for (s.stream_read_1_bytes(t), this.ptl_sublayer_present_mask = 0, r = this.num_sublayers - 2; r >= 0; --r) {
            var h = s.extract_bits(1);
            this.ptl_sublayer_present_mask |= h << r;
          }
          for (r = this.num_sublayers; r <= 8 && this.num_sublayers > 1; ++r)
            s.extract_bits(1);
          for (this.sublayer_level_idc = [], r = this.num_sublayers - 2; r >= 0; --r)
            this.ptl_sublayer_present_mask & 1 << r && (this.sublayer_level_idc[r] = t.readUint8());
        }
        if (this.ptl_num_sub_profiles = t.readUint8(), this.general_sub_profile_idc = [], this.ptl_num_sub_profiles)
          for (e = 0; e < this.ptl_num_sub_profiles; e++)
            this.general_sub_profile_idc.push(t.readUint32());
      }
      this.max_picture_width = t.readUint16(), this.max_picture_height = t.readUint16(), this.avg_frame_rate = t.readUint16();
    }
    var d = 12, p = 13;
    this.nalu_arrays = [];
    var u = t.readUint8();
    for (e = 0; e < u; e++) {
      var c = [];
      this.nalu_arrays.push(c), s.stream_read_1_bytes(t), c.completeness = s.extract_bits(1), s.extract_bits(2), c.nalu_type = s.extract_bits(5);
      var y = 1;
      for (c.nalu_type != p && c.nalu_type != d && (y = t.readUint16()), r = 0; r < y; r++) {
        var x = t.readUint16();
        c.push({
          data: t.readUint8Array(x),
          length: x
        });
      }
    }
  }), n.createFullBoxCtor("vvnC", "VvcNALUConfigBox", function(t) {
    var e = strm.readUint8();
    this.lengthSizeMinusOne = e & 3;
  }), n.SampleEntry.prototype.isVideo = function() {
    return !1;
  }, n.SampleEntry.prototype.isAudio = function() {
    return !1;
  }, n.SampleEntry.prototype.isSubtitle = function() {
    return !1;
  }, n.SampleEntry.prototype.isMetadata = function() {
    return !1;
  }, n.SampleEntry.prototype.isHint = function() {
    return !1;
  }, n.SampleEntry.prototype.getCodec = function() {
    return this.type.replace(".", "");
  }, n.SampleEntry.prototype.getWidth = function() {
    return "";
  }, n.SampleEntry.prototype.getHeight = function() {
    return "";
  }, n.SampleEntry.prototype.getChannelCount = function() {
    return "";
  }, n.SampleEntry.prototype.getSampleRate = function() {
    return "";
  }, n.SampleEntry.prototype.getSampleSize = function() {
    return "";
  }, n.VisualSampleEntry.prototype.isVideo = function() {
    return !0;
  }, n.VisualSampleEntry.prototype.getWidth = function() {
    return this.width;
  }, n.VisualSampleEntry.prototype.getHeight = function() {
    return this.height;
  }, n.AudioSampleEntry.prototype.isAudio = function() {
    return !0;
  }, n.AudioSampleEntry.prototype.getChannelCount = function() {
    return this.channel_count;
  }, n.AudioSampleEntry.prototype.getSampleRate = function() {
    return this.samplerate;
  }, n.AudioSampleEntry.prototype.getSampleSize = function() {
    return this.samplesize;
  }, n.SubtitleSampleEntry.prototype.isSubtitle = function() {
    return !0;
  }, n.MetadataSampleEntry.prototype.isMetadata = function() {
    return !0;
  }, n.decimalToHex = function(t, e) {
    var r = Number(t).toString(16);
    for (e = typeof e > "u" || e === null ? e = 2 : e; r.length < e; )
      r = "0" + r;
    return r;
  }, n.avc1SampleEntry.prototype.getCodec = n.avc2SampleEntry.prototype.getCodec = n.avc3SampleEntry.prototype.getCodec = n.avc4SampleEntry.prototype.getCodec = function() {
    var t = n.SampleEntry.prototype.getCodec.call(this);
    return this.avcC ? t + "." + n.decimalToHex(this.avcC.AVCProfileIndication) + n.decimalToHex(this.avcC.profile_compatibility) + n.decimalToHex(this.avcC.AVCLevelIndication) : t;
  }, n.hev1SampleEntry.prototype.getCodec = n.hvc1SampleEntry.prototype.getCodec = function() {
    var t, e = n.SampleEntry.prototype.getCodec.call(this);
    if (this.hvcC) {
      switch (e += ".", this.hvcC.general_profile_space) {
        case 0:
          e += "";
          break;
        case 1:
          e += "A";
          break;
        case 2:
          e += "B";
          break;
        case 3:
          e += "C";
          break;
      }
      e += this.hvcC.general_profile_idc, e += ".";
      var r = this.hvcC.general_profile_compatibility, s = 0;
      for (t = 0; t < 32 && (s |= r & 1, t != 31); t++)
        s <<= 1, r >>= 1;
      e += n.decimalToHex(s, 0), e += ".", this.hvcC.general_tier_flag === 0 ? e += "L" : e += "H", e += this.hvcC.general_level_idc;
      var o = !1, a = "";
      for (t = 5; t >= 0; t--)
        (this.hvcC.general_constraint_indicator[t] || o) && (a = "." + n.decimalToHex(this.hvcC.general_constraint_indicator[t], 0) + a, o = !0);
      e += a;
    }
    return e;
  }, n.vvc1SampleEntry.prototype.getCodec = n.vvi1SampleEntry.prototype.getCodec = function() {
    var t, e = n.SampleEntry.prototype.getCodec.call(this);
    if (this.vvcC) {
      e += "." + this.vvcC.general_profile_idc, this.vvcC.general_tier_flag ? e += ".H" : e += ".L", e += this.vvcC.general_level_idc;
      var r = "";
      if (this.vvcC.general_constraint_info) {
        var s = [], o = 0;
        o |= this.vvcC.ptl_frame_only_constraint << 7, o |= this.vvcC.ptl_multilayer_enabled << 6;
        var a;
        for (t = 0; t < this.vvcC.general_constraint_info.length; ++t)
          o |= this.vvcC.general_constraint_info[t] >> 2 & 63, s.push(o), o && (a = t), o = this.vvcC.general_constraint_info[t] >> 2 & 3;
        if (a === void 0)
          r = ".CA";
        else {
          r = ".C";
          var h = "ABCDEFGHIJKLMNOPQRSTUVWXYZ234567", d = 0, p = 0;
          for (t = 0; t <= a; ++t)
            for (d = d << 8 | s[t], p += 8; p >= 5; ) {
              var u = d >> p - 5 & 31;
              r += h[u], p -= 5, d &= (1 << p) - 1;
            }
          p && (d <<= 5 - p, r += h[d & 31]);
        }
      }
      e += r;
    }
    return e;
  }, n.mp4aSampleEntry.prototype.getCodec = function() {
    var t = n.SampleEntry.prototype.getCodec.call(this);
    if (this.esds && this.esds.esd) {
      var e = this.esds.esd.getOTI(), r = this.esds.esd.getAudioConfig();
      return t + "." + n.decimalToHex(e) + (r ? "." + r : "");
    } else
      return t;
  }, n.stxtSampleEntry.prototype.getCodec = function() {
    var t = n.SampleEntry.prototype.getCodec.call(this);
    return this.mime_format ? t + "." + this.mime_format : t;
  }, n.vp08SampleEntry.prototype.getCodec = n.vp09SampleEntry.prototype.getCodec = function() {
    var t = n.SampleEntry.prototype.getCodec.call(this), e = this.vpcC.level;
    e == 0 && (e = "00");
    var r = this.vpcC.bitDepth;
    return r == 8 && (r = "08"), t + ".0" + this.vpcC.profile + "." + e + "." + r;
  }, n.av01SampleEntry.prototype.getCodec = function() {
    var t = n.SampleEntry.prototype.getCodec.call(this), e = this.av1C.seq_level_idx_0;
    e < 10 && (e = "0" + e);
    var r;
    return this.av1C.seq_profile === 2 && this.av1C.high_bitdepth === 1 ? r = this.av1C.twelve_bit === 1 ? "12" : "10" : this.av1C.seq_profile <= 2 && (r = this.av1C.high_bitdepth === 1 ? "10" : "08"), t + "." + this.av1C.seq_profile + "." + e + (this.av1C.seq_tier_0 ? "H" : "M") + "." + r;
  }, n.Box.prototype.writeHeader = function(t, e) {
    this.size += 8, this.size > B && (this.size += 8), this.type === "uuid" && (this.size += 16), f.debug("BoxWriter", "Writing box " + this.type + " of size: " + this.size + " at position " + t.getPosition() + (e || "")), this.size > B ? t.writeUint32(1) : (this.sizePosition = t.getPosition(), t.writeUint32(this.size)), t.writeString(this.type, null, 4), this.type === "uuid" && t.writeUint8Array(this.uuid), this.size > B && t.writeUint64(this.size);
  }, n.FullBox.prototype.writeHeader = function(t) {
    this.size += 4, n.Box.prototype.writeHeader.call(this, t, " v=" + this.version + " f=" + this.flags), t.writeUint8(this.version), t.writeUint24(this.flags);
  }, n.Box.prototype.write = function(t) {
    this.type === "mdat" ? this.data && (this.size = this.data.length, this.writeHeader(t), t.writeUint8Array(this.data)) : (this.size = this.data ? this.data.length : 0, this.writeHeader(t), this.data && t.writeUint8Array(this.data));
  }, n.ContainerBox.prototype.write = function(t) {
    this.size = 0, this.writeHeader(t);
    for (var e = 0; e < this.boxes.length; e++)
      this.boxes[e] && (this.boxes[e].write(t), this.size += this.boxes[e].size);
    f.debug("BoxWriter", "Adjusting box " + this.type + " with new size " + this.size), t.adjustUint32(this.sizePosition, this.size);
  }, n.TrackReferenceTypeBox.prototype.write = function(t) {
    this.size = this.track_ids.length * 4, this.writeHeader(t), t.writeUint32Array(this.track_ids);
  }, n.avcCBox.prototype.write = function(t) {
    var e;
    for (this.size = 7, e = 0; e < this.SPS.length; e++)
      this.size += 2 + this.SPS[e].length;
    for (e = 0; e < this.PPS.length; e++)
      this.size += 2 + this.PPS[e].length;
    for (this.ext && (this.size += this.ext.length), this.writeHeader(t), t.writeUint8(this.configurationVersion), t.writeUint8(this.AVCProfileIndication), t.writeUint8(this.profile_compatibility), t.writeUint8(this.AVCLevelIndication), t.writeUint8(this.lengthSizeMinusOne + 252), t.writeUint8(this.SPS.length + 224), e = 0; e < this.SPS.length; e++)
      t.writeUint16(this.SPS[e].length), t.writeUint8Array(this.SPS[e].nalu);
    for (t.writeUint8(this.PPS.length), e = 0; e < this.PPS.length; e++)
      t.writeUint16(this.PPS[e].length), t.writeUint8Array(this.PPS[e].nalu);
    this.ext && t.writeUint8Array(this.ext);
  }, n.co64Box.prototype.write = function(t) {
    var e;
    for (this.version = 0, this.flags = 0, this.size = 4 + 8 * this.chunk_offsets.length, this.writeHeader(t), t.writeUint32(this.chunk_offsets.length), e = 0; e < this.chunk_offsets.length; e++)
      t.writeUint64(this.chunk_offsets[e]);
  }, n.cslgBox.prototype.write = function(t) {
    this.version = 0, this.flags = 0, this.size = 4 * 5, this.writeHeader(t), t.writeInt32(this.compositionToDTSShift), t.writeInt32(this.leastDecodeToDisplayDelta), t.writeInt32(this.greatestDecodeToDisplayDelta), t.writeInt32(this.compositionStartTime), t.writeInt32(this.compositionEndTime);
  }, n.cttsBox.prototype.write = function(t) {
    var e;
    for (this.version = 0, this.flags = 0, this.size = 4 + 8 * this.sample_counts.length, this.writeHeader(t), t.writeUint32(this.sample_counts.length), e = 0; e < this.sample_counts.length; e++)
      t.writeUint32(this.sample_counts[e]), this.version === 1 ? t.writeInt32(this.sample_offsets[e]) : t.writeUint32(this.sample_offsets[e]);
  }, n.drefBox.prototype.write = function(t) {
    this.version = 0, this.flags = 0, this.size = 4, this.writeHeader(t), t.writeUint32(this.entries.length);
    for (var e = 0; e < this.entries.length; e++)
      this.entries[e].write(t), this.size += this.entries[e].size;
    f.debug("BoxWriter", "Adjusting box " + this.type + " with new size " + this.size), t.adjustUint32(this.sizePosition, this.size);
  }, n.elngBox.prototype.write = function(t) {
    this.version = 0, this.flags = 0, this.size = this.extended_language.length, this.writeHeader(t), t.writeString(this.extended_language);
  }, n.elstBox.prototype.write = function(t) {
    this.version = 0, this.flags = 0, this.size = 4 + 12 * this.entries.length, this.writeHeader(t), t.writeUint32(this.entries.length);
    for (var e = 0; e < this.entries.length; e++) {
      var r = this.entries[e];
      t.writeUint32(r.segment_duration), t.writeInt32(r.media_time), t.writeInt16(r.media_rate_integer), t.writeInt16(r.media_rate_fraction);
    }
  }, n.emsgBox.prototype.write = function(t) {
    this.version = 0, this.flags = 0, this.size = 4 * 4 + this.message_data.length + (this.scheme_id_uri.length + 1) + (this.value.length + 1), this.writeHeader(t), t.writeCString(this.scheme_id_uri), t.writeCString(this.value), t.writeUint32(this.timescale), t.writeUint32(this.presentation_time_delta), t.writeUint32(this.event_duration), t.writeUint32(this.id), t.writeUint8Array(this.message_data);
  }, n.ftypBox.prototype.write = function(t) {
    this.size = 8 + 4 * this.compatible_brands.length, this.writeHeader(t), t.writeString(this.major_brand, null, 4), t.writeUint32(this.minor_version);
    for (var e = 0; e < this.compatible_brands.length; e++)
      t.writeString(this.compatible_brands[e], null, 4);
  }, n.hdlrBox.prototype.write = function(t) {
    this.size = 5 * 4 + this.name.length + 1, this.version = 0, this.flags = 0, this.writeHeader(t), t.writeUint32(0), t.writeString(this.handler, null, 4), t.writeUint32(0), t.writeUint32(0), t.writeUint32(0), t.writeCString(this.name);
  }, n.hvcCBox.prototype.write = function(t) {
    var e, r;
    for (this.size = 23, e = 0; e < this.nalu_arrays.length; e++)
      for (this.size += 3, r = 0; r < this.nalu_arrays[e].length; r++)
        this.size += 2 + this.nalu_arrays[e][r].data.length;
    for (this.writeHeader(t), t.writeUint8(this.configurationVersion), t.writeUint8((this.general_profile_space << 6) + (this.general_tier_flag << 5) + this.general_profile_idc), t.writeUint32(this.general_profile_compatibility), t.writeUint8Array(this.general_constraint_indicator), t.writeUint8(this.general_level_idc), t.writeUint16(this.min_spatial_segmentation_idc + (15 << 24)), t.writeUint8(this.parallelismType + 252), t.writeUint8(this.chroma_format_idc + 252), t.writeUint8(this.bit_depth_luma_minus8 + 248), t.writeUint8(this.bit_depth_chroma_minus8 + 248), t.writeUint16(this.avgFrameRate), t.writeUint8((this.constantFrameRate << 6) + (this.numTemporalLayers << 3) + (this.temporalIdNested << 2) + this.lengthSizeMinusOne), t.writeUint8(this.nalu_arrays.length), e = 0; e < this.nalu_arrays.length; e++)
      for (t.writeUint8((this.nalu_arrays[e].completeness << 7) + this.nalu_arrays[e].nalu_type), t.writeUint16(this.nalu_arrays[e].length), r = 0; r < this.nalu_arrays[e].length; r++)
        t.writeUint16(this.nalu_arrays[e][r].data.length), t.writeUint8Array(this.nalu_arrays[e][r].data);
  }, n.kindBox.prototype.write = function(t) {
    this.version = 0, this.flags = 0, this.size = this.schemeURI.length + 1 + (this.value.length + 1), this.writeHeader(t), t.writeCString(this.schemeURI), t.writeCString(this.value);
  }, n.mdhdBox.prototype.write = function(t) {
    this.size = 4 * 4 + 2 * 2, this.flags = 0, this.version = 0, this.writeHeader(t), t.writeUint32(this.creation_time), t.writeUint32(this.modification_time), t.writeUint32(this.timescale), t.writeUint32(this.duration), t.writeUint16(this.language), t.writeUint16(0);
  }, n.mehdBox.prototype.write = function(t) {
    this.version = 0, this.flags = 0, this.size = 4, this.writeHeader(t), t.writeUint32(this.fragment_duration);
  }, n.mfhdBox.prototype.write = function(t) {
    this.version = 0, this.flags = 0, this.size = 4, this.writeHeader(t), t.writeUint32(this.sequence_number);
  }, n.mvhdBox.prototype.write = function(t) {
    this.version = 0, this.flags = 0, this.size = 23 * 4 + 2 * 2, this.writeHeader(t), t.writeUint32(this.creation_time), t.writeUint32(this.modification_time), t.writeUint32(this.timescale), t.writeUint32(this.duration), t.writeUint32(this.rate), t.writeUint16(this.volume << 8), t.writeUint16(0), t.writeUint32(0), t.writeUint32(0), t.writeUint32Array(this.matrix), t.writeUint32(0), t.writeUint32(0), t.writeUint32(0), t.writeUint32(0), t.writeUint32(0), t.writeUint32(0), t.writeUint32(this.next_track_id);
  }, n.SampleEntry.prototype.writeHeader = function(t) {
    this.size = 8, n.Box.prototype.writeHeader.call(this, t), t.writeUint8(0), t.writeUint8(0), t.writeUint8(0), t.writeUint8(0), t.writeUint8(0), t.writeUint8(0), t.writeUint16(this.data_reference_index);
  }, n.SampleEntry.prototype.writeFooter = function(t) {
    for (var e = 0; e < this.boxes.length; e++)
      this.boxes[e].write(t), this.size += this.boxes[e].size;
    f.debug("BoxWriter", "Adjusting box " + this.type + " with new size " + this.size), t.adjustUint32(this.sizePosition, this.size);
  }, n.SampleEntry.prototype.write = function(t) {
    this.writeHeader(t), t.writeUint8Array(this.data), this.size += this.data.length, f.debug("BoxWriter", "Adjusting box " + this.type + " with new size " + this.size), t.adjustUint32(this.sizePosition, this.size);
  }, n.VisualSampleEntry.prototype.write = function(t) {
    this.writeHeader(t), this.size += 2 * 7 + 6 * 4 + 32, t.writeUint16(0), t.writeUint16(0), t.writeUint32(0), t.writeUint32(0), t.writeUint32(0), t.writeUint16(this.width), t.writeUint16(this.height), t.writeUint32(this.horizresolution), t.writeUint32(this.vertresolution), t.writeUint32(0), t.writeUint16(this.frame_count), t.writeUint8(Math.min(31, this.compressorname.length)), t.writeString(this.compressorname, null, 31), t.writeUint16(this.depth), t.writeInt16(-1), this.writeFooter(t);
  }, n.AudioSampleEntry.prototype.write = function(t) {
    this.writeHeader(t), this.size += 2 * 4 + 3 * 4, t.writeUint32(0), t.writeUint32(0), t.writeUint16(this.channel_count), t.writeUint16(this.samplesize), t.writeUint16(0), t.writeUint16(0), t.writeUint32(this.samplerate << 16), this.writeFooter(t);
  }, n.stppSampleEntry.prototype.write = function(t) {
    this.writeHeader(t), this.size += this.namespace.length + 1 + this.schema_location.length + 1 + this.auxiliary_mime_types.length + 1, t.writeCString(this.namespace), t.writeCString(this.schema_location), t.writeCString(this.auxiliary_mime_types), this.writeFooter(t);
  }, n.SampleGroupEntry.prototype.write = function(t) {
    t.writeUint8Array(this.data);
  }, n.sbgpBox.prototype.write = function(t) {
    this.version = 1, this.flags = 0, this.size = 12 + 8 * this.entries.length, this.writeHeader(t), t.writeString(this.grouping_type, null, 4), t.writeUint32(this.grouping_type_parameter), t.writeUint32(this.entries.length);
    for (var e = 0; e < this.entries.length; e++) {
      var r = this.entries[e];
      t.writeInt32(r.sample_count), t.writeInt32(r.group_description_index);
    }
  }, n.sgpdBox.prototype.write = function(t) {
    var e, r;
    for (this.flags = 0, this.size = 12, e = 0; e < this.entries.length; e++)
      r = this.entries[e], this.version === 1 && (this.default_length === 0 && (this.size += 4), this.size += r.data.length);
    for (this.writeHeader(t), t.writeString(this.grouping_type, null, 4), this.version === 1 && t.writeUint32(this.default_length), this.version >= 2 && t.writeUint32(this.default_sample_description_index), t.writeUint32(this.entries.length), e = 0; e < this.entries.length; e++)
      r = this.entries[e], this.version === 1 && this.default_length === 0 && t.writeUint32(r.description_length), r.write(t);
  }, n.sidxBox.prototype.write = function(t) {
    this.version = 0, this.flags = 0, this.size = 4 * 4 + 2 + 2 + 12 * this.references.length, this.writeHeader(t), t.writeUint32(this.reference_ID), t.writeUint32(this.timescale), t.writeUint32(this.earliest_presentation_time), t.writeUint32(this.first_offset), t.writeUint16(0), t.writeUint16(this.references.length);
    for (var e = 0; e < this.references.length; e++) {
      var r = this.references[e];
      t.writeUint32(r.reference_type << 31 | r.referenced_size), t.writeUint32(r.subsegment_duration), t.writeUint32(r.starts_with_SAP << 31 | r.SAP_type << 28 | r.SAP_delta_time);
    }
  }, n.smhdBox.prototype.write = function(t) {
    this.version = 0, this.flags = 1, this.size = 4, this.writeHeader(t), t.writeUint16(this.balance), t.writeUint16(0);
  }, n.stcoBox.prototype.write = function(t) {
    this.version = 0, this.flags = 0, this.size = 4 + 4 * this.chunk_offsets.length, this.writeHeader(t), t.writeUint32(this.chunk_offsets.length), t.writeUint32Array(this.chunk_offsets);
  }, n.stscBox.prototype.write = function(t) {
    var e;
    for (this.version = 0, this.flags = 0, this.size = 4 + 12 * this.first_chunk.length, this.writeHeader(t), t.writeUint32(this.first_chunk.length), e = 0; e < this.first_chunk.length; e++)
      t.writeUint32(this.first_chunk[e]), t.writeUint32(this.samples_per_chunk[e]), t.writeUint32(this.sample_description_index[e]);
  }, n.stsdBox.prototype.write = function(t) {
    var e;
    for (this.version = 0, this.flags = 0, this.size = 0, this.writeHeader(t), t.writeUint32(this.entries.length), this.size += 4, e = 0; e < this.entries.length; e++)
      this.entries[e].write(t), this.size += this.entries[e].size;
    f.debug("BoxWriter", "Adjusting box " + this.type + " with new size " + this.size), t.adjustUint32(this.sizePosition, this.size);
  }, n.stshBox.prototype.write = function(t) {
    var e;
    for (this.version = 0, this.flags = 0, this.size = 4 + 8 * this.shadowed_sample_numbers.length, this.writeHeader(t), t.writeUint32(this.shadowed_sample_numbers.length), e = 0; e < this.shadowed_sample_numbers.length; e++)
      t.writeUint32(this.shadowed_sample_numbers[e]), t.writeUint32(this.sync_sample_numbers[e]);
  }, n.stssBox.prototype.write = function(t) {
    this.version = 0, this.flags = 0, this.size = 4 + 4 * this.sample_numbers.length, this.writeHeader(t), t.writeUint32(this.sample_numbers.length), t.writeUint32Array(this.sample_numbers);
  }, n.stszBox.prototype.write = function(t) {
    var e, r = !0;
    if (this.version = 0, this.flags = 0, this.sample_sizes.length > 0)
      for (e = 0; e + 1 < this.sample_sizes.length; )
        if (this.sample_sizes[e + 1] !== this.sample_sizes[0]) {
          r = !1;
          break;
        } else
          e++;
    else
      r = !1;
    this.size = 8, r || (this.size += 4 * this.sample_sizes.length), this.writeHeader(t), r ? t.writeUint32(this.sample_sizes[0]) : t.writeUint32(0), t.writeUint32(this.sample_sizes.length), r || t.writeUint32Array(this.sample_sizes);
  }, n.sttsBox.prototype.write = function(t) {
    var e;
    for (this.version = 0, this.flags = 0, this.size = 4 + 8 * this.sample_counts.length, this.writeHeader(t), t.writeUint32(this.sample_counts.length), e = 0; e < this.sample_counts.length; e++)
      t.writeUint32(this.sample_counts[e]), t.writeUint32(this.sample_deltas[e]);
  }, n.tfdtBox.prototype.write = function(t) {
    var e = Math.pow(2, 32) - 1;
    this.version = this.baseMediaDecodeTime > e ? 1 : 0, this.flags = 0, this.size = 4, this.version === 1 && (this.size += 4), this.writeHeader(t), this.version === 1 ? t.writeUint64(this.baseMediaDecodeTime) : t.writeUint32(this.baseMediaDecodeTime);
  }, n.tfhdBox.prototype.write = function(t) {
    this.version = 0, this.size = 4, this.flags & n.TFHD_FLAG_BASE_DATA_OFFSET && (this.size += 8), this.flags & n.TFHD_FLAG_SAMPLE_DESC && (this.size += 4), this.flags & n.TFHD_FLAG_SAMPLE_DUR && (this.size += 4), this.flags & n.TFHD_FLAG_SAMPLE_SIZE && (this.size += 4), this.flags & n.TFHD_FLAG_SAMPLE_FLAGS && (this.size += 4), this.writeHeader(t), t.writeUint32(this.track_id), this.flags & n.TFHD_FLAG_BASE_DATA_OFFSET && t.writeUint64(this.base_data_offset), this.flags & n.TFHD_FLAG_SAMPLE_DESC && t.writeUint32(this.default_sample_description_index), this.flags & n.TFHD_FLAG_SAMPLE_DUR && t.writeUint32(this.default_sample_duration), this.flags & n.TFHD_FLAG_SAMPLE_SIZE && t.writeUint32(this.default_sample_size), this.flags & n.TFHD_FLAG_SAMPLE_FLAGS && t.writeUint32(this.default_sample_flags);
  }, n.tkhdBox.prototype.write = function(t) {
    this.version = 0, this.size = 4 * 18 + 2 * 4, this.writeHeader(t), t.writeUint32(this.creation_time), t.writeUint32(this.modification_time), t.writeUint32(this.track_id), t.writeUint32(0), t.writeUint32(this.duration), t.writeUint32(0), t.writeUint32(0), t.writeInt16(this.layer), t.writeInt16(this.alternate_group), t.writeInt16(this.volume << 8), t.writeUint16(0), t.writeInt32Array(this.matrix), t.writeUint32(this.width), t.writeUint32(this.height);
  }, n.trexBox.prototype.write = function(t) {
    this.version = 0, this.flags = 0, this.size = 4 * 5, this.writeHeader(t), t.writeUint32(this.track_id), t.writeUint32(this.default_sample_description_index), t.writeUint32(this.default_sample_duration), t.writeUint32(this.default_sample_size), t.writeUint32(this.default_sample_flags);
  }, n.trunBox.prototype.write = function(t) {
    this.version = 0, this.size = 4, this.flags & n.TRUN_FLAGS_DATA_OFFSET && (this.size += 4), this.flags & n.TRUN_FLAGS_FIRST_FLAG && (this.size += 4), this.flags & n.TRUN_FLAGS_DURATION && (this.size += 4 * this.sample_duration.length), this.flags & n.TRUN_FLAGS_SIZE && (this.size += 4 * this.sample_size.length), this.flags & n.TRUN_FLAGS_FLAGS && (this.size += 4 * this.sample_flags.length), this.flags & n.TRUN_FLAGS_CTS_OFFSET && (this.size += 4 * this.sample_composition_time_offset.length), this.writeHeader(t), t.writeUint32(this.sample_count), this.flags & n.TRUN_FLAGS_DATA_OFFSET && (this.data_offset_position = t.getPosition(), t.writeInt32(this.data_offset)), this.flags & n.TRUN_FLAGS_FIRST_FLAG && t.writeUint32(this.first_sample_flags);
    for (var e = 0; e < this.sample_count; e++)
      this.flags & n.TRUN_FLAGS_DURATION && t.writeUint32(this.sample_duration[e]), this.flags & n.TRUN_FLAGS_SIZE && t.writeUint32(this.sample_size[e]), this.flags & n.TRUN_FLAGS_FLAGS && t.writeUint32(this.sample_flags[e]), this.flags & n.TRUN_FLAGS_CTS_OFFSET && (this.version === 0 ? t.writeUint32(this.sample_composition_time_offset[e]) : t.writeInt32(this.sample_composition_time_offset[e]));
  }, n["url Box"].prototype.write = function(t) {
    this.version = 0, this.location ? (this.flags = 0, this.size = this.location.length + 1) : (this.flags = 1, this.size = 0), this.writeHeader(t), this.location && t.writeCString(this.location);
  }, n["urn Box"].prototype.write = function(t) {
    this.version = 0, this.flags = 0, this.size = this.name.length + 1 + (this.location ? this.location.length + 1 : 0), this.writeHeader(t), t.writeCString(this.name), this.location && t.writeCString(this.location);
  }, n.vmhdBox.prototype.write = function(t) {
    this.version = 0, this.flags = 1, this.size = 8, this.writeHeader(t), t.writeUint16(this.graphicsmode), t.writeUint16Array(this.opcolor);
  }, n.cttsBox.prototype.unpack = function(t) {
    var e, r, s;
    for (s = 0, e = 0; e < this.sample_counts.length; e++)
      for (r = 0; r < this.sample_counts[e]; r++)
        t[s].pts = t[s].dts + this.sample_offsets[e], s++;
  }, n.sttsBox.prototype.unpack = function(t) {
    var e, r, s;
    for (s = 0, e = 0; e < this.sample_counts.length; e++)
      for (r = 0; r < this.sample_counts[e]; r++)
        s === 0 ? t[s].dts = 0 : t[s].dts = t[s - 1].dts + this.sample_deltas[e], s++;
  }, n.stcoBox.prototype.unpack = function(t) {
    var e;
    for (e = 0; e < this.chunk_offsets.length; e++)
      t[e].offset = this.chunk_offsets[e];
  }, n.stscBox.prototype.unpack = function(t) {
    var e, r, s, o, a;
    for (o = 0, a = 0, e = 0; e < this.first_chunk.length; e++)
      for (r = 0; r < (e + 1 < this.first_chunk.length ? this.first_chunk[e + 1] : 1 / 0); r++)
        for (a++, s = 0; s < this.samples_per_chunk[e]; s++) {
          if (t[o])
            t[o].description_index = this.sample_description_index[e], t[o].chunk_index = a;
          else
            return;
          o++;
        }
  }, n.stszBox.prototype.unpack = function(t) {
    var e;
    for (e = 0; e < this.sample_sizes.length; e++)
      t[e].size = this.sample_sizes[e];
  }, n.DIFF_BOXES_PROP_NAMES = [
    "boxes",
    "entries",
    "references",
    "subsamples",
    "items",
    "item_infos",
    "extents",
    "associations",
    "subsegments",
    "ranges",
    "seekLists",
    "seekPoints",
    "esd",
    "levels"
  ], n.DIFF_PRIMITIVE_ARRAY_PROP_NAMES = [
    "compatible_brands",
    "matrix",
    "opcolor",
    "sample_counts",
    "sample_deltas",
    "first_chunk",
    "samples_per_chunk",
    "sample_sizes",
    "chunk_offsets",
    "sample_offsets",
    "sample_description_index",
    "sample_duration"
  ], n.boxEqualFields = function(t, e) {
    if (t && !e) return !1;
    var r;
    for (r in t)
      if (!(n.DIFF_BOXES_PROP_NAMES.indexOf(r) > -1)) {
        if (t[r] instanceof n.Box || e[r] instanceof n.Box)
          continue;
        if (typeof t[r] > "u" || typeof e[r] > "u")
          continue;
        if (typeof t[r] == "function" || typeof e[r] == "function")
          continue;
        if (t.subBoxNames && t.subBoxNames.indexOf(r.slice(0, 4)) > -1 || e.subBoxNames && e.subBoxNames.indexOf(r.slice(0, 4)) > -1)
          continue;
        if (r === "data" || r === "start" || r === "size" || r === "creation_time" || r === "modification_time")
          continue;
        if (n.DIFF_PRIMITIVE_ARRAY_PROP_NAMES.indexOf(r) > -1)
          continue;
        if (t[r] !== e[r])
          return !1;
      }
    return !0;
  }, n.boxEqual = function(t, e) {
    if (!n.boxEqualFields(t, e))
      return !1;
    for (var r = 0; r < n.DIFF_BOXES_PROP_NAMES.length; r++) {
      var s = n.DIFF_BOXES_PROP_NAMES[r];
      if (t[s] && e[s] && !n.boxEqual(t[s], e[s]))
        return !1;
    }
    return !0;
  };
  var R = function() {
  };
  R.prototype.parseSample = function(t) {
    var e, r, s = new g(t.buffer);
    for (e = []; !s.isEos(); )
      r = n.parseOneBox(s, !1), r.code === n.OK && r.box.type === "vttc" && e.push(r.box);
    return e;
  }, R.prototype.getText = function(t, e, r) {
    function s(u, c, y) {
      return y = y || "0", u = u + "", u.length >= c ? u : new Array(c - u.length + 1).join(y) + u;
    }
    function o(u) {
      var c = Math.floor(u / 3600), y = Math.floor((u - c * 3600) / 60), x = Math.floor(u - c * 3600 - y * 60), m = Math.floor((u - c * 3600 - y * 60 - x) * 1e3);
      return "" + s(c, 2) + ":" + s(y, 2) + ":" + s(x, 2) + "." + s(m, 3);
    }
    for (var a = this.parseSample(r), h = "", d = 0; d < a.length; d++) {
      var p = a[d];
      h += o(t) + " --> " + o(e) + `\r
`, h += p.payl.text;
    }
    return h;
  };
  var H = function() {
  };
  H.prototype.parseSample = function(t) {
    var e = {}, r;
    e.resources = [];
    var s = new g(t.data.buffer);
    if (!t.subsamples || t.subsamples.length === 0)
      e.documentString = s.readString(t.data.length);
    else if (e.documentString = s.readString(t.subsamples[0].size), t.subsamples.length > 1)
      for (r = 1; r < t.subsamples.length; r++)
        e.resources[r] = s.readUint8Array(t.subsamples[r].size);
    return typeof DOMParser < "u" && (e.document = new DOMParser().parseFromString(e.documentString, "application/xml")), e;
  };
  var M = function() {
  };
  M.prototype.parseSample = function(t) {
    var e, r = new g(t.data.buffer);
    return e = r.readString(t.data.length), e;
  }, M.prototype.parseConfig = function(t) {
    var e, r = new g(t.buffer);
    return r.readUint32(), e = r.readCString(), e;
  }, U.VTTin4Parser = R, U.XMLSubtitlein4Parser = H, U.Textin4Parser = M;
  var _ = function(t) {
    this.stream = t || new S(), this.boxes = [], this.mdats = [], this.moofs = [], this.isProgressive = !1, this.moovStartFound = !1, this.onMoovStart = null, this.moovStartSent = !1, this.onReady = null, this.readySent = !1, this.onSegment = null, this.onSamples = null, this.onError = null, this.sampleListBuilt = !1, this.fragmentedTracks = [], this.extractedTracks = [], this.isFragmentationInitialized = !1, this.sampleProcessingStarted = !1, this.nextMoofNumber = 0, this.itemListBuilt = !1, this.items = [], this.entity_groups = [], this.onSidx = null, this.sidxSent = !1;
  };
  _.prototype.setSegmentOptions = function(t, e, r) {
    var s = this.getTrackById(t);
    if (s) {
      var o = {};
      this.fragmentedTracks.push(o), o.id = t, o.user = e, o.trak = s, s.nextSample = 0, o.segmentStream = null, o.nb_samples = 1e3, o.rapAlignement = !0, r && (r.nbSamples && (o.nb_samples = r.nbSamples), r.rapAlignement && (o.rapAlignement = r.rapAlignement));
    }
  }, _.prototype.unsetSegmentOptions = function(t) {
    for (var e = -1, r = 0; r < this.fragmentedTracks.length; r++) {
      var s = this.fragmentedTracks[r];
      s.id == t && (e = r);
    }
    e > -1 && this.fragmentedTracks.splice(e, 1);
  }, _.prototype.setExtractionOptions = function(t, e, r) {
    var s = this.getTrackById(t);
    if (s) {
      var o = {};
      this.extractedTracks.push(o), o.id = t, o.user = e, o.trak = s, s.nextSample = 0, o.nb_samples = 1e3, o.samples = [], r && r.nbSamples && (o.nb_samples = r.nbSamples);
    }
  }, _.prototype.unsetExtractionOptions = function(t) {
    for (var e = -1, r = 0; r < this.extractedTracks.length; r++) {
      var s = this.extractedTracks[r];
      s.id == t && (e = r);
    }
    e > -1 && this.extractedTracks.splice(e, 1);
  }, _.prototype.parse = function() {
    var t, e, r = !1;
    if (!(this.restoreParsePosition && !this.restoreParsePosition()))
      for (; ; )
        if (this.hasIncompleteMdat && this.hasIncompleteMdat()) {
          if (this.processIncompleteMdat())
            continue;
          return;
        } else if (this.saveParsePosition && this.saveParsePosition(), t = n.parseOneBox(this.stream, r), t.code === n.ERR_NOT_ENOUGH_DATA)
          if (this.processIncompleteBox) {
            if (this.processIncompleteBox(t))
              continue;
            return;
          } else
            return;
        else {
          var s;
          switch (e = t.box, s = e.type !== "uuid" ? e.type : e.uuid, this.boxes.push(e), s) {
            case "mdat":
              this.mdats.push(e);
              break;
            case "moof":
              this.moofs.push(e);
              break;
            case "moov":
              this.moovStartFound = !0, this.mdats.length === 0 && (this.isProgressive = !0);
            default:
              this[s] !== void 0 && f.warn("ISOFile", "Duplicate Box of type: " + s + ", overriding previous occurrence"), this[s] = e;
              break;
          }
          this.updateUsedBytes && this.updateUsedBytes(e, t);
        }
  }, _.prototype.checkBuffer = function(t) {
    if (t == null)
      throw "Buffer must be defined and non empty";
    if (t.fileStart === void 0)
      throw "Buffer must have a fileStart property";
    return t.byteLength === 0 ? (f.warn("ISOFile", "Ignoring empty buffer (fileStart: " + t.fileStart + ")"), this.stream.logBufferLevel(), !1) : (f.info("ISOFile", "Processing buffer (fileStart: " + t.fileStart + ")"), t.usedBytes = 0, this.stream.insertBuffer(t), this.stream.logBufferLevel(), this.stream.initialized() ? !0 : (f.warn("ISOFile", "Not ready to start parsing"), !1));
  }, _.prototype.appendBuffer = function(t, e) {
    var r;
    if (this.checkBuffer(t))
      return this.parse(), this.moovStartFound && !this.moovStartSent && (this.moovStartSent = !0, this.onMoovStart && this.onMoovStart()), this.moov ? (this.sampleListBuilt || (this.buildSampleLists(), this.sampleListBuilt = !0), this.updateSampleLists(), this.onReady && !this.readySent && (this.readySent = !0, this.onReady(this.getInfo())), this.processSamples(e), this.nextSeekPosition ? (r = this.nextSeekPosition, this.nextSeekPosition = void 0) : r = this.nextParsePosition, this.stream.getEndFilePositionAfter && (r = this.stream.getEndFilePositionAfter(r))) : this.nextParsePosition ? r = this.nextParsePosition : r = 0, this.sidx && this.onSidx && !this.sidxSent && (this.onSidx(this.sidx), this.sidxSent = !0), this.meta && (this.flattenItemInfo && !this.itemListBuilt && (this.flattenItemInfo(), this.itemListBuilt = !0), this.processItems && this.processItems(this.onItem)), this.stream.cleanBuffers && (f.info("ISOFile", "Done processing buffer (fileStart: " + t.fileStart + ") - next buffer to fetch should have a fileStart position of " + r), this.stream.logBufferLevel(), this.stream.cleanBuffers(), this.stream.logBufferLevel(!0), f.info("ISOFile", "Sample data size in memory: " + this.getAllocatedSampleDataSize())), r;
  }, _.prototype.getInfo = function() {
    var t, e, r = {}, s, o, a, h, d = (/* @__PURE__ */ new Date("1904-01-01T00:00:00Z")).getTime();
    if (this.moov)
      for (r.hasMoov = !0, r.duration = this.moov.mvhd.duration, r.timescale = this.moov.mvhd.timescale, r.isFragmented = this.moov.mvex != null, r.isFragmented && this.moov.mvex.mehd && (r.fragment_duration = this.moov.mvex.mehd.fragment_duration), r.isProgressive = this.isProgressive, r.hasIOD = this.moov.iods != null, r.brands = [], r.brands.push(this.ftyp.major_brand), r.brands = r.brands.concat(this.ftyp.compatible_brands), r.created = new Date(d + this.moov.mvhd.creation_time * 1e3), r.modified = new Date(d + this.moov.mvhd.modification_time * 1e3), r.tracks = [], r.audioTracks = [], r.videoTracks = [], r.subtitleTracks = [], r.metadataTracks = [], r.hintTracks = [], r.otherTracks = [], t = 0; t < this.moov.traks.length; t++) {
        if (s = this.moov.traks[t], h = s.mdia.minf.stbl.stsd.entries[0], o = {}, r.tracks.push(o), o.id = s.tkhd.track_id, o.name = s.mdia.hdlr.name, o.references = [], s.tref)
          for (e = 0; e < s.tref.boxes.length; e++)
            a = {}, o.references.push(a), a.type = s.tref.boxes[e].type, a.track_ids = s.tref.boxes[e].track_ids;
        s.edts && (o.edits = s.edts.elst.entries), o.created = new Date(d + s.tkhd.creation_time * 1e3), o.modified = new Date(d + s.tkhd.modification_time * 1e3), o.movie_duration = s.tkhd.duration, o.movie_timescale = r.timescale, o.layer = s.tkhd.layer, o.alternate_group = s.tkhd.alternate_group, o.volume = s.tkhd.volume, o.matrix = s.tkhd.matrix, o.track_width = s.tkhd.width / 65536, o.track_height = s.tkhd.height / 65536, o.timescale = s.mdia.mdhd.timescale, o.cts_shift = s.mdia.minf.stbl.cslg, o.duration = s.mdia.mdhd.duration, o.samples_duration = s.samples_duration, o.codec = h.getCodec(), o.kind = s.udta && s.udta.kinds.length ? s.udta.kinds[0] : { schemeURI: "", value: "" }, o.language = s.mdia.elng ? s.mdia.elng.extended_language : s.mdia.mdhd.languageString, o.nb_samples = s.samples.length, o.size = s.samples_size, o.bitrate = o.size * 8 * o.timescale / o.samples_duration, h.isAudio() ? (o.type = "audio", r.audioTracks.push(o), o.audio = {}, o.audio.sample_rate = h.getSampleRate(), o.audio.channel_count = h.getChannelCount(), o.audio.sample_size = h.getSampleSize()) : h.isVideo() ? (o.type = "video", r.videoTracks.push(o), o.video = {}, o.video.width = h.getWidth(), o.video.height = h.getHeight()) : h.isSubtitle() ? (o.type = "subtitles", r.subtitleTracks.push(o)) : h.isHint() ? (o.type = "metadata", r.hintTracks.push(o)) : h.isMetadata() ? (o.type = "metadata", r.metadataTracks.push(o)) : (o.type = "metadata", r.otherTracks.push(o));
      }
    else
      r.hasMoov = !1;
    if (r.mime = "", r.hasMoov && r.tracks) {
      for (r.videoTracks && r.videoTracks.length > 0 ? r.mime += 'video/mp4; codecs="' : r.audioTracks && r.audioTracks.length > 0 ? r.mime += 'audio/mp4; codecs="' : r.mime += 'application/mp4; codecs="', t = 0; t < r.tracks.length; t++)
        t !== 0 && (r.mime += ","), r.mime += r.tracks[t].codec;
      r.mime += '"; profiles="', r.mime += this.ftyp.compatible_brands.join(), r.mime += '"';
    }
    return r;
  }, _.prototype.setNextSeekPositionFromSample = function(t) {
    t && (this.nextSeekPosition ? this.nextSeekPosition = Math.min(t.offset + t.alreadyRead, this.nextSeekPosition) : this.nextSeekPosition = t.offset + t.alreadyRead);
  }, _.prototype.processSamples = function(t) {
    var e, r;
    if (this.sampleProcessingStarted) {
      if (this.isFragmentationInitialized && this.onSegment !== null)
        for (e = 0; e < this.fragmentedTracks.length; e++) {
          var s = this.fragmentedTracks[e];
          for (r = s.trak; r.nextSample < r.samples.length && this.sampleProcessingStarted; ) {
            f.debug("ISOFile", "Creating media fragment on track #" + s.id + " for sample " + r.nextSample);
            var o = this.createFragment(s.id, r.nextSample, s.segmentStream);
            if (o)
              s.segmentStream = o, r.nextSample++;
            else
              break;
            if ((r.nextSample % s.nb_samples === 0 || t || r.nextSample >= r.samples.length) && (f.info("ISOFile", "Sending fragmented data on track #" + s.id + " for samples [" + Math.max(0, r.nextSample - s.nb_samples) + "," + (r.nextSample - 1) + "]"), f.info("ISOFile", "Sample data size in memory: " + this.getAllocatedSampleDataSize()), this.onSegment && this.onSegment(s.id, s.user, s.segmentStream.buffer, r.nextSample, t || r.nextSample >= r.samples.length), s.segmentStream = null, s !== this.fragmentedTracks[e]))
              break;
          }
        }
      if (this.onSamples !== null)
        for (e = 0; e < this.extractedTracks.length; e++) {
          var a = this.extractedTracks[e];
          for (r = a.trak; r.nextSample < r.samples.length && this.sampleProcessingStarted; ) {
            f.debug("ISOFile", "Exporting on track #" + a.id + " sample #" + r.nextSample);
            var h = this.getSample(r, r.nextSample);
            if (h)
              r.nextSample++, a.samples.push(h);
            else {
              this.setNextSeekPositionFromSample(r.samples[r.nextSample]);
              break;
            }
            if ((r.nextSample % a.nb_samples === 0 || r.nextSample >= r.samples.length) && (f.debug("ISOFile", "Sending samples on track #" + a.id + " for sample " + r.nextSample), this.onSamples && this.onSamples(a.id, a.user, a.samples), a.samples = [], a !== this.extractedTracks[e]))
              break;
          }
        }
    }
  }, _.prototype.getBox = function(t) {
    var e = this.getBoxes(t, !0);
    return e.length ? e[0] : null;
  }, _.prototype.getBoxes = function(t, e) {
    var r = [];
    return _._sweep.call(this, t, r, e), r;
  }, _._sweep = function(t, e, r) {
    this.type && this.type == t && e.push(this);
    for (var s in this.boxes) {
      if (e.length && r) return;
      _._sweep.call(this.boxes[s], t, e, r);
    }
  }, _.prototype.getTrackSamplesInfo = function(t) {
    var e = this.getTrackById(t);
    if (e)
      return e.samples;
  }, _.prototype.getTrackSample = function(t, e) {
    var r = this.getTrackById(t), s = this.getSample(r, e);
    return s;
  }, _.prototype.releaseUsedSamples = function(t, e) {
    var r = 0, s = this.getTrackById(t);
    s.lastValidSample || (s.lastValidSample = 0);
    for (var o = s.lastValidSample; o < e; o++)
      r += this.releaseSample(s, o);
    f.info("ISOFile", "Track #" + t + " released samples up to " + e + " (released size: " + r + ", remaining: " + this.samplesDataSize + ")"), s.lastValidSample = e;
  }, _.prototype.start = function() {
    this.sampleProcessingStarted = !0, this.processSamples(!1);
  }, _.prototype.stop = function() {
    this.sampleProcessingStarted = !1;
  }, _.prototype.flush = function() {
    f.info("ISOFile", "Flushing remaining samples"), this.updateSampleLists(), this.processSamples(!0), this.stream.cleanBuffers(), this.stream.logBufferLevel(!0);
  }, _.prototype.seekTrack = function(t, e, r) {
    var s, o, a = 1 / 0, h = 0, d = 0, p;
    if (r.samples.length === 0)
      return f.info("ISOFile", "No sample in track, cannot seek! Using time " + f.getDurationString(0, 1) + " and offset: 0"), { offset: 0, time: 0 };
    for (s = 0; s < r.samples.length; s++) {
      if (o = r.samples[s], s === 0)
        d = 0, p = o.timescale;
      else if (o.cts > t * o.timescale) {
        d = s - 1;
        break;
      }
      e && o.is_sync && (h = s);
    }
    for (e && (d = h), t = r.samples[d].cts, r.nextSample = d; r.samples[d].alreadyRead === r.samples[d].size && r.samples[d + 1]; )
      d++;
    return a = r.samples[d].offset + r.samples[d].alreadyRead, f.info("ISOFile", "Seeking to " + (e ? "RAP" : "") + " sample #" + r.nextSample + " on track " + r.tkhd.track_id + ", time " + f.getDurationString(t, p) + " and offset: " + a), { offset: a, time: t / p };
  }, _.prototype.getTrackDuration = function(t) {
    var e;
    return t.samples ? (e = t.samples[t.samples.length - 1], (e.cts + e.duration) / e.timescale) : 1 / 0;
  }, _.prototype.seek = function(t, e) {
    var r = this.moov, s, o, a, h = { offset: 1 / 0, time: 1 / 0 };
    if (this.moov) {
      for (a = 0; a < r.traks.length; a++)
        s = r.traks[a], !(t > this.getTrackDuration(s)) && (o = this.seekTrack(t, e, s), o.offset < h.offset && (h.offset = o.offset), o.time < h.time && (h.time = o.time));
      return f.info("ISOFile", "Seeking at time " + f.getDurationString(h.time, 1) + " needs a buffer with a fileStart position of " + h.offset), h.offset === 1 / 0 ? h = { offset: this.nextParsePosition, time: 0 } : h.offset = this.stream.getEndFilePositionAfter(h.offset), f.info("ISOFile", "Adjusted seek position (after checking data already in buffer): " + h.offset), h;
    } else
      throw "Cannot seek: moov not received!";
  }, _.prototype.equal = function(t) {
    for (var e = 0; e < this.boxes.length && e < t.boxes.length; ) {
      var r = this.boxes[e], s = t.boxes[e];
      if (!n.boxEqual(r, s))
        return !1;
      e++;
    }
    return !0;
  }, U.ISOFile = _, _.prototype.lastBoxStartPosition = 0, _.prototype.parsingMdat = null, _.prototype.nextParsePosition = 0, _.prototype.discardMdatData = !1, _.prototype.processIncompleteBox = function(t) {
    var e, r, s;
    return t.type === "mdat" ? (e = new n[t.type + "Box"](t.size), this.parsingMdat = e, this.boxes.push(e), this.mdats.push(e), e.start = t.start, e.hdr_size = t.hdr_size, this.stream.addUsedBytes(e.hdr_size), this.lastBoxStartPosition = e.start + e.size, s = this.stream.seek(e.start + e.size, !1, this.discardMdatData), s ? (this.parsingMdat = null, !0) : (this.moovStartFound ? this.nextParsePosition = this.stream.findEndContiguousBuf() : this.nextParsePosition = e.start + e.size, !1)) : (t.type === "moov" && (this.moovStartFound = !0, this.mdats.length === 0 && (this.isProgressive = !0)), r = this.stream.mergeNextBuffer ? this.stream.mergeNextBuffer() : !1, r ? (this.nextParsePosition = this.stream.getEndPosition(), !0) : (t.type ? this.moovStartFound ? this.nextParsePosition = this.stream.getEndPosition() : this.nextParsePosition = this.stream.getPosition() + t.size : this.nextParsePosition = this.stream.getEndPosition(), !1));
  }, _.prototype.hasIncompleteMdat = function() {
    return this.parsingMdat !== null;
  }, _.prototype.processIncompleteMdat = function() {
    var t, e;
    return t = this.parsingMdat, e = this.stream.seek(t.start + t.size, !1, this.discardMdatData), e ? (f.debug("ISOFile", "Found 'mdat' end in buffered data"), this.parsingMdat = null, !0) : (this.nextParsePosition = this.stream.findEndContiguousBuf(), !1);
  }, _.prototype.restoreParsePosition = function() {
    return this.stream.seek(this.lastBoxStartPosition, !0, this.discardMdatData);
  }, _.prototype.saveParsePosition = function() {
    this.lastBoxStartPosition = this.stream.getPosition();
  }, _.prototype.updateUsedBytes = function(t, e) {
    this.stream.addUsedBytes && (t.type === "mdat" ? (this.stream.addUsedBytes(t.hdr_size), this.discardMdatData && this.stream.addUsedBytes(t.size - t.hdr_size)) : this.stream.addUsedBytes(t.size));
  }, _.prototype.add = n.Box.prototype.add, _.prototype.addBox = n.Box.prototype.addBox, _.prototype.init = function(t) {
    var e = t || {};
    this.add("ftyp").set("major_brand", e.brands && e.brands[0] || "iso4").set("minor_version", 0).set("compatible_brands", e.brands || ["iso4"]);
    var r = this.add("moov");
    return r.add("mvhd").set("timescale", e.timescale || 600).set("rate", e.rate || 65536).set("creation_time", 0).set("modification_time", 0).set("duration", e.duration || 0).set("volume", e.width ? 0 : 256).set("matrix", [65536, 0, 0, 0, 65536, 0, 0, 0, 1073741824]).set("next_track_id", 1), r.add("mvex"), this;
  }, _.prototype.addTrack = function(t) {
    this.moov || this.init(t);
    var e = t || {};
    e.width = e.width || 320, e.height = e.height || 320, e.id = e.id || this.moov.mvhd.next_track_id, e.type = e.type || "avc1";
    var r = this.moov.add("trak");
    this.moov.mvhd.next_track_id = e.id + 1, r.add("tkhd").set("flags", n.TKHD_FLAG_ENABLED | n.TKHD_FLAG_IN_MOVIE | n.TKHD_FLAG_IN_PREVIEW).set("creation_time", 0).set("modification_time", 0).set("track_id", e.id).set("duration", e.duration || 0).set("layer", e.layer || 0).set("alternate_group", 0).set("volume", 1).set("matrix", [65536, 0, 0, 0, 65536, 0, 0, 0, 1073741824]).set("width", e.width << 16).set("height", e.height << 16);
    var s = r.add("mdia");
    s.add("mdhd").set("creation_time", 0).set("modification_time", 0).set("timescale", e.timescale || 1).set("duration", e.media_duration || 0).set("language", e.language || "und"), s.add("hdlr").set("handler", e.hdlr || "vide").set("name", e.name || "Track created with MP4Box.js"), s.add("elng").set("extended_language", e.language || "fr-FR");
    var o = s.add("minf");
    if (n[e.type + "SampleEntry"] !== void 0) {
      var a = new n[e.type + "SampleEntry"]();
      a.data_reference_index = 1;
      var h = "";
      for (var d in n.sampleEntryCodes)
        for (var p = n.sampleEntryCodes[d], u = 0; u < p.length; u++)
          if (p.indexOf(e.type) > -1) {
            h = d;
            break;
          }
      switch (h) {
        case "Visual":
          if (o.add("vmhd").set("graphicsmode", 0).set("opcolor", [0, 0, 0]), a.set("width", e.width).set("height", e.height).set("horizresolution", 72 << 16).set("vertresolution", 72 << 16).set("frame_count", 1).set("compressorname", e.type + " Compressor").set("depth", 24), e.avcDecoderConfigRecord) {
            var c = new n.avcCBox();
            c.parse(new g(e.avcDecoderConfigRecord)), a.addBox(c);
          } else if (e.hevcDecoderConfigRecord) {
            var y = new n.hvcCBox();
            y.parse(new g(e.hevcDecoderConfigRecord)), a.addBox(y);
          }
          break;
        case "Audio":
          o.add("smhd").set("balance", e.balance || 0), a.set("channel_count", e.channel_count || 2).set("samplesize", e.samplesize || 16).set("samplerate", e.samplerate || 65536);
          break;
        case "Hint":
          o.add("hmhd");
          break;
        case "Subtitle":
          switch (o.add("sthd"), e.type) {
            case "stpp":
              a.set("namespace", e.namespace || "nonamespace").set("schema_location", e.schema_location || "").set("auxiliary_mime_types", e.auxiliary_mime_types || "");
              break;
          }
          break;
        case "Metadata":
          o.add("nmhd");
          break;
        case "System":
          o.add("nmhd");
          break;
        default:
          o.add("nmhd");
          break;
      }
      e.description && a.addBox(e.description), e.description_boxes && e.description_boxes.forEach(function(m) {
        a.addBox(m);
      }), o.add("dinf").add("dref").addEntry(new n["url Box"]().set("flags", 1));
      var x = o.add("stbl");
      return x.add("stsd").addEntry(a), x.add("stts").set("sample_counts", []).set("sample_deltas", []), x.add("stsc").set("first_chunk", []).set("samples_per_chunk", []).set("sample_description_index", []), x.add("stco").set("chunk_offsets", []), x.add("stsz").set("sample_sizes", []), this.moov.mvex.add("trex").set("track_id", e.id).set("default_sample_description_index", e.default_sample_description_index || 1).set("default_sample_duration", e.default_sample_duration || 0).set("default_sample_size", e.default_sample_size || 0).set("default_sample_flags", e.default_sample_flags || 0), this.buildTrakSampleLists(r), e.id;
    }
  }, n.Box.prototype.computeSize = function(t) {
    var e = t || new l();
    e.endianness = l.BIG_ENDIAN, this.write(e);
  }, _.prototype.addSample = function(t, e, r) {
    var s = r || {}, o = {}, a = this.getTrackById(t);
    if (a !== null) {
      o.number = a.samples.length, o.track_id = a.tkhd.track_id, o.timescale = a.mdia.mdhd.timescale, o.description_index = s.sample_description_index ? s.sample_description_index - 1 : 0, o.description = a.mdia.minf.stbl.stsd.entries[o.description_index], o.data = e, o.size = e.byteLength, o.alreadyRead = o.size, o.duration = s.duration || 1, o.cts = s.cts || 0, o.dts = s.dts || 0, o.is_sync = s.is_sync || !1, o.is_leading = s.is_leading || 0, o.depends_on = s.depends_on || 0, o.is_depended_on = s.is_depended_on || 0, o.has_redundancy = s.has_redundancy || 0, o.degradation_priority = s.degradation_priority || 0, o.offset = 0, o.subsamples = s.subsamples, a.samples.push(o), a.samples_size += o.size, a.samples_duration += o.duration, a.first_dts === void 0 && (a.first_dts = s.dts), this.processSamples();
      var h = this.createSingleSampleMoof(o);
      return this.addBox(h), h.computeSize(), h.trafs[0].truns[0].data_offset = h.size + 8, this.add("mdat").data = new Uint8Array(e), o;
    }
  }, _.prototype.createSingleSampleMoof = function(t) {
    var e = 0;
    t.is_sync ? e = 1 << 25 : e = 65536;
    var r = new n.moofBox();
    r.add("mfhd").set("sequence_number", this.nextMoofNumber), this.nextMoofNumber++;
    var s = r.add("traf"), o = this.getTrackById(t.track_id);
    return s.add("tfhd").set("track_id", t.track_id).set("flags", n.TFHD_FLAG_DEFAULT_BASE_IS_MOOF), s.add("tfdt").set("baseMediaDecodeTime", t.dts - (o.first_dts || 0)), s.add("trun").set("flags", n.TRUN_FLAGS_DATA_OFFSET | n.TRUN_FLAGS_DURATION | n.TRUN_FLAGS_SIZE | n.TRUN_FLAGS_FLAGS | n.TRUN_FLAGS_CTS_OFFSET).set("data_offset", 0).set("first_sample_flags", 0).set("sample_count", 1).set("sample_duration", [t.duration]).set("sample_size", [t.size]).set("sample_flags", [e]).set("sample_composition_time_offset", [t.cts - t.dts]), r;
  }, _.prototype.lastMoofIndex = 0, _.prototype.samplesDataSize = 0, _.prototype.resetTables = function() {
    var t, e, r, s, o, a, h, d;
    for (this.initial_duration = this.moov.mvhd.duration, this.moov.mvhd.duration = 0, t = 0; t < this.moov.traks.length; t++) {
      e = this.moov.traks[t], e.tkhd.duration = 0, e.mdia.mdhd.duration = 0, r = e.mdia.minf.stbl.stco || e.mdia.minf.stbl.co64, r.chunk_offsets = [], s = e.mdia.minf.stbl.stsc, s.first_chunk = [], s.samples_per_chunk = [], s.sample_description_index = [], o = e.mdia.minf.stbl.stsz || e.mdia.minf.stbl.stz2, o.sample_sizes = [], a = e.mdia.minf.stbl.stts, a.sample_counts = [], a.sample_deltas = [], h = e.mdia.minf.stbl.ctts, h && (h.sample_counts = [], h.sample_offsets = []), d = e.mdia.minf.stbl.stss;
      var p = e.mdia.minf.stbl.boxes.indexOf(d);
      p != -1 && (e.mdia.minf.stbl.boxes[p] = null);
    }
  }, _.initSampleGroups = function(t, e, r, s, o) {
    var a, h, d, p;
    function u(c, y, x) {
      this.grouping_type = c, this.grouping_type_parameter = y, this.sbgp = x, this.last_sample_in_run = -1, this.entry_index = -1;
    }
    for (e && (e.sample_groups_info = []), t.sample_groups_info || (t.sample_groups_info = []), h = 0; h < r.length; h++) {
      for (p = r[h].grouping_type + "/" + r[h].grouping_type_parameter, d = new u(r[h].grouping_type, r[h].grouping_type_parameter, r[h]), e && (e.sample_groups_info[p] = d), t.sample_groups_info[p] || (t.sample_groups_info[p] = d), a = 0; a < s.length; a++)
        s[a].grouping_type === r[h].grouping_type && (d.description = s[a], d.description.used = !0);
      if (o)
        for (a = 0; a < o.length; a++)
          o[a].grouping_type === r[h].grouping_type && (d.fragment_description = o[a], d.fragment_description.used = !0, d.is_fragment = !0);
    }
    if (e) {
      if (o)
        for (h = 0; h < o.length; h++)
          !o[h].used && o[h].version >= 2 && (p = o[h].grouping_type + "/0", d = new u(o[h].grouping_type, 0), d.is_fragment = !0, e.sample_groups_info[p] || (e.sample_groups_info[p] = d));
    } else
      for (h = 0; h < s.length; h++)
        !s[h].used && s[h].version >= 2 && (p = s[h].grouping_type + "/0", d = new u(s[h].grouping_type, 0), t.sample_groups_info[p] || (t.sample_groups_info[p] = d));
  }, _.setSampleGroupProperties = function(t, e, r, s) {
    var o, a;
    e.sample_groups = [];
    for (o in s)
      if (e.sample_groups[o] = {}, e.sample_groups[o].grouping_type = s[o].grouping_type, e.sample_groups[o].grouping_type_parameter = s[o].grouping_type_parameter, r >= s[o].last_sample_in_run && (s[o].last_sample_in_run < 0 && (s[o].last_sample_in_run = 0), s[o].entry_index++, s[o].entry_index <= s[o].sbgp.entries.length - 1 && (s[o].last_sample_in_run += s[o].sbgp.entries[s[o].entry_index].sample_count)), s[o].entry_index <= s[o].sbgp.entries.length - 1 ? e.sample_groups[o].group_description_index = s[o].sbgp.entries[s[o].entry_index].group_description_index : e.sample_groups[o].group_description_index = -1, e.sample_groups[o].group_description_index !== 0) {
        var h;
        s[o].fragment_description ? h = s[o].fragment_description : h = s[o].description, e.sample_groups[o].group_description_index > 0 ? (e.sample_groups[o].group_description_index > 65535 ? a = (e.sample_groups[o].group_description_index >> 16) - 1 : a = e.sample_groups[o].group_description_index - 1, h && a >= 0 && (e.sample_groups[o].description = h.entries[a])) : h && h.version >= 2 && h.default_group_description_index > 0 && (e.sample_groups[o].description = h.entries[h.default_group_description_index - 1]);
      }
  }, _.process_sdtp = function(t, e, r) {
    e && (t ? (e.is_leading = t.is_leading[r], e.depends_on = t.sample_depends_on[r], e.is_depended_on = t.sample_is_depended_on[r], e.has_redundancy = t.sample_has_redundancy[r]) : (e.is_leading = 0, e.depends_on = 0, e.is_depended_on = 0, e.has_redundancy = 0));
  }, _.prototype.buildSampleLists = function() {
    var t, e;
    for (t = 0; t < this.moov.traks.length; t++)
      e = this.moov.traks[t], this.buildTrakSampleLists(e);
  }, _.prototype.buildTrakSampleLists = function(t) {
    var e, r, s, o, a, h, d, p, u, c, y, x, m, w, b, P, L, z, C, I, D, N, F, k;
    if (t.samples = [], t.samples_duration = 0, t.samples_size = 0, r = t.mdia.minf.stbl.stco || t.mdia.minf.stbl.co64, s = t.mdia.minf.stbl.stsc, o = t.mdia.minf.stbl.stsz || t.mdia.minf.stbl.stz2, a = t.mdia.minf.stbl.stts, h = t.mdia.minf.stbl.ctts, d = t.mdia.minf.stbl.stss, p = t.mdia.minf.stbl.stsd, u = t.mdia.minf.stbl.subs, x = t.mdia.minf.stbl.stdp, c = t.mdia.minf.stbl.sbgps, y = t.mdia.minf.stbl.sgpds, z = -1, C = -1, I = -1, D = -1, N = 0, F = 0, k = 0, _.initSampleGroups(t, null, c, y), !(typeof o > "u")) {
      for (e = 0; e < o.sample_sizes.length; e++) {
        var v = {};
        v.number = e, v.track_id = t.tkhd.track_id, v.timescale = t.mdia.mdhd.timescale, v.alreadyRead = 0, t.samples[e] = v, v.size = o.sample_sizes[e], t.samples_size += v.size, e === 0 ? (w = 1, m = 0, v.chunk_index = w, v.chunk_run_index = m, L = s.samples_per_chunk[m], P = 0, m + 1 < s.first_chunk.length ? b = s.first_chunk[m + 1] - 1 : b = 1 / 0) : e < L ? (v.chunk_index = w, v.chunk_run_index = m) : (w++, v.chunk_index = w, P = 0, w <= b || (m++, m + 1 < s.first_chunk.length ? b = s.first_chunk[m + 1] - 1 : b = 1 / 0), v.chunk_run_index = m, L += s.samples_per_chunk[m]), v.description_index = s.sample_description_index[v.chunk_run_index] - 1, v.description = p.entries[v.description_index], v.offset = r.chunk_offsets[v.chunk_index - 1] + P, P += v.size, e > z && (C++, z < 0 && (z = 0), z += a.sample_counts[C]), e > 0 ? (t.samples[e - 1].duration = a.sample_deltas[C], t.samples_duration += t.samples[e - 1].duration, v.dts = t.samples[e - 1].dts + t.samples[e - 1].duration) : v.dts = 0, h ? (e >= I && (D++, I < 0 && (I = 0), I += h.sample_counts[D]), v.cts = t.samples[e].dts + h.sample_offsets[D]) : v.cts = v.dts, d ? (e == d.sample_numbers[N] - 1 ? (v.is_sync = !0, N++) : (v.is_sync = !1, v.degradation_priority = 0), u && u.entries[F].sample_delta + k == e + 1 && (v.subsamples = u.entries[F].subsamples, k += u.entries[F].sample_delta, F++)) : v.is_sync = !0, _.process_sdtp(t.mdia.minf.stbl.sdtp, v, v.number), x ? v.degradation_priority = x.priority[e] : v.degradation_priority = 0, u && u.entries[F].sample_delta + k == e && (v.subsamples = u.entries[F].subsamples, k += u.entries[F].sample_delta), (c.length > 0 || y.length > 0) && _.setSampleGroupProperties(t, v, e, t.sample_groups_info);
      }
      e > 0 && (t.samples[e - 1].duration = Math.max(t.mdia.mdhd.duration - t.samples[e - 1].dts, 0), t.samples_duration += t.samples[e - 1].duration);
    }
  }, _.prototype.updateSampleLists = function() {
    var t, e, r, s, o, a, h, d, p, u, c, y, x, m, w;
    if (this.moov !== void 0) {
      for (; this.lastMoofIndex < this.moofs.length; )
        if (p = this.moofs[this.lastMoofIndex], this.lastMoofIndex++, p.type == "moof")
          for (u = p, t = 0; t < u.trafs.length; t++) {
            for (c = u.trafs[t], y = this.getTrackById(c.tfhd.track_id), x = this.getTrexById(c.tfhd.track_id), c.tfhd.flags & n.TFHD_FLAG_SAMPLE_DESC ? s = c.tfhd.default_sample_description_index : s = x ? x.default_sample_description_index : 1, c.tfhd.flags & n.TFHD_FLAG_SAMPLE_DUR ? o = c.tfhd.default_sample_duration : o = x ? x.default_sample_duration : 0, c.tfhd.flags & n.TFHD_FLAG_SAMPLE_SIZE ? a = c.tfhd.default_sample_size : a = x ? x.default_sample_size : 0, c.tfhd.flags & n.TFHD_FLAG_SAMPLE_FLAGS ? h = c.tfhd.default_sample_flags : h = x ? x.default_sample_flags : 0, c.sample_number = 0, c.sbgps.length > 0 && _.initSampleGroups(y, c, c.sbgps, y.mdia.minf.stbl.sgpds, c.sgpds), e = 0; e < c.truns.length; e++) {
              var b = c.truns[e];
              for (r = 0; r < b.sample_count; r++) {
                m = {}, m.moof_number = this.lastMoofIndex, m.number_in_traf = c.sample_number, c.sample_number++, m.number = y.samples.length, c.first_sample_index = y.samples.length, y.samples.push(m), m.track_id = y.tkhd.track_id, m.timescale = y.mdia.mdhd.timescale, m.description_index = s - 1, m.description = y.mdia.minf.stbl.stsd.entries[m.description_index], m.size = a, b.flags & n.TRUN_FLAGS_SIZE && (m.size = b.sample_size[r]), y.samples_size += m.size, m.duration = o, b.flags & n.TRUN_FLAGS_DURATION && (m.duration = b.sample_duration[r]), y.samples_duration += m.duration, y.first_traf_merged || r > 0 ? m.dts = y.samples[y.samples.length - 2].dts + y.samples[y.samples.length - 2].duration : (c.tfdt ? m.dts = c.tfdt.baseMediaDecodeTime : m.dts = 0, y.first_traf_merged = !0), m.cts = m.dts, b.flags & n.TRUN_FLAGS_CTS_OFFSET && (m.cts = m.dts + b.sample_composition_time_offset[r]), w = h, b.flags & n.TRUN_FLAGS_FLAGS ? w = b.sample_flags[r] : r === 0 && b.flags & n.TRUN_FLAGS_FIRST_FLAG && (w = b.first_sample_flags), m.is_sync = !(w >> 16 & 1), m.is_leading = w >> 26 & 3, m.depends_on = w >> 24 & 3, m.is_depended_on = w >> 22 & 3, m.has_redundancy = w >> 20 & 3, m.degradation_priority = w & 65535;
                var P = !!(c.tfhd.flags & n.TFHD_FLAG_BASE_DATA_OFFSET), L = !!(c.tfhd.flags & n.TFHD_FLAG_DEFAULT_BASE_IS_MOOF), z = !!(b.flags & n.TRUN_FLAGS_DATA_OFFSET), C = 0;
                P ? C = c.tfhd.base_data_offset : L || e === 0 ? C = u.start : C = d, e === 0 && r === 0 ? z ? m.offset = C + b.data_offset : m.offset = C : m.offset = d, d = m.offset + m.size, (c.sbgps.length > 0 || c.sgpds.length > 0 || y.mdia.minf.stbl.sbgps.length > 0 || y.mdia.minf.stbl.sgpds.length > 0) && _.setSampleGroupProperties(y, m, m.number_in_traf, c.sample_groups_info);
              }
            }
            if (c.subs) {
              y.has_fragment_subsamples = !0;
              var I = c.first_sample_index;
              for (e = 0; e < c.subs.entries.length; e++)
                I += c.subs.entries[e].sample_delta, m = y.samples[I - 1], m.subsamples = c.subs.entries[e].subsamples;
            }
          }
    }
  }, _.prototype.getSample = function(t, e) {
    var r, s = t.samples[e];
    if (!this.moov)
      return null;
    if (!s.data)
      s.data = new Uint8Array(s.size), s.alreadyRead = 0, this.samplesDataSize += s.size, f.debug("ISOFile", "Allocating sample #" + e + " on track #" + t.tkhd.track_id + " of size " + s.size + " (total: " + this.samplesDataSize + ")");
    else if (s.alreadyRead == s.size)
      return s;
    for (; ; ) {
      var o = this.stream.findPosition(!0, s.offset + s.alreadyRead, !1);
      if (o > -1) {
        r = this.stream.buffers[o];
        var a = r.byteLength - (s.offset + s.alreadyRead - r.fileStart);
        if (s.size - s.alreadyRead <= a)
          return f.debug("ISOFile", "Getting sample #" + e + " data (alreadyRead: " + s.alreadyRead + " offset: " + (s.offset + s.alreadyRead - r.fileStart) + " read size: " + (s.size - s.alreadyRead) + " full size: " + s.size + ")"), l.memcpy(
            s.data.buffer,
            s.alreadyRead,
            r,
            s.offset + s.alreadyRead - r.fileStart,
            s.size - s.alreadyRead
          ), r.usedBytes += s.size - s.alreadyRead, this.stream.logBufferLevel(), s.alreadyRead = s.size, s;
        if (a === 0) return null;
        f.debug("ISOFile", "Getting sample #" + e + " partial data (alreadyRead: " + s.alreadyRead + " offset: " + (s.offset + s.alreadyRead - r.fileStart) + " read size: " + a + " full size: " + s.size + ")"), l.memcpy(
          s.data.buffer,
          s.alreadyRead,
          r,
          s.offset + s.alreadyRead - r.fileStart,
          a
        ), s.alreadyRead += a, r.usedBytes += a, this.stream.logBufferLevel();
      } else
        return null;
    }
  }, _.prototype.releaseSample = function(t, e) {
    var r = t.samples[e];
    return r.data ? (this.samplesDataSize -= r.size, r.data = null, r.alreadyRead = 0, r.size) : 0;
  }, _.prototype.getAllocatedSampleDataSize = function() {
    return this.samplesDataSize;
  }, _.prototype.getCodecs = function() {
    var t, e = "";
    for (t = 0; t < this.moov.traks.length; t++) {
      var r = this.moov.traks[t];
      t > 0 && (e += ","), e += r.mdia.minf.stbl.stsd.entries[0].getCodec();
    }
    return e;
  }, _.prototype.getTrexById = function(t) {
    var e;
    if (!this.moov || !this.moov.mvex) return null;
    for (e = 0; e < this.moov.mvex.trexs.length; e++) {
      var r = this.moov.mvex.trexs[e];
      if (r.track_id == t) return r;
    }
    return null;
  }, _.prototype.getTrackById = function(t) {
    if (this.moov === void 0)
      return null;
    for (var e = 0; e < this.moov.traks.length; e++) {
      var r = this.moov.traks[e];
      if (r.tkhd.track_id == t) return r;
    }
    return null;
  }, _.prototype.itemsDataSize = 0, _.prototype.flattenItemInfo = function() {
    var t = this.items, e = this.entity_groups, r, s, o, a = this.meta;
    if (a != null && a.hdlr !== void 0 && a.iinf !== void 0) {
      for (r = 0; r < a.iinf.item_infos.length; r++)
        o = {}, o.id = a.iinf.item_infos[r].item_ID, t[o.id] = o, o.ref_to = [], o.name = a.iinf.item_infos[r].item_name, a.iinf.item_infos[r].protection_index > 0 && (o.protection = a.ipro.protections[a.iinf.item_infos[r].protection_index - 1]), a.iinf.item_infos[r].item_type ? o.type = a.iinf.item_infos[r].item_type : o.type = "mime", o.content_type = a.iinf.item_infos[r].content_type, o.content_encoding = a.iinf.item_infos[r].content_encoding, o.item_uri_type = a.iinf.item_infos[r].item_uri_type;
      if (a.grpl)
        for (r = 0; r < a.grpl.boxes.length; r++)
          entity_group = {}, entity_group.id = a.grpl.boxes[r].group_id, entity_group.entity_ids = a.grpl.boxes[r].entity_ids, entity_group.type = a.grpl.boxes[r].type, e[entity_group.id] = entity_group;
      if (a.iloc)
        for (r = 0; r < a.iloc.items.length; r++) {
          var h = a.iloc.items[r];
          switch (o = t[h.item_ID], h.data_reference_index !== 0 && (f.warn("Item storage with reference to other files: not supported"), o.source = a.dinf.boxes[h.data_reference_index - 1]), h.construction_method) {
            case 0:
              break;
            case 1:
              break;
            case 2:
              f.warn("Item storage with construction_method : not supported");
              break;
          }
          for (o.extents = [], o.size = 0, s = 0; s < h.extents.length; s++)
            o.extents[s] = {}, o.extents[s].offset = h.extents[s].extent_offset + h.base_offset, h.construction_method == 1 && (o.extents[s].offset += a.idat.start + a.idat.hdr_size), o.extents[s].length = h.extents[s].extent_length, o.extents[s].alreadyRead = 0, o.size += o.extents[s].length;
        }
      if (a.pitm && (t[a.pitm.item_id].primary = !0), a.iref)
        for (r = 0; r < a.iref.references.length; r++) {
          var d = a.iref.references[r];
          for (s = 0; s < d.references.length; s++)
            t[d.from_item_ID].ref_to.push({ type: d.type, id: d.references[s] });
        }
      if (a.iprp)
        for (var p = 0; p < a.iprp.ipmas.length; p++) {
          var u = a.iprp.ipmas[p];
          for (r = 0; r < u.associations.length; r++) {
            var c = u.associations[r];
            if (o = t[c.id], o || (o = e[c.id]), o)
              for (o.properties === void 0 && (o.properties = {}, o.properties.boxes = []), s = 0; s < c.props.length; s++) {
                var y = c.props[s];
                if (y.property_index > 0 && y.property_index - 1 < a.iprp.ipco.boxes.length) {
                  var x = a.iprp.ipco.boxes[y.property_index - 1];
                  o.properties[x.type] = x, o.properties.boxes.push(x);
                }
              }
          }
        }
    }
  }, _.prototype.getItem = function(t) {
    var e, r;
    if (!this.meta)
      return null;
    if (r = this.items[t], !r.data && r.size)
      r.data = new Uint8Array(r.size), r.alreadyRead = 0, this.itemsDataSize += r.size, f.debug("ISOFile", "Allocating item #" + t + " of size " + r.size + " (total: " + this.itemsDataSize + ")");
    else if (r.alreadyRead === r.size)
      return r;
    for (var s = 0; s < r.extents.length; s++) {
      var o = r.extents[s];
      if (o.alreadyRead !== o.length) {
        var a = this.stream.findPosition(!0, o.offset + o.alreadyRead, !1);
        if (a > -1) {
          e = this.stream.buffers[a];
          var h = e.byteLength - (o.offset + o.alreadyRead - e.fileStart);
          if (o.length - o.alreadyRead <= h)
            f.debug("ISOFile", "Getting item #" + t + " extent #" + s + " data (alreadyRead: " + o.alreadyRead + " offset: " + (o.offset + o.alreadyRead - e.fileStart) + " read size: " + (o.length - o.alreadyRead) + " full extent size: " + o.length + " full item size: " + r.size + ")"), l.memcpy(
              r.data.buffer,
              r.alreadyRead,
              e,
              o.offset + o.alreadyRead - e.fileStart,
              o.length - o.alreadyRead
            ), e.usedBytes += o.length - o.alreadyRead, this.stream.logBufferLevel(), r.alreadyRead += o.length - o.alreadyRead, o.alreadyRead = o.length;
          else
            return f.debug("ISOFile", "Getting item #" + t + " extent #" + s + " partial data (alreadyRead: " + o.alreadyRead + " offset: " + (o.offset + o.alreadyRead - e.fileStart) + " read size: " + h + " full extent size: " + o.length + " full item size: " + r.size + ")"), l.memcpy(
              r.data.buffer,
              r.alreadyRead,
              e,
              o.offset + o.alreadyRead - e.fileStart,
              h
            ), o.alreadyRead += h, r.alreadyRead += h, e.usedBytes += h, this.stream.logBufferLevel(), null;
        } else
          return null;
      }
    }
    return r.alreadyRead === r.size ? r : null;
  }, _.prototype.releaseItem = function(t) {
    var e = this.items[t];
    if (e.data) {
      this.itemsDataSize -= e.size, e.data = null, e.alreadyRead = 0;
      for (var r = 0; r < e.extents.length; r++) {
        var s = e.extents[r];
        s.alreadyRead = 0;
      }
      return e.size;
    } else
      return 0;
  }, _.prototype.processItems = function(t) {
    for (var e in this.items) {
      var r = this.items[e];
      this.getItem(r.id), t && !r.sent && (t(r), r.sent = !0, r.data = null);
    }
  }, _.prototype.hasItem = function(t) {
    for (var e in this.items) {
      var r = this.items[e];
      if (r.name === t)
        return r.id;
    }
    return -1;
  }, _.prototype.getMetaHandler = function() {
    return this.meta ? this.meta.hdlr.handler : null;
  }, _.prototype.getPrimaryItem = function() {
    return !this.meta || !this.meta.pitm ? null : this.getItem(this.meta.pitm.item_id);
  }, _.prototype.itemToFragmentedTrackFile = function(t) {
    var e = t || {}, r = null;
    if (e.itemId ? r = this.getItem(e.itemId) : r = this.getPrimaryItem(), r == null) return null;
    var s = new _();
    s.discardMdatData = !1;
    var o = { type: r.type, description_boxes: r.properties.boxes };
    r.properties.ispe && (o.width = r.properties.ispe.image_width, o.height = r.properties.ispe.image_height);
    var a = s.addTrack(o);
    return a ? (s.addSample(a, r.data), s) : null;
  }, _.prototype.write = function(t) {
    for (var e = 0; e < this.boxes.length; e++)
      this.boxes[e].write(t);
  }, _.prototype.createFragment = function(t, e, r) {
    var s = this.getTrackById(t), o = this.getSample(s, e);
    if (o == null)
      return this.setNextSeekPositionFromSample(s.samples[e]), null;
    var a = r || new l();
    a.endianness = l.BIG_ENDIAN;
    var h = this.createSingleSampleMoof(o);
    h.write(a), h.trafs[0].truns[0].data_offset = h.size + 8, f.debug("MP4Box", "Adjusting data_offset with new value " + h.trafs[0].truns[0].data_offset), a.adjustUint32(h.trafs[0].truns[0].data_offset_position, h.trafs[0].truns[0].data_offset);
    var d = new n.mdatBox();
    return d.data = o.data, d.write(a), a;
  }, _.writeInitializationSegment = function(t, e, r, s) {
    var o;
    f.debug("ISOFile", "Generating initialization segment");
    var a = new l();
    a.endianness = l.BIG_ENDIAN, t.write(a);
    var h = e.add("mvex");
    for (r && h.add("mehd").set("fragment_duration", r), o = 0; o < e.traks.length; o++)
      h.add("trex").set("track_id", e.traks[o].tkhd.track_id).set("default_sample_description_index", 1).set("default_sample_duration", s).set("default_sample_size", 0).set("default_sample_flags", 65536);
    return e.write(a), a.buffer;
  }, _.prototype.save = function(t) {
    var e = new l();
    e.endianness = l.BIG_ENDIAN, this.write(e), e.save(t);
  }, _.prototype.getBuffer = function() {
    var t = new l();
    return t.endianness = l.BIG_ENDIAN, this.write(t), t.buffer;
  }, _.prototype.initializeSegmentation = function() {
    var t, e, r, s;
    for (this.onSegment === null && f.warn("MP4Box", "No segmentation callback set!"), this.isFragmentationInitialized || (this.isFragmentationInitialized = !0, this.nextMoofNumber = 0, this.resetTables()), e = [], t = 0; t < this.fragmentedTracks.length; t++) {
      var o = new n.moovBox();
      o.mvhd = this.moov.mvhd, o.boxes.push(o.mvhd), r = this.getTrackById(this.fragmentedTracks[t].id), o.boxes.push(r), o.traks.push(r), s = {}, s.id = r.tkhd.track_id, s.user = this.fragmentedTracks[t].user, s.buffer = _.writeInitializationSegment(this.ftyp, o, this.moov.mvex && this.moov.mvex.mehd ? this.moov.mvex.mehd.fragment_duration : void 0, this.moov.traks[t].samples.length > 0 ? this.moov.traks[t].samples[0].duration : 0), e.push(s);
    }
    return e;
  }, n.Box.prototype.printHeader = function(t) {
    this.size += 8, this.size > B && (this.size += 8), this.type === "uuid" && (this.size += 16), t.log(t.indent + "size:" + this.size), t.log(t.indent + "type:" + this.type);
  }, n.FullBox.prototype.printHeader = function(t) {
    this.size += 4, n.Box.prototype.printHeader.call(this, t), t.log(t.indent + "version:" + this.version), t.log(t.indent + "flags:" + this.flags);
  }, n.Box.prototype.print = function(t) {
    this.printHeader(t);
  }, n.ContainerBox.prototype.print = function(t) {
    this.printHeader(t);
    for (var e = 0; e < this.boxes.length; e++)
      if (this.boxes[e]) {
        var r = t.indent;
        t.indent += " ", this.boxes[e].print(t), t.indent = r;
      }
  }, _.prototype.print = function(t) {
    t.indent = "";
    for (var e = 0; e < this.boxes.length; e++)
      this.boxes[e] && this.boxes[e].print(t);
  }, n.mvhdBox.prototype.print = function(t) {
    n.FullBox.prototype.printHeader.call(this, t), t.log(t.indent + "creation_time: " + this.creation_time), t.log(t.indent + "modification_time: " + this.modification_time), t.log(t.indent + "timescale: " + this.timescale), t.log(t.indent + "duration: " + this.duration), t.log(t.indent + "rate: " + this.rate), t.log(t.indent + "volume: " + (this.volume >> 8)), t.log(t.indent + "matrix: " + this.matrix.join(", ")), t.log(t.indent + "next_track_id: " + this.next_track_id);
  }, n.tkhdBox.prototype.print = function(t) {
    n.FullBox.prototype.printHeader.call(this, t), t.log(t.indent + "creation_time: " + this.creation_time), t.log(t.indent + "modification_time: " + this.modification_time), t.log(t.indent + "track_id: " + this.track_id), t.log(t.indent + "duration: " + this.duration), t.log(t.indent + "volume: " + (this.volume >> 8)), t.log(t.indent + "matrix: " + this.matrix.join(", ")), t.log(t.indent + "layer: " + this.layer), t.log(t.indent + "alternate_group: " + this.alternate_group), t.log(t.indent + "width: " + this.width), t.log(t.indent + "height: " + this.height);
  };
  var Y = {};
  Y.createFile = function(t, e) {
    var r = t !== void 0 ? t : !0, s = new _(e);
    return s.discardMdatData = !r, s;
  }, U.createFile = Y.createFile;
})(j);
const O = /* @__PURE__ */ K(j);
class q {
  constructor(f, g) {
    this.onConfigReady = f, this.onChunk = g, this.file = O.createFile(), this.offset = 0, this.trackId = null, this.file.onError = (l) => console.error("[rtsp-player] mp4box error:", l), this.file.onReady = (l) => this.handleReady(l), this.file.onSamples = (l, B, S) => this.handleSamples(S);
  }
  appendBuffer(f) {
    const g = f.buffer.slice(f.byteOffset, f.byteOffset + f.byteLength);
    g.fileStart = this.offset, this.offset += g.byteLength, this.file.appendBuffer(g);
  }
  flush() {
    this.file.flush();
  }
  handleReady(f) {
    var n;
    const g = (n = f.videoTracks) == null ? void 0 : n[0];
    if (!g) {
      console.error("[rtsp-player] no video track in stream");
      return;
    }
    this.trackId = g.id;
    const B = this.file.getTrackById(g.id).mdia.minf.stbl.stsd.entries[0], S = B.avcC ?? B.hvcC;
    let E;
    if (S) {
      const A = new O.DataStream(void 0, 0, O.DataStream.BIG_ENDIAN);
      S.write(A), E = new Uint8Array(A.buffer, 8);
    }
    this.onConfigReady({
      codec: g.codec,
      codedWidth: g.video.width,
      codedHeight: g.video.height,
      description: E
    }), this.file.setExtractionOptions(g.id, void 0, { nbSamples: 1 }), this.file.start();
  }
  handleSamples(f) {
    for (const g of f) {
      const l = new EncodedVideoChunk({
        type: g.is_sync ? "key" : "delta",
        timestamp: g.cts * 1e6 / g.timescale,
        duration: g.duration * 1e6 / g.timescale,
        data: g.data
      });
      this.onChunk(l);
    }
  }
}
class V {
  constructor(f) {
    this.ws = null, this.decoder = null, this.demuxer = null, this.canvas = f.canvas;
    const g = this.canvas.getContext("2d");
    if (!g) throw new Error("rtsp-player: 2D canvas context unavailable");
    this.ctx = g, this.onStatus = f.onStatus ?? (() => {
    }), this.connect(f.bridgeUrl, f.src, f.transport ?? "tcp", f.token);
  }
  static isSupported() {
    return typeof VideoDecoder < "u" && typeof WebSocket < "u";
  }
  connect(f, g, l, B) {
    this.onStatus("connecting"), this.demuxer = new q(
      (n) => this.configureDecoder(n),
      (n) => this.decodeChunk(n)
    );
    const S = new URL(f);
    S.searchParams.set("url", g), S.searchParams.set("transport", l), B && S.searchParams.set("token", B);
    const E = new WebSocket(S);
    E.binaryType = "arraybuffer", this.ws = E, E.onmessage = (n) => {
      var A;
      if (typeof n.data == "string") {
        try {
          const T = JSON.parse(n.data);
          T.type === "error" && this.onStatus("error", T.message);
        } catch {
        }
        return;
      }
      (A = this.demuxer) == null || A.appendBuffer(new Uint8Array(n.data));
    }, E.onerror = () => this.onStatus("error", "websocket error"), E.onclose = (n) => {
      var A;
      (A = this.demuxer) == null || A.flush(), n.code === 1e3 ? this.onStatus("closed") : this.onStatus("error", `connection closed (${n.code}) ${n.reason}`.trim());
    };
  }
  configureDecoder(f) {
    this.canvas.width = f.codedWidth, this.canvas.height = f.codedHeight, this.decoder = new VideoDecoder({
      output: (g) => this.renderFrame(g),
      error: (g) => this.onStatus("error", g.message)
    }), this.decoder.configure({
      codec: f.codec,
      codedWidth: f.codedWidth,
      codedHeight: f.codedHeight,
      description: f.description,
      hardwareAcceleration: "prefer-hardware",
      optimizeForLatency: !0
    }), this.onStatus("playing");
  }
  decodeChunk(f) {
    !this.decoder || this.decoder.state !== "configured" || this.decoder.decode(f);
  }
  renderFrame(f) {
    this.ctx.drawImage(f, 0, 0, this.canvas.width, this.canvas.height), f.close();
  }
  /** Tears down the socket and decoder. Safe to call multiple times. */
  destroy() {
    this.ws && (this.ws.onopen = null, this.ws.onmessage = null, this.ws.onerror = null, this.ws.onclose = null, this.ws.close(1e3, "client disconnect"), this.ws = null), this.decoder && this.decoder.state !== "closed" && this.decoder.close(), this.decoder = null, this.demuxer = null;
  }
}
class X extends HTMLElement {
  constructor() {
    super(), this.player = null, this.connected = !1;
    const f = this.attachShadow({ mode: "open" }), g = document.createElement("style");
    g.textContent = `
      :host { display: inline-block; line-height: 0; }
      canvas { width: 100%; height: 100%; background: #000; }
    `, this.canvas = document.createElement("canvas"), f.append(g, this.canvas);
  }
  static get observedAttributes() {
    return ["bridge-url", "src", "transport", "token"];
  }
  connectedCallback() {
    this.connected = !0, this.start();
  }
  disconnectedCallback() {
    var f;
    this.connected = !1, (f = this.player) == null || f.destroy(), this.player = null;
  }
  attributeChangedCallback() {
    this.connected && this.start();
  }
  start() {
    var S;
    (S = this.player) == null || S.destroy(), this.player = null;
    const f = this.getAttribute("bridge-url"), g = this.getAttribute("src");
    if (!f || !g) return;
    const l = this.getAttribute("transport") ?? "tcp", B = this.getAttribute("token") ?? void 0;
    if (!V.isSupported()) {
      this.emitStatus("error", "WebCodecs is not supported in this browser");
      return;
    }
    this.player = new V({
      canvas: this.canvas,
      bridgeUrl: f,
      src: g,
      transport: l,
      token: B,
      onStatus: (E, n) => this.emitStatus(E, n)
    });
  }
  emitStatus(f, g) {
    this.dispatchEvent(new CustomEvent("status", { detail: { status: f, message: g } }));
  }
}
function W(U = "rtsp-player") {
  customElements.get(U) || customElements.define(U, X);
}
W();
export {
  X as RtspPlayerElement,
  V as RtspWebCodecsPlayer,
  W as defineRtspPlayerElement
};
//# sourceMappingURL=rtsp-player.js.map
